/**
 * A function to create a log object for the 'errorEventSrc12Evid10' event (evid: 10)
 *
 * Event description: error event.
 *
 * @param {errorEventSrc12Evid10Params} params - The parameters for this event
 * @property {string} dsc - dsc
 * @property {number} response_time - Time in ms from load to error
 * @property {string} vsi - vsi
 * @property {boolean} is_rollout - is_rollout
 * @property {string} initiator_name - initiator_name
 * @property {string} builderType - builder_type
 * @property {string} errscp - error scope
 * @property {GUID} site_id - changed from did -> site_id on Oct 03, 2013
 * @property {string} errn - error name
 * @property {string} p4 - 4st extra parameter
 * @property {string} majorver - the major version of html editor
 * @property {string} trgt - target name, api call or class
 * @property {boolean} isLiveEditor - is_live_editor
 * @property {number} ts - Time in ms from load to error
 * @property {string} playerVersion - player_version
 * @property {string} artifactVersion - artifact_version
 * @property {GUID} visitor_id - visitor_id
 * @property {number} usersOnPageCount - users_on_page_count
 * @property {string} viewmode - viewmode
 * @property {string} error_description_short - error_description_short
 * @property {string} data_center - data_center
 * @property {string} screenResolution - screen_resolution
 * @property {string} p3 - 3rd extra parameter
 * @property {GUID} did - changed from did -> site_id on Oct 03, 2013
 * @property {boolean} isSg - is_sg
 * @property {string} dsOrigin - ds_origin
 * @property {string} p2 - 2nd extra parameter
 * @property {string} token - token
 * @property {string} sessionId - session_id
 * @property {number} errc - error code
 * @property {string} stack - stacktrace
 * @property {string} viewerName - viewer_name
 * @property {string} app_id - app_id
 * @property {number} sev - severity of the error
 * @property {number} cat - category id
 * @property {string} errormsg - dsc
 * @property {number} usersOnSiteCount - users_on_site_count
 * @property {string} p1 - 1st extra parameter
 * @property {GUID} msid - msid
 * @property {number} base_version - base_version
 * @property {number} iss - issue (sub-category)
 * @return {LogObject<errorEventSrc12Evid10Params>} LogObject<errorEventSrc12Evid10Params>
 */
export function errorEventSrc12Evid10(params) {
    return { evid: 10, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dragCategory' event (evid: 100)
 *
 * Event description: drag_category
 *
 * @param {dragCategoryParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} category_state - father,son
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<dragCategoryParams>} LogObject<dragCategoryParams>
 */
export function dragCategory(params) {
    return { evid: 100, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'categoryNumberPostsClick' event (evid: 101)
 *
 * Event description: category_number_posts_click
 *
 * @param {categoryNumberPostsClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<categoryNumberPostsClickParams>} LogObject<categoryNumberPostsClickParams>
 */
export function categoryNumberPostsClick(params) {
    return { evid: 101, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'categoryTagSwitchPostEditor' event (evid: 103)
 *
 * Event description: category_tag_switch_post_editor
 *
 * @param {categoryTagSwitchPostEditorParams} params - The parameters for this event
 * @property {string} state - category,tag
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<categoryTagSwitchPostEditorParams>} LogObject<categoryTagSwitchPostEditorParams>
 */
export function categoryTagSwitchPostEditor(params) {
    return { evid: 103, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'categorySelected' event (evid: 104)
 *
 * Event description: category_apply_select
 *
 * @param {categorySelectedParams} params - The parameters for this event
 * @property {string} state - father, son
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - multi_select,post_editor
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<categorySelectedParams>} LogObject<categorySelectedParams>
 */
export function categorySelected(params) {
    return { evid: 104, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dividerAdded' event (evid: 105)
 *
 * Event description: divider_added
 *
 * @param {dividerAddedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<dividerAddedParams>} LogObject<dividerAddedParams>
 */
export function dividerAdded(params) {
    return { evid: 105, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dividerTooltipClick' event (evid: 106)
 *
 * Event description: divider_tooltip_click
 *
 * @param {dividerTooltipClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} category - width,color,style,height,delete
 * @property {GUID} msid - msid
 * @return {LogObject<dividerTooltipClickParams>} LogObject<dividerTooltipClickParams>
 */
export function dividerTooltipClick(params) {
    return { evid: 106, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'htmlAdded' event (evid: 107)
 *
 * Event description: html_added
 *
 * @param {htmlAddedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<htmlAddedParams>} LogObject<htmlAddedParams>
 */
export function htmlAdded(params) {
    return { evid: 107, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'htmlCodeBoxResizedClicked' event (evid: 109)
 *
 * Event description: html_code_box_resized_clicked
 *
 * @param {htmlCodeBoxResizedClickedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} mode - increase,decrease
 * @property {GUID} msid - msid
 * @return {LogObject<htmlCodeBoxResizedClickedParams>} LogObject<htmlCodeBoxResizedClickedParams>
 */
export function htmlCodeBoxResizedClicked(params) {
    return { evid: 109, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'filterByTag' event (evid: 11)
 *
 * Event description: filter_by_tag.
 *
 * @param {filterByTagParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<filterByTagParams>} LogObject<filterByTagParams>
 */
export function filterByTag(params) {
    return { evid: 11, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'htmlUpdateClicked' event (evid: 110)
 *
 * Event description: html_update_clicked
 *
 * @param {htmlUpdateClickedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {boolean} paste_ind - 1,0
 * @property {GUID} msid - msid
 * @return {LogObject<htmlUpdateClickedParams>} LogObject<htmlUpdateClickedParams>
 */
export function htmlUpdateClicked(params) {
    return { evid: 110, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'htmlCancelClicked' event (evid: 111)
 *
 * Event description: html_cancel_clicked
 *
 * @param {htmlCancelClickedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<htmlCancelClickedParams>} LogObject<htmlCancelClickedParams>
 */
export function htmlCancelClicked(params) {
    return { evid: 111, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'htmlToolBarClicked' event (evid: 112)
 *
 * Event description: html_tool_bar_clicked
 *
 * @param {htmlToolBarClickedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @property {string} action - delete,align left, align right, align center
 * @return {LogObject<htmlToolBarClickedParams>} LogObject<htmlToolBarClickedParams>
 */
export function htmlToolBarClicked(params) {
    return { evid: 112, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'htmlResizeClicked' event (evid: 113)
 *
 * Event description: html_resize_clicked
 *
 * @param {htmlResizeClickedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<htmlResizeClickedParams>} LogObject<htmlResizeClickedParams>
 */
export function htmlResizeClicked(params) {
    return { evid: 113, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'firstTimeGifPopup' event (evid: 115)
 *
 * Event description: First time users will see a popup video about categories and posts
 *
 * @param {firstTimeGifPopupParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} category - {add_edit_post,add_category }
 * @property {GUID} msid - msid
 * @return {LogObject<firstTimeGifPopupParams>} LogObject<firstTimeGifPopupParams>
 */
export function firstTimeGifPopup(params) {
    return { evid: 115, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'firstTimeGifClick' event (evid: 116)
 *
 * Event description: First time users will see a popup video about categories and posts here we can see what users are doing in this window
 *
 * @param {firstTimeGifClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} button_name - {close_page, next_arrow, prev_arrow, bottom_nav}
 * @property {string} user_agent - user_agent
 * @property {string} category - {add_edit_post,add_category }
 * @property {GUID} msid - msid
 * @property {number} page_number - 1,2,3
 * @return {LogObject<firstTimeGifClickParams>} LogObject<firstTimeGifClickParams>
 */
export function firstTimeGifClick(params) {
    return { evid: 116, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'videoSearch' event (evid: 117)
 *
 * Event description: Click on search in post editor after adding a video
 *
 * @param {videoSearchParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<videoSearchParams>} LogObject<videoSearchParams>
 */
export function videoSearch(params) {
    return { evid: 117, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchButton' event (evid: 118)
 *
 * Event description: search video in youtube or vimeo
 *
 * @param {searchButtonParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} search_term - what user searched for
 * @property {string} source_name - youtube/vimeo
 * @property {GUID} msid - msid
 * @return {LogObject<searchButtonParams>} LogObject<searchButtonParams>
 */
export function searchButton(params) {
    return { evid: 118, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addVideoFromSearch' event (evid: 119)
 *
 * Event description: adding video to blog
 *
 * @param {addVideoFromSearchParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} file_name - name of the video
 * @property {string} user_agent - user_agent
 * @property {string} source_name - youtube/vimeo
 * @property {GUID} msid - msid
 * @return {LogObject<addVideoFromSearchParams>} LogObject<addVideoFromSearchParams>
 */
export function addVideoFromSearch(params) {
    return { evid: 119, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editPost' event (evid: 12)
 *
 * Event description: edit_post.
 *
 * @param {editPostParams} params - The parameters for this event
 * @property {boolean} isDesktopPost - True if this was created on desktop but edited on OneApp
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {boolean} is_desktop_post - True if this was created on desktop but edited on OneApp
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<editPostParams>} LogObject<editPostParams>
 */
export function editPost(params) {
    return { evid: 12, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'videoPreview' event (evid: 120)
 *
 * Event description: preview video after search and before adding it to the blog
 *
 * @param {videoPreviewParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} source_name - youtube/vimeo
 * @property {GUID} msid - msid
 * @return {LogObject<videoPreviewParams>} LogObject<videoPreviewParams>
 */
export function videoPreview(params) {
    return { evid: 120, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'closeVideoSearch' event (evid: 121)
 *
 * Event description: closing without adding a video
 *
 * @param {closeVideoSearchParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} button_name - close , X at the top of the screen
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<closeVideoSearchParams>} LogObject<closeVideoSearchParams>
 */
export function closeVideoSearch(params) {
    return { evid: 121, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'categoryApplyButtonPressed' event (evid: 122)
 *
 * Event description: category_apply_button_pressed
 *
 * @param {categoryApplyButtonPressedParams} params - The parameters for this event
 * @property {string} state - father, son
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - multi_select,post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<categoryApplyButtonPressedParams>} LogObject<categoryApplyButtonPressedParams>
 */
export function categoryApplyButtonPressed(params) {
    return { evid: 122, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mobileMiniView' event (evid: 123)
 *
 * Event description: mobile app first edit button
 *
 * @param {mobileMiniViewParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<mobileMiniViewParams>} LogObject<mobileMiniViewParams>
 */
export function mobileMiniView(params) {
    return { evid: 123, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'giphySearch' event (evid: 125)
 *
 * Event description: Click on search in post editor after adding a video
 *
 * @param {giphySearchParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<giphySearchParams>} LogObject<giphySearchParams>
 */
export function giphySearch(params) {
    return { evid: 125, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addGiphyFromSearch' event (evid: 126)
 *
 * Event description: adding video to blog
 *
 * @param {addGiphyFromSearchParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} file_name - name of the video
 * @property {string} user_agent - user_agent
 * @property {string} source_name - giphy
 * @property {GUID} msid - msid
 * @return {LogObject<addGiphyFromSearchParams>} LogObject<addGiphyFromSearchParams>
 */
export function addGiphyFromSearch(params) {
    return { evid: 126, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'giphyPreview' event (evid: 127)
 *
 * Event description: preview video after search and before adding it to the blog
 *
 * @param {giphyPreviewParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} source_name - giphy
 * @property {GUID} msid - msid
 * @return {LogObject<giphyPreviewParams>} LogObject<giphyPreviewParams>
 */
export function giphyPreview(params) {
    return { evid: 127, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'closeGiphySearch' event (evid: 128)
 *
 * Event description: closing without adding a video
 *
 * @param {closeGiphySearchParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} button_name - close , X at the top of the screen
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<closeGiphySearchParams>} LogObject<closeGiphySearchParams>
 */
export function closeGiphySearch(params) {
    return { evid: 128, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'previewPost' event (evid: 13)
 *
 * Event description: preview post.
 *
 * @param {previewPostParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<previewPostParams>} LogObject<previewPostParams>
 */
export function previewPost(params) {
    return { evid: 13, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnAdvancedSeo' event (evid: 130)
 *
 * Event description: click on advanced seo
 *
 * @param {clickOnAdvancedSeoParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<clickOnAdvancedSeoParams>} LogObject<clickOnAdvancedSeoParams>
 */
export function clickOnAdvancedSeo(params) {
    return { evid: 130, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'advancedSeoClickOnDone' event (evid: 131)
 *
 * Event description: advanced seo click on done
 *
 * @param {advancedSeoClickOnDoneParams} params - The parameters for this event
 * @property {boolean} meta_description_changed - 1 = yes, 0 = no
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {boolean} permalink_changed - 1 = yes, 0 = no
 * @property {boolean} excerpt_changed - 1 = yes, 0 = no
 * @property {string} user_agent - user_agent
 * @property {boolean} meta_title_changed - 1 = yes, 0 = no
 * @property {GUID} msid - msid
 * @property {boolean} mobile_title_changed - 1 = yes, 0 = no
 * @return {LogObject<advancedSeoClickOnDoneParams>} LogObject<advancedSeoClickOnDoneParams>
 */
export function advancedSeoClickOnDone(params) {
    return { evid: 131, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'advancedSeoClickOnCancel' event (evid: 132)
 *
 * Event description: advanced seo click on cancel
 *
 * @param {advancedSeoClickOnCancelParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} button_name - Cancel,X,esc,click on BM
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<advancedSeoClickOnCancelParams>} LogObject<advancedSeoClickOnCancelParams>
 */
export function advancedSeoClickOnCancel(params) {
    return { evid: 132, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'relatedPostClick' event (evid: 133)
 *
 * Event description: click on related post button
 *
 * @param {relatedPostClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post id
 * @property {string} user_agent - user_agent
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<relatedPostClickParams>} LogObject<relatedPostClickParams>
 */
export function relatedPostClick(params) {
    return { evid: 133, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'relatedPostSearchClicked' event (evid: 134)
 *
 * Event description: click on search in related items
 *
 * @param {relatedPostSearchClickedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post id
 * @property {string} user_agent - user_agent
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<relatedPostSearchClickedParams>} LogObject<relatedPostSearchClickedParams>
 */
export function relatedPostSearchClicked(params) {
    return { evid: 134, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'relatedPostClickOnDone' event (evid: 135)
 *
 * Event description: click on search in related items
 *
 * @param {relatedPostClickOnDoneParams} params - The parameters for this event
 * @property {string} list_name - [post_id1, post_id2, etc...]
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post id
 * @property {string} user_agent - user_agent
 * @property {number} num_items - number of selected posts
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<relatedPostClickOnDoneParams>} LogObject<relatedPostClickOnDoneParams>
 */
export function relatedPostClickOnDone(params) {
    return { evid: 135, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'relatedPostClickOnCancel' event (evid: 136)
 *
 * Event description: click on search in related items
 *
 * @param {relatedPostClickOnCancelParams} params - The parameters for this event
 * @property {string} list_name - [post_id1, post_id2, etc...]
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post id
 * @property {string} button_name - esc,close,X,click on BM,etc...
 * @property {string} user_agent - user_agent
 * @property {number} num_items - number of selected posts
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<relatedPostClickOnCancelParams>} LogObject<relatedPostClickOnCancelParams>
 */
export function relatedPostClickOnCancel(params) {
    return { evid: 136, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addMusic' event (evid: 137)
 *
 * Event description: music added
 *
 * @param {addMusicParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {boolean} cover_toggle - 1- on, 0 - off
 * @property {string} post_id - post_id
 * @property {boolean} track_list_toggle - 1- on, 0 - off
 * @property {string} user_agent - user_agent
 * @property {string} design_state - light, dark
 * @property {GUID} msid - msid
 * @return {LogObject<addMusicParams>} LogObject<addMusicParams>
 */
export function addMusic(params) {
    return { evid: 137, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'musicToolBarClicked' event (evid: 138)
 *
 * Event description: muisic_tool_bar_clicked
 *
 * @param {musicToolBarClickedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @property {string} action - change album,manage music,album cover, track list, delete
 * @return {LogObject<musicToolBarClickedParams>} LogObject<musicToolBarClickedParams>
 */
export function musicToolBarClicked(params) {
    return { evid: 138, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'imageAddedToPost' event (evid: 139)
 *
 * Event description: image added to post
 *
 * @param {imageAddedToPostParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<imageAddedToPostParams>} LogObject<imageAddedToPostParams>
 */
export function imageAddedToPost(params) {
    return { evid: 139, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'duplicate' event (evid: 14)
 *
 * Event description: duplicate.
 *
 * @param {duplicateParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<duplicateParams>} LogObject<duplicateParams>
 */
export function duplicate(params) {
    return { evid: 14, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'galleryAddedToPost' event (evid: 140)
 *
 * Event description: gallery added to post
 *
 * @param {galleryAddedToPostParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<galleryAddedToPostParams>} LogObject<galleryAddedToPostParams>
 */
export function galleryAddedToPost(params) {
    return { evid: 140, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tryingToOpenBlogManagerWithoutStoreId' event (evid: 141)
 *
 * Event description: trying to open Blog Manager without storeId
 *
 * @param {tryingToOpenBlogManagerWithoutStoreIdParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<tryingToOpenBlogManagerWithoutStoreIdParams>} LogObject<tryingToOpenBlogManagerWithoutStoreIdParams>
 */
export function tryingToOpenBlogManagerWithoutStoreId(params) {
    return { evid: 141, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnUpdateSubscribers' event (evid: 142)
 *
 * Event description: turn on/off option to update users on new published posts
 *
 * @param {clickOnUpdateSubscribersParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {boolean} status - 0 - off , 1 - on
 * @property {GUID} metasiteid - msid
 * @property {GUID} msid - msid
 * @return {LogObject<clickOnUpdateSubscribersParams>} LogObject<clickOnUpdateSubscribersParams>
 */
export function clickOnUpdateSubscribers(params) {
    return { evid: 142, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppClickAddTagsCategoriesFromActionList' event (evid: 143)
 *
 * Event description: When user clicks on "add tags and categories" button in the action list.
 *
 * @param {oneAppClickAddTagsCategoriesFromActionListParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppClickAddTagsCategoriesFromActionListParams>} LogObject<oneAppClickAddTagsCategoriesFromActionListParams>
 */
export function oneAppClickAddTagsCategoriesFromActionList(params) {
    return { evid: 143, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppAddEditTags' event (evid: 144)
 *
 * Event description: When user clicks on add / edit tags button in the tags and categories screen
 *
 * @param {oneAppAddEditTagsParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @property {string} action - add/edit
 * @return {LogObject<oneAppAddEditTagsParams>} LogObject<oneAppAddEditTagsParams>
 */
export function oneAppAddEditTags(params) {
    return { evid: 144, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppAddEditCategory' event (evid: 145)
 *
 * Event description: When user clicks on add / edit category button in the tags and categories screen
 *
 * @param {oneAppAddEditCategoryParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @property {string} action - add/edit
 * @return {LogObject<oneAppAddEditCategoryParams>} LogObject<oneAppAddEditCategoryParams>
 */
export function oneAppAddEditCategory(params) {
    return { evid: 145, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppSaveNewCategory' event (evid: 146)
 *
 * Event description: When user saves a new category (clicking done in the new category flow)
 *
 * @param {oneAppSaveNewCategoryParams} params - The parameters for this event
 * @property {string} name - category name
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppSaveNewCategoryParams>} LogObject<oneAppSaveNewCategoryParams>
 */
export function oneAppSaveNewCategory(params) {
    return { evid: 146, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppSaveTagsAndCategories' event (evid: 147)
 *
 * Event description: This event is fired when user finished the flow and click on done
 *
 * @param {oneAppSaveTagsAndCategoriesParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} tags - tags array
 * @property {string} user_agent - user_agent
 * @property {string} categories - categories array
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppSaveTagsAndCategoriesParams>} LogObject<oneAppSaveTagsAndCategoriesParams>
 */
export function oneAppSaveTagsAndCategories(params) {
    return { evid: 147, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogEditorEditDesktopPostClicked' event (evid: 148)
 *
 * Event description: When user clicks on edit while viewing a desktop-created blogpost. This is a dummy button until implemented as part of A/B test
 *
 * @param {blogEditorEditDesktopPostClickedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} postId - post id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<blogEditorEditDesktopPostClickedParams>} LogObject<blogEditorEditDesktopPostClickedParams>
 */
export function blogEditorEditDesktopPostClicked(params) {
    return { evid: 148, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogEditorLimitedEditingOptionsReadMoreButtonClicked' event (evid: 149)
 *
 * Event description: When user clicks on "read more" in the blue alert
 *
 * @param {blogEditorLimitedEditingOptionsReadMoreButtonClickedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} value - "yes" / "no"
 * @return {LogObject<blogEditorLimitedEditingOptionsReadMoreButtonClickedParams>} LogObject<blogEditorLimitedEditingOptionsReadMoreButtonClickedParams>
 */
export function blogEditorLimitedEditingOptionsReadMoreButtonClicked(params) {
    return { evid: 149, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publishPost' event (evid: 15)
 *
 * Event description: publish_post.
 *
 * @param {publishPostParams} params - The parameters for this event
 * @property {boolean} isDesktopPost - True if this was created on desktop but edited on OneApp
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {boolean} is_desktop_post - True if this was created on desktop but edited on OneApp
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<publishPostParams>} LogObject<publishPostParams>
 */
export function publishPost(params) {
    return { evid: 15, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'whatsNewClick' event (evid: 151)
 *
 * Event description: Fires when a user click on an action in the what's new window
 *
 * @param {whatsNewClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} data - where the what's new direct (mail subscribe, insights, etc...)
 * @property {string} user_agent - user_agent
 * @property {string} selection - check it out, no thanks
 * @property {GUID} msid - msid
 * @return {LogObject<whatsNewClickParams>} LogObject<whatsNewClickParams>
 */
export function whatsNewClick(params) {
    return { evid: 151, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnFilterPostsStatus' event (evid: 152)
 *
 * Event description: When user click on the filter button in the posts list screen (mobile only)
 * for choosing between published, drafts,etc..
 *
 * @param {clickOnFilterPostsStatusParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<clickOnFilterPostsStatusParams>} LogObject<clickOnFilterPostsStatusParams>
 */
export function clickOnFilterPostsStatus(params) {
    return { evid: 152, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'selectedPostsStatusFromFilter' event (evid: 153)
 *
 * Event description: when user selected post status from the filter (mobile only) and  choosing between published, drafts,etc..
 *
 * @param {selectedPostsStatusFromFilterParams} params - The parameters for this event
 * @property {string} previous_value - published,drafts,all,etc..
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @property {string} value - published,drafts,all,etc..
 * @return {LogObject<selectedPostsStatusFromFilterParams>} LogObject<selectedPostsStatusFromFilterParams>
 */
export function selectedPostsStatusFromFilter(params) {
    return { evid: 153, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogAmpToggleClick' event (evid: 154)
 *
 * Event description: fired when blog amp toggle is clicked
 *
 * @param {blogAmpToggleClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {boolean} status - status
 * @property {string} hosting - MA, editor
 * @property {GUID} msid - msid
 * @return {LogObject<blogAmpToggleClickParams>} LogObject<blogAmpToggleClickParams>
 */
export function blogAmpToggleClick(params) {
    return { evid: 154, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mobilePrePublish' event (evid: 155)
 *
 * Event description: when user clicks on publish from the post and going to pre publish screen where he can choose to share and publish the post
 *
 * @param {mobilePrePublishParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<mobilePrePublishParams>} LogObject<mobilePrePublishParams>
 */
export function mobilePrePublish(params) {
    return { evid: 155, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppSocialShareToggle' event (evid: 156)
 *
 * Event description: when user change the state of a social share toggle in the pre publish screen
 *
 * @param {oneAppSocialShareToggleParams} params - The parameters for this event
 * @property {string} state - true/false-> to which state the toggle is changing
 * @property {GUID} site_id - site_id
 * @property {string} socialNetwork - facebook, tweeter,..
 * @property {string} user_agent - user_agent
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppSocialShareToggleParams>} LogObject<oneAppSocialShareToggleParams>
 */
export function oneAppSocialShareToggle(params) {
    return { evid: 156, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsEndpointStartedToUse' event (evid: 157)
 *
 * Event description: DS endpoint started to use
 *
 * @param {dsEndpointStartedToUseParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dsEndpointStartedToUseParams>} LogObject<dsEndpointStartedToUseParams>
 */
export function dsEndpointStartedToUse(params) {
    return { evid: 157, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'failToUseDsEndpoint' event (evid: 158)
 *
 * Event description: Fail to use DS endpoint
 *
 * @param {failToUseDsEndpointParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<failToUseDsEndpointParams>} LogObject<failToUseDsEndpointParams>
 */
export function failToUseDsEndpoint(params) {
    return { evid: 158, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deletePost' event (evid: 16)
 *
 * Event description: delete_post.
 *
 * @param {deletePostParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<deletePostParams>} LogObject<deletePostParams>
 */
export function deletePost(params) {
    return { evid: 16, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnAddYourMusic' event (evid: 160)
 *
 * Event description: click on add music
 *
 * @param {clickOnAddYourMusicParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<clickOnAddYourMusicParams>} LogObject<clickOnAddYourMusicParams>
 */
export function clickOnAddYourMusic(params) {
    return { evid: 160, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'musicCoverToggleClicked' event (evid: 161)
 *
 * Event description: music - cover toggle clicked
 *
 * @param {musicCoverToggleClickedParams} params - The parameters for this event
 * @property {boolean} toggle_state - toggle_state (1-on, 0-off)
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<musicCoverToggleClickedParams>} LogObject<musicCoverToggleClickedParams>
 */
export function musicCoverToggleClicked(params) {
    return { evid: 161, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'musicTrackListToggleClicked' event (evid: 162)
 *
 * Event description: music - track list toggle clicked
 *
 * @param {musicTrackListToggleClickedParams} params - The parameters for this event
 * @property {boolean} toggle_state - toggle_state (1-on, 0-off)
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<musicTrackListToggleClickedParams>} LogObject<musicTrackListToggleClickedParams>
 */
export function musicTrackListToggleClicked(params) {
    return { evid: 162, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'musicChangeThemeClicked' event (evid: 163)
 *
 * Event description: music - track list toggle clicked
 *
 * @param {musicChangeThemeClickedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {string} theme_type - theme_type (dark,light)
 * @property {GUID} msid - msid
 * @return {LogObject<musicChangeThemeClickedParams>} LogObject<musicChangeThemeClickedParams>
 */
export function musicChangeThemeClicked(params) {
    return { evid: 163, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteMusic' event (evid: 164)
 *
 * Event description: delete music component
 *
 * @param {deleteMusicParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<deleteMusicParams>} LogObject<deleteMusicParams>
 */
export function deleteMusic(params) {
    return { evid: 164, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnManageMusic' event (evid: 165)
 *
 * Event description: click on manage music
 *
 * @param {clickOnManageMusicParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<clickOnManageMusicParams>} LogObject<clickOnManageMusicParams>
 */
export function clickOnManageMusic(params) {
    return { evid: 165, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeMusicAlbumDropdownClicked' event (evid: 166)
 *
 * Event description: change music album
 *
 * @param {changeMusicAlbumDropdownClickedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<changeMusicAlbumDropdownClickedParams>} LogObject<changeMusicAlbumDropdownClickedParams>
 */
export function changeMusicAlbumDropdownClicked(params) {
    return { evid: 166, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'musicAlbumChanged' event (evid: 167)
 *
 * Event description: music album changed
 *
 * @param {musicAlbumChangedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<musicAlbumChangedParams>} LogObject<musicAlbumChangedParams>
 */
export function musicAlbumChanged(params) {
    return { evid: 167, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogEditorExplanationScreenDismissed' event (evid: 168)
 *
 * Event description: When user dismisses explanation screen shown after clicking on non-editable blogpost item or after clicking read more in the blue alert.
 *
 * @param {blogEditorExplanationScreenDismissedParams} params - The parameters for this event
 * @property {string} buttonType - the type of button i.e "X" or "Got it"
 * @property {GUID} postId - post id
 * @property {string} button_type - the type of button i.e "X" or "Got it"
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post id
 * @property {string} user_agent - user_agent
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<blogEditorExplanationScreenDismissedParams>} LogObject<blogEditorExplanationScreenDismissedParams>
 */
export function blogEditorExplanationScreenDismissed(params) {
    return { evid: 168, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogEditorDesktopPostDesktopItemClicked' event (evid: 169)
 *
 * Event description: When user click on non-editable desktop post item
 *
 * @param {blogEditorDesktopPostDesktopItemClickedParams} params - The parameters for this event
 * @property {string} itemType - `gallery`, `music`, `video`, `html`, and `embedded content`
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} postId - post_id
 * @property {string} platform - platform
 * @property {string} item_type - `gallery`, `music`, `video`, `html`, and `embedded content`
 * @property {GUID} msid - msid
 * @return {LogObject<blogEditorDesktopPostDesktopItemClickedParams>} LogObject<blogEditorDesktopPostDesktopItemClickedParams>
 */
export function blogEditorDesktopPostDesktopItemClicked(params) {
    return { evid: 169, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeCoverImage' event (evid: 17)
 *
 * Event description: change_cover_image.
 *
 * @param {changeCoverImageParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<changeCoverImageParams>} LogObject<changeCoverImageParams>
 */
export function changeCoverImage(params) {
    return { evid: 17, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogManagerFullyLoaded' event (evid: 170)
 *
 * Event description: Indicate when the BM is fully loaded
 *
 * @param {blogManagerFullyLoadedParams} params - The parameters for this event
 * @property {number} duration - duration in ms from event 12:50
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<blogManagerFullyLoadedParams>} LogObject<blogManagerFullyLoadedParams>
 */
export function blogManagerFullyLoaded(params) {
    return { evid: 170, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mobilePreUpdateForScheduledPost' event (evid: 171)
 *
 * Event description: when user clicks on update from the scheduled post and going to pre update screen
 *
 * @param {mobilePreUpdateForScheduledPostParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<mobilePreUpdateForScheduledPostParams>} LogObject<mobilePreUpdateForScheduledPostParams>
 */
export function mobilePreUpdateForScheduledPost(params) {
    return { evid: 171, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'doneSetTimeForSchedulePost' event (evid: 175)
 *
 * Event description: when user click on last o.k/done on time scheduler
 *
 * @param {doneSetTimeForSchedulePostParams} params - The parameters for this event
 * @property {number} timeTillPublish - Time to publish in minutes from current time
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {number} timetopublish - Time to publish in minutes from current time
 * @property {boolean} is_desktop_post - True if the post was created on desktop, False if on OneApp
 * @property {string} type - "new"/"update" for creating a new scheduled post or updating an existing one
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<doneSetTimeForSchedulePostParams>} LogObject<doneSetTimeForSchedulePostParams>
 */
export function doneSetTimeForSchedulePost(params) {
    return { evid: 175, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeCoverApply' event (evid: 18)
 *
 * Event description: change_cover_apply .
 *
 * @param {changeCoverApplyParams} params - The parameters for this event
 * @property {string} image_origin - private image,from post
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<changeCoverApplyParams>} LogObject<changeCoverApplyParams>
 */
export function changeCoverApply(params) {
    return { evid: 18, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeCoverCancel' event (evid: 19)
 *
 * Event description: change_cover_cancel.
 *
 * @param {changeCoverCancelParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<changeCoverCancelParams>} LogObject<changeCoverCancelParams>
 */
export function changeCoverCancel(params) {
    return { evid: 19, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'trashDeleteForever' event (evid: 20)
 *
 * Event description: trash_delete_forever.
 *
 * @param {trashDeleteForeverParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<trashDeleteForeverParams>} LogObject<trashDeleteForeverParams>
 */
export function trashDeleteForever(params) {
    return { evid: 20, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restore' event (evid: 21)
 *
 * Event description: restore.
 *
 * @param {restoreParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<restoreParams>} LogObject<restoreParams>
 */
export function restore(params) {
    return { evid: 21, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'apply' event (evid: 22)
 *
 * Event description: apply.
 *
 * @param {applyParams} params - The parameters for this event
 * @property {number} count - count
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<applyParams>} LogObject<applyParams>
 */
export function apply(params) {
    return { evid: 22, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'selectAll' event (evid: 23)
 *
 * Event description: select_all.
 *
 * @param {selectAllParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<selectAllParams>} LogObject<selectAllParams>
 */
export function selectAll(params) {
    return { evid: 23, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'selectAllXPosts' event (evid: 24)
 *
 * Event description: select_all_x_posts.
 *
 * @param {selectAllXPostsParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<selectAllXPostsParams>} LogObject<selectAllXPostsParams>
 */
export function selectAllXPosts(params) {
    return { evid: 24, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'featuredPost' event (evid: 25)
 *
 * Event description: featured_post.
 *
 * @param {featuredPostParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<featuredPostParams>} LogObject<featuredPostParams>
 */
export function featuredPost(params) {
    return { evid: 25, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteTag' event (evid: 26)
 *
 * Event description: delete_tag.
 *
 * @param {deleteTagParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<deleteTagParams>} LogObject<deleteTagParams>
 */
export function deleteTag(params) {
    return { evid: 26, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editTag' event (evid: 27)
 *
 * Event description: edit_tag.
 *
 * @param {editTagParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<editTagParams>} LogObject<editTagParams>
 */
export function editTag(params) {
    return { evid: 27, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeState' event (evid: 28)
 *
 * Event description: change_state.
 *
 * @param {changeStateParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<changeStateParams>} LogObject<changeStateParams>
 */
export function changeState(params) {
    return { evid: 28, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeDate' event (evid: 29)
 *
 * Event description: change_date.
 *
 * @param {changeDateParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<changeDateParams>} LogObject<changeDateParams>
 */
export function changeDate(params) {
    return { evid: 29, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'closePostEditor' event (evid: 30)
 *
 * Event description: Close post editor
 *
 * @param {closePostEditorParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<closePostEditorParams>} LogObject<closePostEditorParams>
 */
export function closePostEditor(params) {
    return { evid: 30, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'closePostEditorDiscardChanges' event (evid: 31)
 *
 * Event description: Close post editor discard changes.
 *
 * @param {closePostEditorDiscardChangesParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<closePostEditorDiscardChangesParams>} LogObject<closePostEditorDiscardChangesParams>
 */
export function closePostEditorDiscardChanges(params) {
    return { evid: 31, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'closePostEditorSaveChanges' event (evid: 32)
 *
 * Event description: Close post editor save changes.
 *
 * @param {closePostEditorSaveChangesParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<closePostEditorSaveChangesParams>} LogObject<closePostEditorSaveChangesParams>
 */
export function closePostEditorSaveChanges(params) {
    return { evid: 32, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'insertImage' event (evid: 33)
 *
 * Event description: insert_image.
 *
 * @param {insertImageParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<insertImageParams>} LogObject<insertImageParams>
 */
export function insertImage(params) {
    return { evid: 33, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'insertVideo' event (evid: 34)
 *
 * Event description: insert_video.
 *
 * @param {insertVideoParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<insertVideoParams>} LogObject<insertVideoParams>
 */
export function insertVideo(params) {
    return { evid: 34, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'setCover' event (evid: 35)
 *
 * Event description: set_cover.
 *
 * @param {setCoverParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<setCoverParams>} LogObject<setCoverParams>
 */
export function setCover(params) {
    return { evid: 35, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeImage' event (evid: 36)
 *
 * Event description: change_image.
 *
 * @param {changeImageParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<changeImageParams>} LogObject<changeImageParams>
 */
export function changeImage(params) {
    return { evid: 36, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'alignImage' event (evid: 37)
 *
 * Event description: align_image.
 *
 * @param {alignImageParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<alignImageParams>} LogObject<alignImageParams>
 */
export function alignImage(params) {
    return { evid: 37, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'alignVideo' event (evid: 38)
 *
 * Event description: align_video.
 *
 * @param {alignVideoParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<alignVideoParams>} LogObject<alignVideoParams>
 */
export function alignVideo(params) {
    return { evid: 38, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteImage' event (evid: 39)
 *
 * Event description: delete_image.
 *
 * @param {deleteImageParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<deleteImageParams>} LogObject<deleteImageParams>
 */
export function deleteImage(params) {
    return { evid: 39, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteVideo' event (evid: 40)
 *
 * Event description: delete_video.
 *
 * @param {deleteVideoParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<deleteVideoParams>} LogObject<deleteVideoParams>
 */
export function deleteVideo(params) {
    return { evid: 40, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeSize' event (evid: 41)
 *
 * Event description: change_size.
 *
 * @param {changeSizeParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<changeSizeParams>} LogObject<changeSizeParams>
 */
export function changeSize(params) {
    return { evid: 41, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'boldTextClicked' event (evid: 42)
 *
 * Event description: Bold text clicked.
 *
 * @param {boldTextClickedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<boldTextClickedParams>} LogObject<boldTextClickedParams>
 */
export function boldTextClicked(params) {
    return { evid: 42, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'italicTextClicked' event (evid: 43)
 *
 * Event description: Italic text clicked.
 *
 * @param {italicTextClickedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<italicTextClickedParams>} LogObject<italicTextClickedParams>
 */
export function italicTextClicked(params) {
    return { evid: 43, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'underlineTextClicked' event (evid: 44)
 *
 * Event description: underline text clicked.
 *
 * @param {underlineTextClickedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<underlineTextClickedParams>} LogObject<underlineTextClickedParams>
 */
export function underlineTextClicked(params) {
    return { evid: 44, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addNumberingToPost' event (evid: 45)
 *
 * Event description: add numbering to post.
 *
 * @param {addNumberingToPostParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<addNumberingToPostParams>} LogObject<addNumberingToPostParams>
 */
export function addNumberingToPost(params) {
    return { evid: 45, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addBulletsToPost' event (evid: 46)
 *
 * Event description: add bullets to post.
 *
 * @param {addBulletsToPostParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<addBulletsToPostParams>} LogObject<addBulletsToPostParams>
 */
export function addBulletsToPost(params) {
    return { evid: 46, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'iFrameBlogManagerOpened' event (evid: 50)
 *
 * Event description: iFrame (blog manager) opened.
 *
 * @param {iFrameBlogManagerOpenedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} post_id - deprecated
 * @property {string} referral_info - MA, other
 * @property {string} user_agent - user_agent
 * @property {string} origin - ADI Origin
 * @property {string} status - result
 * @property {string} sub_referral_info - sub referral info
 * @property {GUID} msid - msid
 * @return {LogObject<iFrameBlogManagerOpenedParams>} LogObject<iFrameBlogManagerOpenedParams>
 */
export function iFrameBlogManagerOpened(params) {
    return { evid: 50, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogComponentStartedLoading' event (evid: 500)
 *
 * Event description: blog_component_started_loading
 *
 * @param {blogComponentStartedLoadingParams} params - The parameters for this event
 * @property {GUID} vsi - vsi
 * @property {GUID} site_id - site_id
 * @property {number} ts - ts
 * @property {GUID} visitor_id - visitor_id
 * @property {string} c2 - id
 * @property {string} viewmode - viewmode
 * @property {string} page_id - page_id
 * @property {GUID} msid - msid
 * @property {number} tsp - tsp
 * @return {LogObject<blogComponentStartedLoadingParams>} LogObject<blogComponentStartedLoadingParams>
 */
export function blogComponentStartedLoading(params) {
    return { evid: 500, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogComponentFinishedLoading' event (evid: 501)
 *
 * Event description: blog_component_finished_loading
 *
 * @param {blogComponentFinishedLoadingParams} params - The parameters for this event
 * @property {GUID} vsi - vsi
 * @property {GUID} site_id - site_id
 * @property {number} ts - ts
 * @property {GUID} visitor_id - visitor_id
 * @property {string} c2 - id
 * @property {string} viewmode - viewmode
 * @property {string} page_id - page_id
 * @property {GUID} msid - msid
 * @property {number} tsp - tsp
 * @property {number} loading_time - Loading time in ms
 * @return {LogObject<blogComponentFinishedLoadingParams>} LogObject<blogComponentFinishedLoadingParams>
 */
export function blogComponentFinishedLoading(params) {
    return { evid: 501, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouCategoryClick' event (evid: 502)
 *
 * Event description: UOU_category_click
 *
 * @param {uouCategoryClickParams} params - The parameters for this event
 * @property {GUID} vsi - vsi
 * @property {GUID} site_id - site_id
 * @property {number} ts - ts
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - viewmode
 * @property {string} page_id - page_id
 * @property {string} origin - feed,single_post,vertical_comp
 * @property {GUID} msid - msid
 * @property {number} tsp - tsp
 * @return {LogObject<uouCategoryClickParams>} LogObject<uouCategoryClickParams>
 */
export function uouCategoryClick(params) {
    return { evid: 502, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouTagClick' event (evid: 503)
 *
 * Event description: UOU_tag_click
 *
 * @param {uouTagClickParams} params - The parameters for this event
 * @property {GUID} vsi - vsi
 * @property {GUID} site_id - site_id
 * @property {number} ts - ts
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - viewmode
 * @property {string} page_id - page_id
 * @property {string} origin - single_post,tag_cloud
 * @property {GUID} msid - msid
 * @property {number} tsp - tsp
 * @return {LogObject<uouTagClickParams>} LogObject<uouTagClickParams>
 */
export function uouTagClick(params) {
    return { evid: 503, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouShareClick' event (evid: 504)
 *
 * Event description: UOU_share_click
 *
 * @param {uouShareClickParams} params - The parameters for this event
 * @property {GUID} vsi - vsi
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {number} ts - ts
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - viewmode
 * @property {string} page_id - page_id
 * @property {string} type - facebook,google,pinterest,twitter,fancy,whatsapp
 * @property {GUID} msid - msid
 * @property {number} tsp - tsp
 * @return {LogObject<uouShareClickParams>} LogObject<uouShareClickParams>
 */
export function uouShareClick(params) {
    return { evid: 504, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouReadMoreClicked' event (evid: 505)
 *
 * Event description: UOU_read_more_clicked
 *
 * @param {uouReadMoreClickedParams} params - The parameters for this event
 * @property {GUID} vsi - vsi
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {number} ts - ts
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - viewmode
 * @property {string} page_id - page_id
 * @property {string} origin - title,image,read_more_btn
 * @property {GUID} msid - msid
 * @property {number} tsp - tsp
 * @return {LogObject<uouReadMoreClickedParams>} LogObject<uouReadMoreClickedParams>
 */
export function uouReadMoreClicked(params) {
    return { evid: 505, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharePartOfTextPopup' event (evid: 507)
 *
 * Event description: After user select a part of text in the single page a popup window will come up.
 *
 * @param {sharePartOfTextPopupParams} params - The parameters for this event
 * @property {GUID} vsi - vsi
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {number} ts - ts
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - viewmode
 * @property {string} page_id - page_id
 * @property {GUID} msid - msid
 * @property {number} tsp - tsp
 * @return {LogObject<sharePartOfTextPopupParams>} LogObject<sharePartOfTextPopupParams>
 */
export function sharePartOfTextPopup(params) {
    return { evid: 507, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharePartOfTextClick' event (evid: 508)
 *
 * Event description: After user select a part of text in the single page a popup window will come up user click on the share button.
 *
 * @param {sharePartOfTextClickParams} params - The parameters for this event
 * @property {GUID} vsi - vsi
 * @property {GUID} site_id - site_id
 * @property {string} socialNetwork - Mail, Facebook, Twitter,etc...
 * @property {number} ts - ts
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - viewmode
 * @property {string} page_id - page_id
 * @property {GUID} msid - msid
 * @property {number} tsp - tsp
 * @return {LogObject<sharePartOfTextClickParams>} LogObject<sharePartOfTextClickParams>
 */
export function sharePartOfTextClick(params) {
    return { evid: 508, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'unFeatured' event (evid: 51)
 *
 * Event description: un_featured.
 *
 * @param {unFeaturedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<unFeaturedParams>} LogObject<unFeaturedParams>
 */
export function unFeatured(params) {
    return { evid: 51, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogOpenInRssMode' event (evid: 510)
 *
 * Event description: identify users that opened the blog via rss
 *
 * @param {blogOpenInRssModeParams} params - The parameters for this event
 * @property {string} user_agent - user_agent
 * @property {string} feedUrl - the full url with the rss
 * @property {GUID} cid - visitor_id
 * @property {GUID} siteid - site_id
 * @property {GUID} msid - msid
 * @return {LogObject<blogOpenInRssModeParams>} LogObject<blogOpenInRssModeParams>
 */
export function blogOpenInRssMode(params) {
    return { evid: 510, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogLikeClick' event (evid: 512)
 *
 * Event description: User click on like
 *
 * @param {blogLikeClickParams} params - The parameters for this event
 * @property {GUID} vsi - vsi
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {number} ts - ts
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - viewmode
 * @property {string} page_id - page_id
 * @property {string} like_status - like. unlike
 * @property {GUID} msid - msid
 * @property {number} tsp - tsp
 * @return {LogObject<blogLikeClickParams>} LogObject<blogLikeClickParams>
 */
export function blogLikeClick(params) {
    return { evid: 512, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPartRendered' event (evid: 513)
 *
 * Event description: Shot when app parts finished rendering
 *
 * @param {appPartRenderedParams} params - The parameters for this event
 * @property {GUID} vsi - vsi
 * @property {number} duration - Duration in milliseconds
 * @property {GUID} site_id - site_id
 * @property {number} ts - ts
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - viewmode
 * @property {string} page_id - page_id
 * @property {number} occurrence_count - occurrence count
 * @property {string} app_part_state - loading, error, content
 * @property {string} app_part_name - App part Name
 * @property {string} component_id - component
 * @property {GUID} msid - msid
 * @property {number} tsp - tsp
 * @return {LogObject<appPartRenderedParams>} LogObject<appPartRenderedParams>
 */
export function appPartRendered(params) {
    return { evid: 513, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPartDataRequestFinished' event (evid: 514)
 *
 * Event description: Fires when app part data request returns from server and if the request  is part of a batch
 *
 * @param {appPartDataRequestFinishedParams} params - The parameters for this event
 * @property {GUID} vsi - vsi
 * @property {number} duration - Duration in milliseconds
 * @property {boolean} is_batched - true, false
 * @property {GUID} site_id - site_id
 * @property {number} ts - ts
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - viewmode
 * @property {string} page_id - page_id
 * @property {number} occurrence_count - occurrence count
 * @property {string} app_part_name - App part Name
 * @property {string} component_id - component
 * @property {GUID} msid - msid
 * @property {number} tsp - tsp
 * @return {LogObject<appPartDataRequestFinishedParams>} LogObject<appPartDataRequestFinishedParams>
 */
export function appPartDataRequestFinished(params) {
    return { evid: 514, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'firstTimeAppPartRenderStart' event (evid: 516)
 *
 * Event description: Shot only on the first time the app part starts rendering
 *
 * @param {firstTimeAppPartRenderStartParams} params - The parameters for this event
 * @property {GUID} vsi - vsi
 * @property {GUID} site_id - site_id
 * @property {number} ts - ts
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - viewmode
 * @property {string} page_id - page_id
 * @property {string} app_part_name - App part Name
 * @property {string} component_id - component
 * @property {GUID} msid - msid
 * @property {number} tsp - tsp
 * @return {LogObject<firstTimeAppPartRenderStartParams>} LogObject<firstTimeAppPartRenderStartParams>
 */
export function firstTimeAppPartRenderStart(params) {
    return { evid: 516, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'firstTimeAppPartRenderFinished' event (evid: 517)
 *
 * Event description: Shot only on the first time app part finished rendering with data (content\error)
 *
 * @param {firstTimeAppPartRenderFinishedParams} params - The parameters for this event
 * @property {GUID} vsi - vsi
 * @property {number} duration - Duration in milliseconds from evid: 516
 * @property {number} render_duration - duration in ms since app part got the data\error
 * @property {GUID} site_id - site_id
 * @property {number} ts - ts
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - viewmode
 * @property {string} page_id - page_id
 * @property {string} app_part_state - error, content
 * @property {string} app_part_name - App part Name
 * @property {string} component_id - component
 * @property {GUID} msid - msid
 * @property {number} tsp - tsp
 * @return {LogObject<firstTimeAppPartRenderFinishedParams>} LogObject<firstTimeAppPartRenderFinishedParams>
 */
export function firstTimeAppPartRenderFinished(params) {
    return { evid: 517, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newPost' event (evid: 52)
 *
 * Event description: new_post.
 *
 * @param {newPostParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<newPostParams>} LogObject<newPostParams>
 */
export function newPost(params) {
    return { evid: 52, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'help' event (evid: 53)
 *
 * Event description: help.
 *
 * @param {helpParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<helpParams>} LogObject<helpParams>
 */
export function help(params) {
    return { evid: 53, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogManagerUiIsReady' event (evid: 54)
 *
 * Event description: blog manager UI is ready.
 *
 * @param {blogManagerUiIsReadyParams} params - The parameters for this event
 * @property {number} duration - duration
 * @property {boolean} has_whats_new - has_whats_new
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {boolean} has_quicktip - has_quicktip
 * @property {GUID} msid - msid
 * @return {LogObject<blogManagerUiIsReadyParams>} LogObject<blogManagerUiIsReadyParams>
 */
export function blogManagerUiIsReady(params) {
    return { evid: 54, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deletePostDialog' event (evid: 55)
 *
 * Event description: delete post dialog
 *
 * @param {deletePostDialogParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - multi_select/post_hover
 * @property {GUID} msid - msid
 * @return {LogObject<deletePostDialogParams>} LogObject<deletePostDialogParams>
 */
export function deletePostDialog(params) {
    return { evid: 55, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deletePostDialogNotNow' event (evid: 56)
 *
 * Event description: delete post dialog not now
 *
 * @param {deletePostDialogNotNowParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - multi_select/post_hover
 * @property {GUID} msid - msid
 * @return {LogObject<deletePostDialogNotNowParams>} LogObject<deletePostDialogNotNowParams>
 */
export function deletePostDialogNotNow(params) {
    return { evid: 56, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'saveAsDraft' event (evid: 57)
 *
 * Event description: Save as draft
 *
 * @param {saveAsDraftParams} params - The parameters for this event
 * @property {boolean} isDesktopPost - is_desktop
 * @property {GUID} postId - post id
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post id
 * @property {string} user_agent - user_agent
 * @property {boolean} is_desktop_post - is_desktop
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<saveAsDraftParams>} LogObject<saveAsDraftParams>
 */
export function saveAsDraft(params) {
    return { evid: 57, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'doneScheduledPost' event (evid: 58)
 *
 * Event description: Done_scheduled_post
 *
 * @param {doneScheduledPostParams} params - The parameters for this event
 * @property {number} timeTillPublish - Time to publish in minutes from current time
 * @property {GUID} site_id - site_id
 * @property {string} post_id - post_id
 * @property {string} user_agent - user_agent
 * @property {number} timetopublish - Time to publish in minutes from current time
 * @property {boolean} is_desktop_post - True if the post was created on desktop, False if on OneApp
 * @property {string} type - "new"/"update" for creating a new scheduled post or updating an existing one
 * @property {number} timeToPublish - Time to publish in minutes from current time
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<doneScheduledPostParams>} LogObject<doneScheduledPostParams>
 */
export function doneScheduledPost(params) {
    return { evid: 58, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'extendTextToolbarClick' event (evid: 59)
 *
 * Event description: extend_text_toolbar_click
 *
 * @param {extendTextToolbarClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {boolean} status - more,less
 * @property {GUID} msid - msid
 * @return {LogObject<extendTextToolbarClickParams>} LogObject<extendTextToolbarClickParams>
 */
export function extendTextToolbarClick(params) {
    return { evid: 59, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'colorPickerClick' event (evid: 60)
 *
 * Event description: color_picker_click
 *
 * @param {colorPickerClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<colorPickerClickParams>} LogObject<colorPickerClickParams>
 */
export function colorPickerClick(params) {
    return { evid: 60, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'colorPickerParams' event (evid: 61)
 *
 * Event description: color_picker_params
 *
 * @param {colorPickerParamsParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} param - text,highlight,customize
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<colorPickerParamsParams>} LogObject<colorPickerParamsParams>
 */
export function colorPickerParams(params) {
    return { evid: 61, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'promoteYourPostClick' event (evid: 62)
 *
 * Event description: promote_your_post_click
 *
 * @param {promoteYourPostClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} socialNetwork - facebook, twitter,email
 * @property {string} user_agent - user_agent
 * @property {string} referal_info - publish_button, share_icon
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<promoteYourPostClickParams>} LogObject<promoteYourPostClickParams>
 */
export function promoteYourPostClick(params) {
    return { evid: 62, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'promoteYourPostCloseClick' event (evid: 63)
 *
 * Event description: promote_your_post_close_click
 *
 * @param {promoteYourPostCloseClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - x,later,don't show
 * @property {GUID} msid - msid
 * @return {LogObject<promoteYourPostCloseClickParams>} LogObject<promoteYourPostCloseClickParams>
 */
export function promoteYourPostCloseClick(params) {
    return { evid: 63, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'insertGalleryClick' event (evid: 67)
 *
 * Event description: insert_gallery_click
 *
 * @param {insertGalleryClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<insertGalleryClickParams>} LogObject<insertGalleryClickParams>
 */
export function insertGalleryClick(params) {
    return { evid: 67, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'galleryToolbarTypeSelected' event (evid: 68)
 *
 * Event description: gallery_toolbar_type_selected
 *
 * @param {galleryToolbarTypeSelectedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} type - {grid, slideshow}
 * @property {GUID} msid - msid
 * @return {LogObject<galleryToolbarTypeSelectedParams>} LogObject<galleryToolbarTypeSelectedParams>
 */
export function galleryToolbarTypeSelected(params) {
    return { evid: 68, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'galleryToolbarGridColumnsClick' event (evid: 69)
 *
 * Event description: gallery_toolbar_grid_columns_click
 *
 * @param {galleryToolbarGridColumnsClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @property {string} value - num of grid columns
 * @return {LogObject<galleryToolbarGridColumnsClickParams>} LogObject<galleryToolbarGridColumnsClickParams>
 */
export function galleryToolbarGridColumnsClick(params) {
    return { evid: 69, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'galleryToolbarGridSpacingClick' event (evid: 70)
 *
 * Event description: gallery_toolbar_grid_spacing_click
 *
 * @param {galleryToolbarGridSpacingClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @property {string} value - spacing
 * @return {LogObject<galleryToolbarGridSpacingClickParams>} LogObject<galleryToolbarGridSpacingClickParams>
 */
export function galleryToolbarGridSpacingClick(params) {
    return { evid: 70, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'galleryToolbarGridFixedSizeClick' event (evid: 71)
 *
 * Event description: gallery_toolbar_grid_fixed_size_click
 *
 * @param {galleryToolbarGridFixedSizeClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {boolean} status - {0, 1}
 * @property {GUID} msid - msid
 * @return {LogObject<galleryToolbarGridFixedSizeClickParams>} LogObject<galleryToolbarGridFixedSizeClickParams>
 */
export function galleryToolbarGridFixedSizeClick(params) {
    return { evid: 71, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'galleryToolbarOrganizeImagesClick' event (evid: 72)
 *
 * Event description: gallery_toolbar_organize_images_click
 *
 * @param {galleryToolbarOrganizeImagesClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} type - {grid, slideshow}
 * @property {GUID} msid - msid
 * @return {LogObject<galleryToolbarOrganizeImagesClickParams>} LogObject<galleryToolbarOrganizeImagesClickParams>
 */
export function galleryToolbarOrganizeImagesClick(params) {
    return { evid: 72, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'galleryToolbarDeleteClick' event (evid: 73)
 *
 * Event description: gallery_toolbar_delete_click
 *
 * @param {galleryToolbarDeleteClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} type - {grid, slideshow}
 * @property {GUID} msid - msid
 * @return {LogObject<galleryToolbarDeleteClickParams>} LogObject<galleryToolbarDeleteClickParams>
 */
export function galleryToolbarDeleteClick(params) {
    return { evid: 73, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gallerySlideAutoplayClick' event (evid: 74)
 *
 * Event description: gallery_slide_autoplay_click
 *
 * @param {gallerySlideAutoplayClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {boolean} status - {0, 1}
 * @property {GUID} msid - msid
 * @return {LogObject<gallerySlideAutoplayClickParams>} LogObject<gallerySlideAutoplayClickParams>
 */
export function gallerySlideAutoplayClick(params) {
    return { evid: 74, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gallerySlideDelayClick' event (evid: 75)
 *
 * Event description: gallery_slide_delay_click
 *
 * @param {gallerySlideDelayClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @property {string} value - delay
 * @return {LogObject<gallerySlideDelayClickParams>} LogObject<gallerySlideDelayClickParams>
 */
export function gallerySlideDelayClick(params) {
    return { evid: 75, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'textAlignmentSelectedClick' event (evid: 77)
 *
 * Event description: text_alignment_selected_click
 *
 * @param {textAlignmentSelectedClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @property {string} value - {right, left, center, justified}
 * @return {LogObject<textAlignmentSelectedClickParams>} LogObject<textAlignmentSelectedClickParams>
 */
export function textAlignmentSelectedClick(params) {
    return { evid: 77, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'textIndentClick' event (evid: 78)
 *
 * Event description: text_indent_click
 *
 * @param {textIndentClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @property {string} value - {increase, decrease}
 * @return {LogObject<textIndentClickParams>} LogObject<textIndentClickParams>
 */
export function textIndentClick(params) {
    return { evid: 78, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'textLineHeightSelectionClick' event (evid: 79)
 *
 * Event description: text_line_height_selection_click
 *
 * @param {textLineHeightSelectionClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @property {string} value - line height
 * @return {LogObject<textLineHeightSelectionClickParams>} LogObject<textLineHeightSelectionClickParams>
 */
export function textLineHeightSelectionClick(params) {
    return { evid: 79, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'textCharSpacingSelectionClick' event (evid: 80)
 *
 * Event description: text_char_spacing_selection_click
 *
 * @param {textCharSpacingSelectionClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @property {string} value - spacing
 * @return {LogObject<textCharSpacingSelectionClickParams>} LogObject<textCharSpacingSelectionClickParams>
 */
export function textCharSpacingSelectionClick(params) {
    return { evid: 80, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'textDirectionSelectionClick' event (evid: 81)
 *
 * Event description: text_direction_selection_click
 *
 * @param {textDirectionSelectionClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @property {string} value - {RTL, LTR}
 * @return {LogObject<textDirectionSelectionClickParams>} LogObject<textDirectionSelectionClickParams>
 */
export function textDirectionSelectionClick(params) {
    return { evid: 81, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'textRemoveFormatClick' event (evid: 82)
 *
 * Event description: text_remove_format_click
 *
 * @param {textRemoveFormatClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<textRemoveFormatClickParams>} LogObject<textRemoveFormatClickParams>
 */
export function textRemoveFormatClick(params) {
    return { evid: 82, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'videoUrlChangeClick' event (evid: 85)
 *
 * Event description: video_url_change_click
 *
 * @param {videoUrlChangeClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<videoUrlChangeClickParams>} LogObject<videoUrlChangeClickParams>
 */
export function videoUrlChangeClick(params) {
    return { evid: 85, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'promoteYourPostShareIconClick' event (evid: 94)
 *
 * Event description: promote_your_post_share_icon_click
 *
 * @param {promoteYourPostShareIconClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - origin
 * @property {string} platform - null, mobile
 * @property {GUID} msid - msid
 * @return {LogObject<promoteYourPostShareIconClickParams>} LogObject<promoteYourPostShareIconClickParams>
 */
export function promoteYourPostShareIconClick(params) {
    return { evid: 94, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'imageResize' event (evid: 95)
 *
 * Event description: image_resize
 *
 * @param {imageResizeParams} params - The parameters for this event
 * @property {string} resize_method - free, fixed
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {number} image_value - 25,50...
 * @property {GUID} msid - msid
 * @return {LogObject<imageResizeParams>} LogObject<imageResizeParams>
 */
export function imageResize(params) {
    return { evid: 95, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newCategoryClick' event (evid: 96)
 *
 * Event description: new_category_click
 *
 * @param {newCategoryClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - category_tab,post_editor,multi_select
 * @property {GUID} msid - msid
 * @return {LogObject<newCategoryClickParams>} LogObject<newCategoryClickParams>
 */
export function newCategoryClick(params) {
    return { evid: 96, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'renameCategoryClick' event (evid: 97)
 *
 * Event description: rename_category_click
 *
 * @param {renameCategoryClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<renameCategoryClickParams>} LogObject<renameCategoryClickParams>
 */
export function renameCategoryClick(params) {
    return { evid: 97, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteCategoryClick' event (evid: 98)
 *
 * Event description: delete_category_click
 *
 * @param {deleteCategoryClickParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - multi_select,hover
 * @property {GUID} msid - msid
 * @return {LogObject<deleteCategoryClickParams>} LogObject<deleteCategoryClickParams>
 */
export function deleteCategoryClick(params) {
    return { evid: 98, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteCategoryPopup' event (evid: 99)
 *
 * Event description: delete_category_popup
 *
 * @param {deleteCategoryPopupParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} user_agent - user_agent
 * @property {string} origin - delete,not_now,x
 * @property {GUID} msid - msid
 * @return {LogObject<deleteCategoryPopupParams>} LogObject<deleteCategoryPopupParams>
 */
export function deleteCategoryPopup(params) {
    return { evid: 99, src: 12, endpoint: '', params };
}
/**
 * A function to create a log object for the 'crudPostSrc69Evid110' event (evid: 110)
 *
 * Event description: CRUD post (not used).
 *
 * @param {crudPostSrc69Evid110Params} params - The parameters for this event
 * @property {number} image_count - image_count in the post
 * @property {string} event_type_name - created, published, unpublished, updated, soft_deleted, restored, hard_deleted
 * @property {boolean} is_demo - is_demo
 * @property {string} post_title - post title
 * @property {string} role - member role (owner, writer, member)
 * @property {string} url - the post url
 * @property {number} tag_count - tag_count
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {boolean} has_gallery - NOT IN USE: 0 - no gallery / 1 - published with gallery
 * @property {string} referral_info - NOT IN USE: external links - facebook, social networks. if from wix then null
 * @property {number} giphy_count - giphy_count
 * @property {string} tag_ids - array of tags
 * @property {number} categories_count - NOT IN USE: categories_count that post was assigned to
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - language
 * @property {number} character_count - The number of characters on the post
 * @property {string} original_post_id - the original post id
 * @property {string} community_id - community_id
 * @property {GUID} original_instance_id - Currently being used for wix reads posts.in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} translation_id - translation_id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} author_id - author_id
 * @property {string} paid_plan_id - Array of paid plan ids
 * @property {string} member_id - member_id
 * @property {number} video_count - video_count in the post
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @property {string} galleries - will sent as array - [{ layout: 'masonry', count: 5}, { layout: 'whatever', count: 10 }]
 * @property {string} related_post_ids - array with related post Ids
 * @return {LogObject<crudPostSrc69Evid110Params>} LogObject<crudPostSrc69Evid110Params>
 */
export function crudPostSrc69Evid110(params) {
    return { evid: 110, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'crudCategory' event (evid: 111)
 *
 * Event description: CRUD category (not used).
 *
 * @param {crudCategoryParams} params - The parameters for this event
 * @property {string} event_type_name - event_type_name
 * @property {boolean} is_demo - is_demo
 * @property {string} role - member role (owner, writer, member)
 * @property {string} url - url
 * @property {string} description - descritpion
 * @property {number} rank - category_rank
 * @property {string} updated_category_content - updated_category_content
 * @property {string} label - menu_label
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} category_content - array {field_name1: content1, ...} all category fields and its content
 * @property {GUID} original_instance_id - original_instance_id
 * @property {string} category_id - category_id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {string} title - name of category label
 * @property {string} member_id - member_id
 * @return {LogObject<crudCategoryParams>} LogObject<crudCategoryParams>
 */
export function crudCategory(params) {
    return { evid: 111, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'crudTagsSrc69Evid112' event (evid: 112)
 *
 * Event description: CRUD tags (not used).
 *
 * @param {crudTagsSrc69Evid112Params} params - The parameters for this event
 * @property {string} postCount - post_count
 * @property {string} event_type_name - created, deleted
 * @property {boolean} is_demo - is_demo
 * @property {string} role - role
 * @property {string} tagid - tag_id
 * @property {string} slug - slug
 * @property {string} tag_label - label
 * @property {string} publicationCount - publication_count
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {number} character_count - The number of characters on the tag
 * @property {GUID} original_instance_id - Currently being used for wix reads posts.in the members app events. holds the child app (forum/blog) instance_id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {string} member_id - member_id
 * @return {LogObject<crudTagsSrc69Evid112Params>} LogObject<crudTagsSrc69Evid112Params>
 */
export function crudTagsSrc69Evid112(params) {
    return { evid: 112, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'crudPost' event (evid: 115)
 *
 * Event description: triggered when post: Created(Published), Updated, Unpublished, Moved to trash, Deleted
 *
 * @param {crudPostParams} params - The parameters for this event
 * @property {number} image_count - image_count in the post
 * @property {string} event_type_name - created, deleted
 * @property {boolean} is_demo - is_demo
 * @property {string} post_title - post title
 * @property {number} timeToRead - estimated number of minutes to read the post
 * @property {string} role - member role (owner, writer, member)
 * @property {string} url - the category url
 * @property {number} tag_count - tag_count
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {number} giphy_count - count of used  giphy gifs
 * @property {string} tag_ids - array of tags
 * @property {number} timeToRead_ms - time_to_read in milliseconds
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - for multilingual
 * @property {number} character_count - character count in a post
 * @property {string} original_post_id - the original post id
 * @property {GUID} original_instance_id - Currently being used for wix reads posts.in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} translation_id - the post_stable_id of the post that was translated
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} author_id - author id
 * @property {string} paid_plan_id - Array of paid plan ids
 * @property {string} member_id - member_id
 * @property {number} video_count - video_count in the post
 * @property {GUID} service_id - service_id
 * @property {string} gallery_ids - gallery_ids. JSON array string
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @property {string} galleries - galleries
 * @property {string} related_post_ids - array with related post Ids
 * @property {string} save_type - save_type
 * @return {LogObject<crudPostParams>} LogObject<crudPostParams>
 */
export function crudPost(params) {
    return { evid: 115, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'crudCategorySrc69Evid116' event (evid: 116)
 *
 * Event description: CRUD category.
 *
 * @param {crudCategorySrc69Evid116Params} params - The parameters for this event
 * @property {string} event_type_name - created, deleted
 * @property {boolean} is_demo - is_demo
 * @property {string} role - member role (owner, writer, member)
 * @property {string} url - the category url
 * @property {string} description - descritpion
 * @property {number} rank - category_rank
 * @property {string} updated_category_content - array {field_name1: content1, ...} only updated category fields and its content
 * @property {string} label - menu_label
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} category_content - array {field_name1: content1, ...} all category fields and its content
 * @property {GUID} original_instance_id - Currently being used for wix reads posts.in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} seo_content - json seo_content
 * @property {string} category_id - category_id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {string} title - name of category label
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @return {LogObject<crudCategorySrc69Evid116Params>} LogObject<crudCategorySrc69Evid116Params>
 */
export function crudCategorySrc69Evid116(params) {
    return { evid: 116, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'crudTags' event (evid: 117)
 *
 * Event description: triggered when tag: Created (added), Deleted from the post
 *
 * @param {crudTagsParams} params - The parameters for this event
 * @property {number} postCount - post_count
 * @property {string} event_type_name - created, deleted
 * @property {boolean} is_demo - is_demo
 * @property {string} role - member role (owner, writer, member)
 * @property {string} url - the tag url
 * @property {string} tagid - tag id
 * @property {string} slug - slug
 * @property {string} tag_label - label
 * @property {number} publicationCount - publication_count
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {number} character_count - character_count
 * @property {GUID} original_instance_id - Currently being used for wix reads posts.in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} seo_content - json with seo_content
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @return {LogObject<crudTagsParams>} LogObject<crudTagsParams>
 */
export function crudTags(params) {
    return { evid: 117, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiTitlesInsideFullPostGeneratorOverviewIdeasGenerated' event (evid: 126)
 *
 * Event description: When 3 titles are autogenerated inside full post generator
 *
 * @param {aiTitlesInsideFullPostGeneratorOverviewIdeasGeneratedParams} params - The parameters for this event
 * @property {number} input_tokens - input tokens
 * @property {number} output_tokens - output tokens
 * @property {string} ai_tool_type - full_post/outline/post_ideas
 * @property {string} image_cost - image_cost
 * @property {string} origin - overview/post_composer
 * @return {LogObject<aiTitlesInsideFullPostGeneratorOverviewIdeasGeneratedParams>} LogObject<aiTitlesInsideFullPostGeneratorOverviewIdeasGeneratedParams>
 */
export function aiTitlesInsideFullPostGeneratorOverviewIdeasGenerated(params) {
    return { evid: 126, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiTitlesInsideFullPostGeneratorUseRegenerateClick' event (evid: 127)
 *
 * Event description: When titles are chosen or regenerated inside full post/outline generator
 *
 * @param {aiTitlesInsideFullPostGeneratorUseRegenerateClickParams} params - The parameters for this event
 * @property {string} ai_tool_type - full_post/outline
 * @property {string} action - use/regenerate
 * @property {number} input_tokens - input_tokens
 * @property {number} output_tokens - output_tokens
 * @property {string} origin - overview,post_composer
 * @return {LogObject<aiTitlesInsideFullPostGeneratorUseRegenerateClickParams>} LogObject<aiTitlesInsideFullPostGeneratorUseRegenerateClickParams>
 */
export function aiTitlesInsideFullPostGeneratorUseRegenerateClick(params) {
    return { evid: 127, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiFullPostGeneratorNextGenerateButtonClick' event (evid: 128)
 *
 * Event description: Next/generate button click inside fullpost/outline generator
 *
 * @param {aiFullPostGeneratorNextGenerateButtonClickParams} params - The parameters for this event
 * @property {string} additional_info - additional_info
 * @property {string} ai_tool_type - full_post/outline
 * @property {string} action - next/generate
 * @property {string} image_cost - image_cost
 * @property {string} topic - any_topic/product/service/event
 * @return {LogObject<aiFullPostGeneratorNextGenerateButtonClickParams>} LogObject<aiFullPostGeneratorNextGenerateButtonClickParams>
 */
export function aiFullPostGeneratorNextGenerateButtonClick(params) {
    return { evid: 128, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiFullPostGeneratorGenerationSuccess' event (evid: 129)
 *
 * Event description: full post/outline was generated
 *
 * @param {aiFullPostGeneratorGenerationSuccessParams} params - The parameters for this event
 * @property {number} input_tokens - input tokens
 * @property {number} output_tokens - output tokens
 * @property {string} ai_tool_type - full_post/outline
 * @property {string} image_cost - image_cost
 * @property {string} generation_time - generation_time
 * @return {LogObject<aiFullPostGeneratorGenerationSuccessParams>} LogObject<aiFullPostGeneratorGenerationSuccessParams>
 */
export function aiFullPostGeneratorGenerationSuccess(params) {
    return { evid: 129, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'categoryAssignedOnBlogPostInsidePostComposer' event (evid: 130)
 *
 * Event description: Category assigned on post
 *
 * @param {categoryAssignedOnBlogPostInsidePostComposerParams} params - The parameters for this event
 * @property {string} action - assign/unassign
 * @property {string} category_id - category_id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} post_stable_id - post_stable_id
 * @return {LogObject<categoryAssignedOnBlogPostInsidePostComposerParams>} LogObject<categoryAssignedOnBlogPostInsidePostComposerParams>
 */
export function categoryAssignedOnBlogPostInsidePostComposer(params) {
    return { evid: 130, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppTabOpenedInManage' event (evid: 1301)
 *
 * Event description: User opened tab in OneApp Manage section
 *
 * @param {oneAppTabOpenedInManageParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} tab_name - tab name opened in Manage
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppTabOpenedInManageParams>} LogObject<oneAppTabOpenedInManageParams>
 */
export function oneAppTabOpenedInManage(params) {
    return { evid: 1301, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppPostSwipeAction' event (evid: 1303)
 *
 * Event description: User did a swipe action in OneApp
 *
 * @param {oneAppPostSwipeActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {string} tab_name - tab name in Manage (Published/Drafts)
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - language
 * @property {string} origin - Manage
 * @property {string} translation_id - translation_id
 * @property {GUID} msid - msid
 * @property {boolean} is_published - is_published
 * @return {LogObject<oneAppPostSwipeActionParams>} LogObject<oneAppPostSwipeActionParams>
 */
export function oneAppPostSwipeAction(params) {
    return { evid: 1303, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppClickInsideSwipeAction' event (evid: 1304)
 *
 * Event description: User chose action after swipe
 *
 * @param {oneAppClickInsideSwipeActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - stable id
 * @property {string} origin - OneApp Manage
 * @property {GUID} msid - msid
 * @property {string} action - Settings/Edit
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<oneAppClickInsideSwipeActionParams>} LogObject<oneAppClickInsideSwipeActionParams>
 */
export function oneAppClickInsideSwipeAction(params) {
    return { evid: 1304, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppManageFilterPostsClick' event (evid: 1305)
 *
 * Event description: Click on filter post in OneApp (to choose your own or written by others posts)
 *
 * @param {oneAppManageFilterPostsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} tab_name - Published/Dratfs
 * @property {string} filter - Which filter in Wix App is used: Analytics/posts/drafts
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppManageFilterPostsClickParams>} LogObject<oneAppManageFilterPostsClickParams>
 */
export function oneAppManageFilterPostsClick(params) {
    return { evid: 1305, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppManageFilterPostsSaveClick' event (evid: 1306)
 *
 * Event description: Click on filter post in OneApp (to choose your own or written by others posts)
 *
 * @param {oneAppManageFilterPostsSaveClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} filter - Which filter in Wix App is used: Analytics/posts/drafts
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} filter_name - "My Posts"/"Posts by Others"/"All Posts"
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppManageFilterPostsSaveClickParams>} LogObject<oneAppManageFilterPostsSaveClickParams>
 */
export function oneAppManageFilterPostsSaveClick(params) {
    return { evid: 1306, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppManageSearchClicked' event (evid: 1307)
 *
 * Event description: After clicking on search in OneApp manage
 *
 * @param {oneAppManageSearchClickedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppManageSearchClickedParams>} LogObject<oneAppManageSearchClickedParams>
 */
export function oneAppManageSearchClicked(params) {
    return { evid: 1307, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneappManageSearchTextEntered' event (evid: 1308)
 *
 * Event description: After text was entered in search
 *
 * @param {oneappManageSearchTextEnteredParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} text - Text entered in a search
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @return {LogObject<oneappManageSearchTextEnteredParams>} LogObject<oneappManageSearchTextEnteredParams>
 */
export function oneappManageSearchTextEntered(params) {
    return { evid: 1308, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneappManageSearchResults' event (evid: 1309)
 *
 * Event description: Number of posts found in search in OneApp Manage
 *
 * @param {oneappManageSearchResultsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} text - Text entered in a search
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {number} num_posts_found - Number of posts found in search
 * @property {GUID} msid - msid
 * @return {LogObject<oneappManageSearchResultsParams>} LogObject<oneappManageSearchResultsParams>
 */
export function oneappManageSearchResults(params) {
    return { evid: 1309, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tagAssignedOnBlogPostInsidePostComposer' event (evid: 131)
 *
 * Event description: Tag assigned on post
 *
 * @param {tagAssignedOnBlogPostInsidePostComposerParams} params - The parameters for this event
 * @property {string} action - assign/unassign
 * @property {GUID} instance_id - instance_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} tag_id - tag_id
 * @return {LogObject<tagAssignedOnBlogPostInsidePostComposerParams>} LogObject<tagAssignedOnBlogPostInsidePostComposerParams>
 */
export function tagAssignedOnBlogPostInsidePostComposer(params) {
    return { evid: 131, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppManageCategoriesThreeDotsClick' event (evid: 1310)
 *
 * Event description: Number of posts found in search in OneApp Manage
 *
 * @param {oneAppManageCategoriesThreeDotsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {string} category_id - category_id
 * @property {string} translation_id - translation id
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppManageCategoriesThreeDotsClickParams>} LogObject<oneAppManageCategoriesThreeDotsClickParams>
 */
export function oneAppManageCategoriesThreeDotsClick(params) {
    return { evid: 1310, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppManageCategoriesButtonInThreeDotsClicked' event (evid: 1311)
 *
 * Event description: Button in categories three dots meniu clicked
 *
 * @param {oneAppManageCategoriesButtonInThreeDotsClickedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} button_name - button name in three dots categories menu
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {string} category_id - category_id
 * @property {string} translation_id - translation id
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppManageCategoriesButtonInThreeDotsClickedParams>} LogObject<oneAppManageCategoriesButtonInThreeDotsClickedParams>
 */
export function oneAppManageCategoriesButtonInThreeDotsClicked(params) {
    return { evid: 1311, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppManageCategoriesAddNewCategoryClick' event (evid: 1312)
 *
 * Event description: Clicked on add new category button in OneApp
 *
 * @param {oneAppManageCategoriesAddNewCategoryClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppManageCategoriesAddNewCategoryClickParams>} LogObject<oneAppManageCategoriesAddNewCategoryClickParams>
 */
export function oneAppManageCategoriesAddNewCategoryClick(params) {
    return { evid: 1312, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppManageCategoriesEditCategoryOpened' event (evid: 1313)
 *
 * Event description: Clicked on add new category button in OneApp
 *
 * @param {oneAppManageCategoriesEditCategoryOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {string} category_id - category_id
 * @property {string} translation_id - translation id
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppManageCategoriesEditCategoryOpenedParams>} LogObject<oneAppManageCategoriesEditCategoryOpenedParams>
 */
export function oneAppManageCategoriesEditCategoryOpened(params) {
    return { evid: 1313, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppSharePostCopyUrlClick' event (evid: 1314)
 *
 * Event description: user copied url to clipboard (clicked share post)
 *
 * @param {oneAppSharePostCopyUrlClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - after publish
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppSharePostCopyUrlClickParams>} LogObject<oneAppSharePostCopyUrlClickParams>
 */
export function oneAppSharePostCopyUrlClick(params) {
    return { evid: 1314, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppHappyMomentBanners' event (evid: 1315)
 *
 * Event description: User did an action with a banner in Blog Manage
 *
 * @param {oneAppHappyMomentBannersParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} banner_name - banner name - add banner to mobile, share your blog
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @property {string} action - closed, CTA - add banner, CTA - share
 * @return {LogObject<oneAppHappyMomentBannersParams>} LogObject<oneAppHappyMomentBannersParams>
 */
export function oneAppHappyMomentBanners(params) {
    return { evid: 1315, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppSharePostButtonClick' event (evid: 1316)
 *
 * Event description: user clicked on share button in oneapp top bar
 *
 * @param {oneAppSharePostButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - post page, view post etc.
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppSharePostButtonClickParams>} LogObject<oneAppSharePostButtonClickParams>
 */
export function oneAppSharePostButtonClick(params) {
    return { evid: 1316, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppOpenedAllPostsAnalytics' event (evid: 1318)
 *
 * Event description: Whenever a user opens Post Analytics (all posts)
 *
 * @param {oneAppOpenedAllPostsAnalyticsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - user role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} filter_name - The analytics Period (1D, 7D, 28D, all time)
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppOpenedAllPostsAnalyticsParams>} LogObject<oneAppOpenedAllPostsAnalyticsParams>
 */
export function oneAppOpenedAllPostsAnalytics(params) {
    return { evid: 1318, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppWixReadsScreenOpen' event (evid: 1319)
 *
 * Event description: triggered when user sees the home or the explore tabs in wix reads
 *
 * @param {oneAppWixReadsScreenOpenParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} screenName - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site member id
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppWixReadsScreenOpenParams>} LogObject<oneAppWixReadsScreenOpenParams>
 */
export function oneAppWixReadsScreenOpen(params) {
    return { evid: 1319, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppGenericModalShown' event (evid: 1320)
 *
 * Event description: Modal shown - generic event for many different modals.
 *
 * @param {oneAppGenericModalShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} visitor_id - visitor
 * @property {string} modal_name - modal name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin - the previous screen/modal
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppGenericModalShownParams>} LogObject<oneAppGenericModalShownParams>
 */
export function oneAppGenericModalShown(params) {
    return { evid: 1320, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppModalOptionClick' event (evid: 1321)
 *
 * Event description: Generic event to track clicks within a modal in OneApp
 *
 * @param {oneAppModalOptionClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} action_name - the option the user clicked / selected on the modal
 * @property {string} role - role
 * @property {GUID} visitor_id - visitor
 * @property {string} modal_name - modal name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin - the previous screen/modal
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppModalOptionClickParams>} LogObject<oneAppModalOptionClickParams>
 */
export function oneAppModalOptionClick(params) {
    return { evid: 1321, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppActionSheetOptionClick' event (evid: 1323)
 *
 * Event description: Generic event to track clicks within an action sheet in OneApp
 *
 * @param {oneAppActionSheetOptionClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} action_name - the option the user clicked / selected on the modal
 * @property {string} role - role
 * @property {GUID} visitor_id - visitor
 * @property {string} action_sheet_name - action name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - what triggered this action
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppActionSheetOptionClickParams>} LogObject<oneAppActionSheetOptionClickParams>
 */
export function oneAppActionSheetOptionClick(params) {
    return { evid: 1323, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppGenericActionSheetShown' event (evid: 1324)
 *
 * Event description: Action sheet showed - a generic event for many different action sheets.
 *
 * @param {oneAppGenericActionSheetShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} visitor_id - visitor
 * @property {string} action_sheet_name - action sheet name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin - the previous screen/modal
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppGenericActionSheetShownParams>} LogObject<oneAppGenericActionSheetShownParams>
 */
export function oneAppGenericActionSheetShown(params) {
    return { evid: 1324, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppConnectPlanToPost' event (evid: 1325)
 *
 * Event description: triggered in OneApp when the user connects a plan to a post(s)
 *
 * @param {oneAppConnectPlanToPostParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_ids - Array of posts
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} translation_id - translation id
 * @property {string} paid_plan_id - Array paid plan Ids
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppConnectPlanToPostParams>} LogObject<oneAppConnectPlanToPostParams>
 */
export function oneAppConnectPlanToPost(params) {
    return { evid: 1325, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppGenericButtonClick' event (evid: 1326)
 *
 * Event description: the user clicked on a button
 *
 * @param {oneAppGenericButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {string} button_name - the button name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - post page
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppGenericButtonClickParams>} LogObject<oneAppGenericButtonClickParams>
 */
export function oneAppGenericButtonClick(params) {
    return { evid: 1326, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppCustomizeBlogSections' event (evid: 1327)
 *
 * Event description: When a user clicks customize from the admin menu on the blog tab. One app only!
 *
 * @param {oneAppCustomizeBlogSectionsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} tab_name - tab name (member view or place card)
 * @property {string} section - which section is being edited. (header, navigation tabs, category list etc..)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Post Page Settings, app settings (feed)
 * @property {string} property_value - The setting value
 * @property {string} app_id - app_id
 * @property {string} property - The setting name
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppCustomizeBlogSectionsParams>} LogObject<oneAppCustomizeBlogSectionsParams>
 */
export function oneAppCustomizeBlogSections(params) {
    return { evid: 1327, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'followUnfollowCategoryClickWixReads' event (evid: 1328)
 *
 * Event description: When the user clicks to follow or unfollow
 *
 * @param {followUnfollowCategoryClickWixReadsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} category_name - category name
 * @property {boolean} is_followed - 1- followed, 0 - unfollowed
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {string} category_id - category id
 * @property {GUID} msid - msid
 * @return {LogObject<followUnfollowCategoryClickWixReadsParams>} LogObject<followUnfollowCategoryClickWixReadsParams>
 */
export function followUnfollowCategoryClickWixReads(params) {
    return { evid: 1328, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customizeChooseCategoriesClickWixReads' event (evid: 1329)
 *
 * Event description: When the user clicks on the Customise or Choose now links on the main screen on wix reads, that link will take the user to the "Edit Categories" screen
 *
 * @param {customizeChooseCategoriesClickWixReadsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {string} click_name - choose now, customise
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<customizeChooseCategoriesClickWixReadsParams>} LogObject<customizeChooseCategoriesClickWixReadsParams>
 */
export function customizeChooseCategoriesClickWixReads(params) {
    return { evid: 1329, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiButtonInsideBmClickSrc69Evid133' event (evid: 133)
 *
 * Event description: When an AI button in BM is clicked
 *
 * @param {aiButtonInsideBmClickSrc69Evid133Params} params - The parameters for this event
 * @property {string} origin - overview/posts/etc
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<aiButtonInsideBmClickSrc69Evid133Params>} LogObject<aiButtonInsideBmClickSrc69Evid133Params>
 */
export function aiButtonInsideBmClickSrc69Evid133(params) {
    return { evid: 133, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppCategoryPage3DotsClick' event (evid: 1330)
 *
 * Event description: When the user clicks on the 3 dots button on the category page in OneApp
 *
 * @param {oneAppCategoryPage3DotsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - category page
 * @property {string} category_id - category_id
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppCategoryPage3DotsClickParams>} LogObject<oneAppCategoryPage3DotsClickParams>
 */
export function oneAppCategoryPage3DotsClick(params) {
    return { evid: 1330, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppBlogPageSettingsScreenOpened' event (evid: 1331)
 *
 * Event description: User opens the blog Page screen settings
 *
 * @param {oneAppBlogPageSettingsScreenOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - from where did the user get to this screen
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppBlogPageSettingsScreenOpenedParams>} LogObject<oneAppBlogPageSettingsScreenOpenedParams>
 */
export function oneAppBlogPageSettingsScreenOpened(params) {
    return { evid: 1331, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppBlogPageSettingsChanged' event (evid: 1332)
 *
 * Event description: User opens the blog Page screen settings
 *
 * @param {oneAppBlogPageSettingsChangedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} tab_name - Post or Category
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - from where did the user get to this screen
 * @property {string} property_value - property value
 * @property {string} property - property
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppBlogPageSettingsChangedParams>} LogObject<oneAppBlogPageSettingsChangedParams>
 */
export function oneAppBlogPageSettingsChanged(params) {
    return { evid: 1332, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppEditCategory' event (evid: 1333)
 *
 * Event description: User edited a category
 *
 * @param {oneAppEditCategoryParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} category_image - category image
 * @property {string} role - member role (owner, writer, member)
 * @property {string} category_name - category label
 * @property {string} category_description - category description
 * @property {string} categoryTitle - category title
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} origin - from where did the user get to this screen
 * @property {string} category_id - category id
 * @property {string} translation_id - translation_id
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppEditCategoryParams>} LogObject<oneAppEditCategoryParams>
 */
export function oneAppEditCategory(params) {
    return { evid: 1333, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppBlogOnboardingStepsButtonClick' event (evid: 1334)
 *
 * Event description: The user clicked a button on the onboarding
 *
 * @param {oneAppBlogOnboardingStepsButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {string} step_name - add your first post, invite members etc..
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} button_name - add post, skip, undo etc...
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - manage blog
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppBlogOnboardingStepsButtonClickParams>} LogObject<oneAppBlogOnboardingStepsButtonClickParams>
 */
export function oneAppBlogOnboardingStepsButtonClick(params) {
    return { evid: 1334, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppBlogSearchClicked' event (evid: 1335)
 *
 * Event description: After clicking on search in OneApp blog home
 *
 * @param {oneAppBlogSearchClickedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppBlogSearchClickedParams>} LogObject<oneAppBlogSearchClickedParams>
 */
export function oneAppBlogSearchClicked(params) {
    return { evid: 1335, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppBlogSearchResultClicked' event (evid: 1338)
 *
 * Event description: After clicking on search in OneApp blog home
 *
 * @param {oneAppBlogSearchResultClickedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post id
 * @property {string} tagid - tag id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {string} category_id - category id
 * @property {GUID} author_id - author id
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppBlogSearchResultClickedParams>} LogObject<oneAppBlogSearchResultClickedParams>
 */
export function oneAppBlogSearchResultClicked(params) {
    return { evid: 1338, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppPreviousNextPostArrowClick' event (evid: 1339)
 *
 * Event description: the user clicked on the previous or next post within the post page
 *
 * @param {oneAppPreviousNextPostArrowClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - post page
 * @property {GUID} msid - msid
 * @property {string} action - previous or next post
 * @return {LogObject<oneAppPreviousNextPostArrowClickParams>} LogObject<oneAppPreviousNextPostArrowClickParams>
 */
export function oneAppPreviousNextPostArrowClick(params) {
    return { evid: 1339, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogNewPostPageSettingsChangedSrc69Evid134' event (evid: 134)
 *
 * Event description: When blog settings are changed inside the new post page
 *
 * @param {blogNewPostPageSettingsChangedSrc69Evid134Params} params - The parameters for this event
 * @property {string} component_id - component_id
 * @property {string} field - field
 * @property {string} value - value
 * @property {string} action_name - action_name
 * @return {LogObject<blogNewPostPageSettingsChangedSrc69Evid134Params>} LogObject<blogNewPostPageSettingsChangedSrc69Evid134Params>
 */
export function blogNewPostPageSettingsChangedSrc69Evid134(params) {
    return { evid: 134, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppWidgetClick' event (evid: 1340)
 *
 * Event description: Tracks what the user clicked on any widget on the app
 *
 * @param {oneAppWidgetClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} click_name - the label on the object clicked
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post id - null if the click was not on a post
 * @property {string} widget_name - widget name
 * @property {GUID} post_stable_id - post stable id - null if the click was not on a post
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppWidgetClickParams>} LogObject<oneAppWidgetClickParams>
 */
export function oneAppWidgetClick(params) {
    return { evid: 1340, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppPostPreview' event (evid: 1341)
 *
 * Event description: Triggered when user previews a post on the owners app
 *
 * @param {oneAppPostPreviewParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - where was the preview triggered: post list, post editor
 * @property {string} preview_type - the preview type: desktop, mobile browser, wix app
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppPostPreviewParams>} LogObject<oneAppPostPreviewParams>
 */
export function oneAppPostPreview(params) {
    return { evid: 1341, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppReportPostClick' event (evid: 1342)
 *
 * Event description: event for reporting a post in OneApp
 *
 * @param {oneAppReportPostClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - site_member role
 * @property {string} post_id - post_id of the reported post
 * @property {GUID} post_stable_id - post_stable_id of the reported post
 * @property {string} origin - where the report click happened from (currently only under three dots)
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppReportPostClickParams>} LogObject<oneAppReportPostClickParams>
 */
export function oneAppReportPostClick(params) {
    return { evid: 1342, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogCardShown' event (evid: 1343)
 *
 * Event description: When a specific card is shown in Blog, e.g. regarding WP import status
 *
 * @param {blogCardShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} values_json - what is shown in the card
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} card_name - name of the card, e.g.: "post_importer"
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<blogCardShownParams>} LogObject<blogCardShownParams>
 */
export function blogCardShown(params) {
    return { evid: 1343, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'actionInsideBlogCard' event (evid: 1344)
 *
 * Event description: When an action is clicked inside Blog card, e.g. in WP importer status card.
 *
 * @param {actionInsideBlogCardParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} card_name - card_name
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @property {string} action - "view_posts_to_copy"/"contact_support"
 * @return {LogObject<actionInsideBlogCardParams>} LogObject<actionInsideBlogCardParams>
 */
export function actionInsideBlogCard(params) {
    return { evid: 1344, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ratingsCommentsToggleInBlogBm' event (evid: 1348)
 *
 * Event description: When Ratings or Comments are toggled on/off in Blog BM settings.
 *
 * @param {ratingsCommentsToggleInBlogBmParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} toggle - true/false
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} type - comments/ratings
 * @property {GUID} msid - msid
 * @return {LogObject<ratingsCommentsToggleInBlogBmParams>} LogObject<ratingsCommentsToggleInBlogBmParams>
 */
export function ratingsCommentsToggleInBlogBm(params) {
    return { evid: 1348, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ratingsCommentsSubToggleInBlogBm' event (evid: 1349)
 *
 * Event description: When a sub-toggle is chosen in Ratings / Comments settings in Blog BM.
 *
 * @param {ratingsCommentsSubToggleInBlogBmParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} toggle - true/false
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} type - ratings/comments
 * @property {GUID} msid - msid
 * @property {string} value - members_only/everyone/ratings_mandatory
 * @return {LogObject<ratingsCommentsSubToggleInBlogBmParams>} LogObject<ratingsCommentsSubToggleInBlogBmParams>
 */
export function ratingsCommentsSubToggleInBlogBm(params) {
    return { evid: 1349, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'multilingualAutoTranslateSuccess' event (evid: 1351)
 *
 * Event description: When user finishes auto translating
 *
 * @param {multilingualAutoTranslateSuccessParams} params - The parameters for this event
 * @property {GUID} instance_id - blog instance_id
 * @property {GUID} biToken - msid
 * @property {string} selected_langauge - the selected language
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} original_language - the original language of post
 * @property {number} credits_required - how many credits were required to translate the post
 * @property {number} credits_after - how many credits were available after the translation
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - where the autotranslate happened from: post_list/post_editor
 * @property {number} credits_before - how many credits were available before the translation
 * @property {GUID} msid - msid
 * @return {LogObject<multilingualAutoTranslateSuccessParams>} LogObject<multilingualAutoTranslateSuccessParams>
 */
export function multilingualAutoTranslateSuccess(params) {
    return { evid: 1351, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'multilingualError' event (evid: 1352)
 *
 * Event description: When a user encounters a multilingual related error
 *
 * @param {multilingualErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} errorMessage - the message which is displayed in the error
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<multilingualErrorParams>} LogObject<multilingualErrorParams>
 */
export function multilingualError(params) {
    return { evid: 1352, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'multilingualPostEditorAddTranslationClick' event (evid: 1353)
 *
 * Event description: When a user clicks on add translation in post editor
 *
 * @param {multilingualPostEditorAddTranslationClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {GUID} msid - msid
 * @return {LogObject<multilingualPostEditorAddTranslationClickParams>} LogObject<multilingualPostEditorAddTranslationClickParams>
 */
export function multilingualPostEditorAddTranslationClick(params) {
    return { evid: 1353, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'threeDotsClickInTagTab' event (evid: 1354)
 *
 * Event description: When a user clicks three dots in a tag tab in blog manager
 *
 * @param {threeDotsClickInTagTabParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} tag_guid - the stable id for tags
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} tagid - tag_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {string} tag_name - tag name
 * @return {LogObject<threeDotsClickInTagTabParams>} LogObject<threeDotsClickInTagTabParams>
 */
export function threeDotsClickInTagTab(params) {
    return { evid: 1354, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'actionInsideThreeDotsClickInTagTab' event (evid: 1355)
 *
 * Event description: When a user clicks three dots in a tag tab in blog manager
 *
 * @param {actionInsideThreeDotsClickInTagTabParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} tag_guid - the stable id for tags
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} tagid - tag_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {string} tag_name - tag name
 * @property {string} action - action
 * @return {LogObject<actionInsideThreeDotsClickInTagTabParams>} LogObject<actionInsideThreeDotsClickInTagTabParams>
 */
export function actionInsideThreeDotsClickInTagTab(params) {
    return { evid: 1355, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'monetizationTabClick' event (evid: 1356)
 *
 * Event description: All of the clicks inside of monetization tab
 *
 * @param {monetizationTabClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} name - name of the click
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} parent_name - tools/video/articles
 * @property {string} additional_info - json with additional info, e.g. article link
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<monetizationTabClickParams>} LogObject<monetizationTabClickParams>
 */
export function monetizationTabClick(params) {
    return { evid: 1356, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogNotificationShown' event (evid: 1357)
 *
 * Event description: When a notification in Blog is being shown
 *
 * @param {blogNotificationShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - where a notification is being shown
 * @property {string} content - what is written in the notification
 * @property {GUID} msid - msid
 * @return {LogObject<blogNotificationShownParams>} LogObject<blogNotificationShownParams>
 */
export function blogNotificationShown(params) {
    return { evid: 1357, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogNotificationButtonClick' event (evid: 1358)
 *
 * Event description: When a button is clicked in the blog notification
 *
 * @param {blogNotificationButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} button_name - button_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - where the notification was shown
 * @property {string} content - what is written in the notification
 * @property {GUID} msid - msid
 * @return {LogObject<blogNotificationButtonClickParams>} LogObject<blogNotificationButtonClickParams>
 */
export function blogNotificationButtonClick(params) {
    return { evid: 1358, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reinstallationModalShown' event (evid: 1359)
 *
 * Event description: When a Blog reinstallation modal is shown in Editor.
 *
 * @param {reinstallationModalShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} entryPoint - from where the installation was triggered
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<reinstallationModalShownParams>} LogObject<reinstallationModalShownParams>
 */
export function reinstallationModalShown(params) {
    return { evid: 1359, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reinstallationModalAction' event (evid: 1360)
 *
 * Event description: When a user clicks on the reinstallation modal in Editor.
 *
 * @param {reinstallationModalActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {string} action - what was chosen in the modal
 * @return {LogObject<reinstallationModalActionParams>} LogObject<reinstallationModalActionParams>
 */
export function reinstallationModalAction(params) {
    return { evid: 1360, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'categoriesTabGenericAction' event (evid: 1365)
 *
 * Event description: Clicks inside categories tab
 *
 * @param {categoriesTabGenericActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} category_id - category_id
 * @property {GUID} msid - msid
 * @property {string} action - action
 * @return {LogObject<categoriesTabGenericActionParams>} LogObject<categoriesTabGenericActionParams>
 */
export function categoriesTabGenericAction(params) {
    return { evid: 1365, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'categoriesTabBulkAction' event (evid: 1366)
 *
 * Event description: Categories tab bulk action
 *
 * @param {categoriesTabBulkActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} category_ids - json with selected categories
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {string} action - what action was done
 * @return {LogObject<categoriesTabBulkActionParams>} LogObject<categoriesTabBulkActionParams>
 */
export function categoriesTabBulkAction(params) {
    return { evid: 1366, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogPostPageWidgetElementsActionsSrc69Evid144' event (evid: 144)
 *
 * Event description: Blog post page widget elements actions
 *
 * @param {blogPostPageWidgetElementsActionsSrc69Evid144Params} params - The parameters for this event
 * @property {string} element - header, content, footer, etc
 * @property {string} value - true, false
 * @return {LogObject<blogPostPageWidgetElementsActionsSrc69Evid144Params>} LogObject<blogPostPageWidgetElementsActionsSrc69Evid144Params>
 */
export function blogPostPageWidgetElementsActionsSrc69Evid144(params) {
    return { evid: 144, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postPublishedServer' event (evid: 2)
 *
 * Event description: triggered when a post is published or when a post is migrated (both OId Blog and WP migrations)
 *
 * @param {postPublishedServerParams} params - The parameters for this event
 * @property {boolean} is_demo - is_demo
 * @property {boolean} is_edited - 0 - new post / 1 - edit (to know if its posted for first time)
 * @property {string} post_title - title
 * @property {string} role - member role (owner, writer, member)
 * @property {string} url - url
 * @property {GUID} biToken - msid
 * @property {string} post_id - post_id
 * @property {string} tag_ids - array of tags
 * @property {GUID} post_stable_id - new id released in aug 2020, post stable id - this id does not change if the post gets duplicated or rebloged
 * @property {string} language - for multilingual
 * @property {string} origin - scheduled / old blog migration / wp migration / user action
 * @property {GUID} original_instance_id - If post is migrated from old blog original instance Id
 * @property {string} oridginalPostId - The original post_id (only if Migrated from old Blog)
 * @property {DateTime} last_publish_date - last publish date
 * @property {string} translation_id - the post_stable_id of the translated post
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} author_id - author id
 * @property {string} paid_plan_id - Array of the paid plan ids
 * @property {string} member_id - member_id
 * @property {GUID} service_id - service_id
 * @property {GUID} instance_id - instance_id
 * @property {string} template_id - post template id
 * @property {string} cover_image_url - url to the cover image
 * @property {string} related_post_ids - array with related post ids
 * @return {LogObject<postPublishedServerParams>} LogObject<postPublishedServerParams>
 */
export function postPublishedServer(params) {
    return { evid: 2, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'homePageOpened' event (evid: 200)
 *
 * Event description: triggered when blog home page opened
 *
 * @param {homePageOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @return {LogObject<homePageOpenedParams>} LogObject<homePageOpenedParams>
 */
export function homePageOpened(params) {
    return { evid: 200, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ssr' event (evid: 2001)
 *
 * Event description: SSR timing
 *
 * @param {ssrParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitorId - visitor_id
 * @property {string} context - Where from it came (widget, app, etc)
 * @property {number} total_duration - duration in ms
 * @property {number} ssr_total_duration - total request durration, ms
 * @property {boolean} is_seo - 1 - SEO, 0 - not
 * @property {number} ssr_fetch_duration - Fetch duration, ms
 * @property {number} ssr_react_duration - react duration, ms
 * @property {GUID} metaSiteId - msid
 * @return {LogObject<ssrParams>} LogObject<ssrParams>
 */
export function ssr(params) {
    return { evid: 2001, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'performanceClientSide' event (evid: 2003)
 *
 * Event description: Tracking performance when a user opens the blog
 *
 * @param {performanceClientSideParams} params - The parameters for this event
 * @property {GUID} instance_id - instance id
 * @property {number} initial_connection_time - from browser, in ms
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} biToken - msid
 * @property {string} context - where it came from
 * @property {GUID} visitor_id - visitor_id
 * @property {number} content_transfer_time - only html, in ms
 * @property {number} dom_content_load - images, in ms
 * @property {number} dom_interactive - CSS and JS download + parsing + execution, in ms
 * @property {GUID} post_stable_id - post_stable_id
 * @property {number} content_transfer_size - only html in KB
 * @return {LogObject<performanceClientSideParams>} LogObject<performanceClientSideParams>
 */
export function performanceClientSide(params) {
    return { evid: 2003, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'categoryPageOpened' event (evid: 201)
 *
 * Event description: triggered when blog category page opened
 *
 * @param {categoryPageOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_name - category name
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {string} category_id - category_id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @return {LogObject<categoryPageOpenedParams>} LogObject<categoryPageOpenedParams>
 */
export function categoryPageOpened(params) {
    return { evid: 201, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postPageOpened' event (evid: 202)
 *
 * Event description: triggered when post page opened
 *
 * @param {postPageOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {number} paid_plan_has_access - 1 - has access, 0 - don't have access, null - not paid post
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - new immutable post id
 * @property {string} language - post language (multilingual)
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - new id (contact_id in members enriched table?)
 * @property {string} paid_plan_id - list (array) of paid plan ids
 * @property {Url} referrer - URL from where did the user come
 * @property {string} member_id - member_id - Old not used anymore
 * @property {string} reading_session_id - user reading session id
 * @property {string} referral_post_id - the post_id that got the user here
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<postPageOpenedParams>} LogObject<postPageOpenedParams>
 */
export function postPageOpened(params) {
    return { evid: 202, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postPublished' event (evid: 203)
 *
 * Event description: triggered when post published
 *
 * @param {postPublishedParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {number} image_count - image_count in the post
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} is_edited - 0 - new post / 1 - edit (to know if its posted for first time)
 * @property {string} role - member role (owner, writer, member)
 * @property {string} url - url
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {boolean} has_gallery - NOT IN USE: 0 - no gallery / 1 - published with gallery
 * @property {string} referral_info - NOT IN USE: external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor_id
 * @property {string} gallery_layout - NOT IN USE: type of the gallery
 * @property {number} giphy_count - count of used  giphy gifs
 * @property {string} tag_ids - array of tags
 * @property {number} categories_count - NOT IN USE: categories_count that post was assigned to
 * @property {boolean} used_html - 0 - didnt used html component / 1 - used html component
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - for multilingual
 * @property {number} character_count - The number of characters on the post
 * @property {string} community_id - NOT IN USE: community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {string} translation_id - the post_stable_id of the translated post
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} author_id - author id
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @property {number} video_count - video_count in the post
 * @property {number} gallery_image_count - NOT IN USE: gallery_image_count
 * @property {boolean} is_published - NOT IN USE (always 1) 0 - not published (draft) / 1 - published
 * @property {string} galleries - will sent as array - [{ layout: 'masonry', count: 5}, { layout: 'whatever', count: 10 }]
 * @property {string} related_post_ids - array of post ids
 * @return {LogObject<postPublishedParams>} LogObject<postPublishedParams>
 */
export function postPublished(params) {
    return { evid: 203, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'commentPublished' event (evid: 204)
 *
 * Event description: triggered when UoU published a comment
 *
 * @param {commentPublishedParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {number} image_count - image_count in the post
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} is_edited - 0 - new post / 1 - edit (to know if its posted for first time)
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor_id
 * @property {number} giphy_count - count of used  giphy gifs
 * @property {string} comment_id - the id of the comment
 * @property {GUID} post_stable_id - immutable post_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @property {number} video_count - video_count in the post
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<commentPublishedParams>} LogObject<commentPublishedParams>
 */
export function commentPublished(params) {
    return { evid: 204, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postDraftCreatedSrc69Evid205' event (evid: 205)
 *
 * Event description: triggered when a post draft is created (first save)
 *
 * @param {postDraftCreatedSrc69Evid205Params} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} post_id - post_id
 * @property {string} referral_info - NOT IN USE: external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_translation - 1- translation, 0  - no translation
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - for multilingual
 * @property {string} community_id - NOT IN USE: community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<postDraftCreatedSrc69Evid205Params>} LogObject<postDraftCreatedSrc69Evid205Params>
 */
export function postDraftCreatedSrc69Evid205(params) {
    return { evid: 205, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postDeletedSrc69Evid206' event (evid: 206)
 *
 * Event description: triggered when post deleted
 *
 * @param {postDeletedSrc69Evid206Params} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<postDeletedSrc69Evid206Params>} LogObject<postDeletedSrc69Evid206Params>
 */
export function postDeletedSrc69Evid206(params) {
    return { evid: 206, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postEditorOpened' event (evid: 207)
 *
 * Event description: triggered when post editor opened
 *
 * @param {postEditorOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} post_id - post_id
 * @property {string} referral_info - NOT IN USE: external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} community_id - NOT IN USE: community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<postEditorOpenedParams>} LogObject<postEditorOpenedParams>
 */
export function postEditorOpened(params) {
    return { evid: 207, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'writeNewPostClickSrc69Evid208' event (evid: 208)
 *
 * Event description: triggered when click on write new post CTA
 *
 * @param {writeNewPostClickSrc69Evid208Params} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor_id
 * @property {string} page_name - page from where the user clicke
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @return {LogObject<writeNewPostClickSrc69Evid208Params>} LogObject<writeNewPostClickSrc69Evid208Params>
 */
export function writeNewPostClickSrc69Evid208(params) {
    return { evid: 208, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'likeClick' event (evid: 209)
 *
 * Event description: triggered when uou clicking like or unlike
 *
 * @param {likeClickParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} post_id - post_id
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comment_id - comment_id of like clicked (can be used to separate like clicks between comments and posts). Currently OneApp only
 * @property {GUID} post_stable_id - new immutable post_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {boolean} flag - 0 - unliked / 1 - like
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {number} likes_count - current like count in the site
 * @property {string} member_id - member_id
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<likeClickParams>} LogObject<likeClickParams>
 */
export function likeClick(params) {
    return { evid: 209, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scrollPositionInPostForReadingTime' event (evid: 2101)
 *
 * Event description: To monitor scroll position inside post page
 *
 * @param {scrollPositionInPostForReadingTimeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} scrolled_top - how much scrolled on the top of the screen
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {number} bottom_position - position of the bottom of the post in a page
 * @property {GUID} biToken - msid
 * @property {string} post_id - post_id
 * @property {number} scrollable_heights - whole page scrollable height (if we are sending everything just while viewing the post, might not be needed)
 * @property {GUID} visitor_id - visitor_id
 * @property {number} browser_width - width of the browser (Just nice to have, not yet know if we will use it; just Medium sends it)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {number} percent_scrolled - percentage of scrolled in a post page (just for analytics and just nice to have)
 * @property {number} timediff - time diff from the start of the session
 * @property {DateTime} view_start - when the view started
 * @property {string} reading_session_id - for each post reading generate id; to be able to join between scroll events and active screen event
 * @property {number} scrolled_bottom - how much scrolled on the bottom of the screen
 * @property {number} top_position - position of the top of the post in a page
 * @return {LogObject<scrollPositionInPostForReadingTimeParams>} LogObject<scrollPositionInPostForReadingTimeParams>
 */
export function scrollPositionInPostForReadingTime(params) {
    return { evid: 2101, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'activeScreenTimeInPostForReadingTime' event (evid: 2102)
 *
 * Event description: To monitor scroll position inside post page
 *
 * @param {activeScreenTimeInPostForReadingTimeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} biToken - msid
 * @property {string} post_id - post_id
 * @property {boolean} is_on - indicate with TRUE if visitor has turned on the tab and FALSE if switched off tab with a post
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} reading_session_id - for each post reading generate id; to be able to join between scroll events and active screen event
 * @return {LogObject<activeScreenTimeInPostForReadingTimeParams>} LogObject<activeScreenTimeInPostForReadingTimeParams>
 */
export function activeScreenTimeInPostForReadingTime(params) {
    return { evid: 2102, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppHidePost' event (evid: 2103)
 *
 * Event description: Hide/unhide post action in OneApp.
 *
 * @param {oneAppHidePostParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - valid, if the action happened in discovery page
 * @property {GUID} biToken - msid
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} reason - selected reason for hiding the post
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} action - hide/unhide (unhide - if presses undo)
 * @return {LogObject<oneAppHidePostParams>} LogObject<oneAppHidePostParams>
 */
export function oneAppHidePost(params) {
    return { evid: 2103, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogWidgetLoadStart' event (evid: 2104)
 *
 * Event description: Blog widget load start
 *
 * @param {blogWidgetLoadStartParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} widget_id - widget_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} page_id - page_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {Url} page_url - page_url
 * @return {LogObject<blogWidgetLoadStartParams>} LogObject<blogWidgetLoadStartParams>
 */
export function blogWidgetLoadStart(params) {
    return { evid: 2104, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogWidgetLoadFinish' event (evid: 2105)
 *
 * Event description: Blog widget load finish
 *
 * @param {blogWidgetLoadFinishParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} duration - duration
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} widget_id - widget_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} page_id - page_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {Url} page_url - page_url
 * @return {LogObject<blogWidgetLoadFinishParams>} LogObject<blogWidgetLoadFinishParams>
 */
export function blogWidgetLoadFinish(params) {
    return { evid: 2105, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newCategoryAddedToBlog' event (evid: 211)
 *
 * Event description: triggered when a new category added in the app settings
 *
 * @param {newCategoryAddedToBlogParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor_id
 * @property {number} category_count - current amount of categories i the blog
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor, avdanced_post_settings
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} category_id - category_id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @return {LogObject<newCategoryAddedToBlogParams>} LogObject<newCategoryAddedToBlogParams>
 */
export function newCategoryAddedToBlog(params) {
    return { evid: 211, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnTag' event (evid: 212)
 *
 * Event description: triggered whenever a user clicks on a tag
 *
 * @param {clickOnTagParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} biToken - msid
 * @property {string} post_id - post id if tag was in the post page
 * @property {string} tagid - tag id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - where did the action take place
 * @property {string} tag_name - tag name
 * @return {LogObject<clickOnTagParams>} LogObject<clickOnTagParams>
 */
export function clickOnTag(params) {
    return { evid: 212, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharePostModalOpenClick' event (evid: 213)
 *
 * Event description: triggered when uou clicks on share on three dots to open share modal
 *
 * @param {sharePostModalOpenClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place - feed/post
 * @property {string} member_id - member_id
 * @return {LogObject<sharePostModalOpenClickParams>} LogObject<sharePostModalOpenClickParams>
 */
export function sharePostModalOpenClick(params) {
    return { evid: 213, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharePostClick' event (evid: 214)
 *
 * Event description: triggered when uou clicks on share on three dots
 *
 * @param {sharePostClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - new immutable post_id
 * @property {string} origin - which page the action took place - feed/post/modal
 * @property {string} member_id - member_id
 * @property {string} shareType - Which share method was chosen - Facebook/Linkedin/Copy Url, etc
 * @return {LogObject<sharePostClickParams>} LogObject<sharePostClickParams>
 */
export function sharePostClick(params) {
    return { evid: 214, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogFeedPostPageSearch' event (evid: 216)
 *
 * Event description: triggered when the user uses the search box on the blog feed and on the blog page.
 *
 * @param {blogFeedPostPageSearchParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} search_term - the text input
 * @property {GUID} post_stable_id - post stable id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - the member Id on the site
 * @return {LogObject<blogFeedPostPageSearchParams>} LogObject<blogFeedPostPageSearchParams>
 */
export function blogFeedPostPageSearch(params) {
    return { evid: 216, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileUploadedSrc69Evid217' event (evid: 217)
 *
 * Event description: Event triggered when a person tries to upload a file to a Blog post
 *
 * @param {fileUploadedSrc69Evid217Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} file_ext - File extension
 * @property {boolean} success - 0 - upload failed / 1 - upload successful
 * @property {string} screen_name - screen_name
 * @property {string} file_id - The file identifier (null if not successful)
 * @property {string} role - role
 * @property {GUID} biToken - metasite id
 * @property {number} file_size - The size of the file being uploaded (in bytes)
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} mime_type - File type
 * @property {string} origin - post (for now just post)
 * @property {GUID} site_member_id - site_member_id
 * @return {LogObject<fileUploadedSrc69Evid217Params>} LogObject<fileUploadedSrc69Evid217Params>
 */
export function fileUploadedSrc69Evid217(params) {
    return { evid: 217, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newEvent' event (evid: 218)
 *
 * Event description: When error page is shown in Blog app, i.e.
 * "We Couldn’t Find This Page
 * Check out some of the other great posts in this blog."
 *
 * @param {newEventParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role in blog
 * @property {GUID} biToken - msid
 * @property {string} pathname - link to post/feed
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} page_type - Feed or Post
 * @return {LogObject<newEventParams>} LogObject<newEventParams>
 */
export function newEvent(params) {
    return { evid: 218, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileDownloaded' event (evid: 219)
 *
 * Event description: Event triggered when a person tries to download a file from a blog post
 *
 * @param {fileDownloadedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} file_ext - File extension
 * @property {boolean} success - 0 - no download link / 1 - download link received
 * @property {string} screen_name - screen_name
 * @property {string} file_id - The file identifier
 * @property {string} role - role
 * @property {GUID} biToken - msid
 * @property {number} file_size - The size of the file being downloaded (in bytes)
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} mime_type - File type
 * @property {string} origin - post
 * @property {GUID} site_member_id - site_member_id
 * @return {LogObject<fileDownloadedParams>} LogObject<fileDownloadedParams>
 */
export function fileDownloaded(params) {
    return { evid: 219, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'categoryLabelClick' event (evid: 220)
 *
 * Event description: triggered when uou clicks on a category label
 *
 * @param {categoryLabelClickParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_name - category name
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {boolean} is_main - is the label clicked main category?
 * @property {string} category_id - category_id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site member id
 * @return {LogObject<categoryLabelClickParams>} LogObject<categoryLabelClickParams>
 */
export function categoryLabelClick(params) {
    return { evid: 220, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'advancedPostSettingsDoneClickSrc69Evid223' event (evid: 223)
 *
 * Event description: Clicking Done in advance post settings
 *
 * @param {advancedPostSettingsDoneClickSrc69Evid223Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {boolean} is_changed_search_engine_title - Changed search engine title
 * @property {string} screen_name - screen_name
 * @property {boolean} is_excerpt_written - 1 - added text, 0 - didn't
 * @property {string} role - Role of user - writer or admin
 * @property {GUID} biToken - MSID
 * @property {boolean} is_on_feature_post_toggle - 1 - on, 0 - off
 * @property {GUID} visitor_id - visitor_id
 * @property {string} button_name - Save, Save and Publish
 * @property {boolean} is_publish_date_edited - Post publish date edited
 * @property {boolean} is_author_changed - User changed author
 * @property {number} categories_chosen - How many categories was chosen
 * @property {boolean} is_written_description - Written a description
 * @property {GUID} post_stable_id - post_stable_id
 * @property {boolean} is_changed_excerpt - If excerpt was changed
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @property {boolean} is_changed_url - Changed URL
 * @property {boolean} is_cover_image_changed - Changed cover image
 * @property {boolean} is_published - Is post published (1-published)
 * @property {boolean} is_on_display_cover_toggle - 1 - on, 0 - off
 * @return {LogObject<advancedPostSettingsDoneClickSrc69Evid223Params>} LogObject<advancedPostSettingsDoneClickSrc69Evid223Params>
 */
export function advancedPostSettingsDoneClickSrc69Evid223(params) {
    return { evid: 223, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'advancedPostSettingsTabOpen' event (evid: 224)
 *
 * Event description: Tab opened in advanced post settings (default tab does not count)
 *
 * @param {advancedPostSettingsTabOpenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of user - writer or admin
 * @property {GUID} biToken - MSID
 * @property {string} tab_name - Which tab was opened in post settings
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @return {LogObject<advancedPostSettingsTabOpenParams>} LogObject<advancedPostSettingsTabOpenParams>
 */
export function advancedPostSettingsTabOpen(params) {
    return { evid: 224, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'advancedPostSettingsOpenSrc69Evid228' event (evid: 228)
 *
 * Event description: Advanced post settings opened
 *
 * @param {advancedPostSettingsOpenSrc69Evid228Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of user - writer or admin
 * @property {GUID} biToken - MSID
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @property {boolean} is_published - Is post published (1-published)
 * @return {LogObject<advancedPostSettingsOpenSrc69Evid228Params>} LogObject<advancedPostSettingsOpenSrc69Evid228Params>
 */
export function advancedPostSettingsOpenSrc69Evid228(params) {
    return { evid: 228, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'followUnfollowPost' event (evid: 229)
 *
 * Event description: When a user Follows or unfollows a post.
 * this is event was originally created for the member's area post 3 dot menu
 *
 * @param {followUnfollowPostParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_followed - 1- followed, 0- unfollowed
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - the member Id on the site
 * @property {string} pageName - the page where the action took place (added for members area)
 * @return {LogObject<followUnfollowPostParams>} LogObject<followUnfollowPostParams>
 */
export function followUnfollowPost(params) {
    return { evid: 229, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pinUnpinToFeed' event (evid: 230)
 *
 * Event description: When a user Pins or unpins a post.
 * this is event was originally created for the member's area post 3 dot menu
 *
 * @param {pinUnpinToFeedParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} isPinned - 1- Pinned, 0- Unpinned
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - the member Id on the site
 * @property {string} pageName - the page where the action took place (added for members area)
 * @return {LogObject<pinUnpinToFeedParams>} LogObject<pinUnpinToFeedParams>
 */
export function pinUnpinToFeed(params) {
    return { evid: 230, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'enableDisableComments' event (evid: 231)
 *
 * Event description: When a user Enables or Disables comments on a post.
 * this is event was originally created for the member's area post 3 dot menu
 *
 * @param {enableDisableCommentsParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_commentable - 1- comments enabled, 0 - comments disabled
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - the member Id on the site
 * @property {string} pageName - the page where the action took place (added for members area)
 * @return {LogObject<enableDisableCommentsParams>} LogObject<enableDisableCommentsParams>
 */
export function enableDisableComments(params) {
    return { evid: 231, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'duplicatePost' event (evid: 232)
 *
 * Event description: When a user duplicates a post.
 * this is event was originally created for the member's area drafts 3 dot menu
 *
 * @param {duplicatePostParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - the member Id on the site
 * @property {string} pageName - the page where the action took place (added for members area)
 * @return {LogObject<duplicatePostParams>} LogObject<duplicatePostParams>
 */
export function duplicatePost(params) {
    return { evid: 232, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'commentEditClick' event (evid: 233)
 *
 * Event description: When a user clicks to edit a post.
 * this is event was originally created for the member's area comments 3 dot menu
 *
 * @param {commentEditClickParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comment_id - the comment id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - the member Id on the site
 * @property {string} pageName - the page where the action took place (added for members area)
 * @return {LogObject<commentEditClickParams>} LogObject<commentEditClickParams>
 */
export function commentEditClick(params) {
    return { evid: 233, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteCommentClick' event (evid: 234)
 *
 * Event description: When a user clicks to delete a post.
 * this is event was originally created for the member's area comments 3 dot menu
 *
 * @param {deleteCommentClickParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comment_id - the comment id
 * @property {GUID} post_stable_id - new immutable post_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - the member Id on the site
 * @property {string} pageName - the page where the action took place (added for members area)
 * @return {LogObject<deleteCommentClickParams>} LogObject<deleteCommentClickParams>
 */
export function deleteCommentClick(params) {
    return { evid: 234, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'shareCommentClick' event (evid: 235)
 *
 * Event description: When a user clicks to share a post.
 * this is event was originally created for the member's area comments 3 dot menu
 *
 * @param {shareCommentClickParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comment_id - the comment id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - the member Id on the site
 * @property {string} pageName - the page where the action took place (added for members area)
 * @return {LogObject<shareCommentClickParams>} LogObject<shareCommentClickParams>
 */
export function shareCommentClick(params) {
    return { evid: 235, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnAuthor' event (evid: 236)
 *
 * Event description: When a user clicks on the author's name.
 * this event was originally created for the member's area
 *
 * @param {clickOnAuthorParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - the member Id on the site
 * @property {string} pageName - the page where the action took place (added for members area)
 * @return {LogObject<clickOnAuthorParams>} LogObject<clickOnAuthorParams>
 */
export function clickOnAuthor(params) {
    return { evid: 236, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnEditMembersArea' event (evid: 237)
 *
 * Event description: When a user clicks on the edit name.
 * this event was originally created for the member's area
 *
 * @param {clickOnEditMembersAreaParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} object - comment, post
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - the member Id on the site
 * @return {LogObject<clickOnEditMembersAreaParams>} LogObject<clickOnEditMembersAreaParams>
 */
export function clickOnEditMembersArea(params) {
    return { evid: 237, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnTitle' event (evid: 238)
 *
 * Event description: When a user clicks on the edit name.
 * this event was originally created for the member's area
 *
 * @param {clickOnTitleParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} title_type - the type of the title (draft, post, excerpt)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - the member Id on the site
 * @return {LogObject<clickOnTitleParams>} LogObject<clickOnTitleParams>
 */
export function clickOnTitle(params) {
    return { evid: 238, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postPage3DotsClick' event (evid: 240)
 *
 * Event description: Triggered when the user clicks on the 3 dots menu, on the post page
 *
 * @param {postPage3DotsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} tabName - tab name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} translation_id - translation id
 * @return {LogObject<postPage3DotsClickParams>} LogObject<postPage3DotsClickParams>
 */
export function postPage3DotsClick(params) {
    return { evid: 240, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postsPage3DotsMenuOptionClick' event (evid: 241)
 *
 * Event description: Whenever a user clicks one of the options from the 3 dots menu, in the Post page on the live site
 *
 * @param {postsPage3DotsMenuOptionClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instace
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} biToken - msid
 * @property {string} post_id - post id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - the language ML
 * @property {string} translation_id - translation
 * @property {string} action - share, edit, print etc..
 * @return {LogObject<postsPage3DotsMenuOptionClickParams>} LogObject<postsPage3DotsMenuOptionClickParams>
 */
export function postsPage3DotsMenuOptionClick(params) {
    return { evid: 241, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postPageBottomIconsClick' event (evid: 242)
 *
 * Event description: when the user clicks the on an icon at the bottom of the post (share options not included)
 *
 * @param {postPageBottomIconsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {string} click_name - click name
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor
 * @property {GUID} post_stable_id - new immutable post_id
 * @property {string} language - language
 * @property {string} origin - which page the action took place - feed/post/modal
 * @property {string} translation_id - translation
 * @return {LogObject<postPageBottomIconsClickParams>} LogObject<postPageBottomIconsClickParams>
 */
export function postPageBottomIconsClick(params) {
    return { evid: 242, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixPostImporterImportStartedServer' event (evid: 2421)
 *
 * Event description: Server event for when the user starts the post import
 *
 * @param {wixPostImporterImportStartedServerParams} params - The parameters for this event
 * @property {boolean} is_demo - is_demo
 * @property {string} role - role
 * @property {GUID} biToken - msid
 * @property {number} num_posts_total - the number of posts to be imported
 * @property {string} import_type - xml/url
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - the instance_id from which the posts were imported
 * @property {GUID} original_msid - the msid from which the posts were imported
 * @return {LogObject<wixPostImporterImportStartedServerParams>} LogObject<wixPostImporterImportStartedServerParams>
 */
export function wixPostImporterImportStartedServer(params) {
    return { evid: 2421, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixPostImporterImportFinishedServer' event (evid: 2422)
 *
 * Event description: Triggered when the import wix posts process finishes
 *
 * @param {wixPostImporterImportFinishedServerParams} params - The parameters for this event
 * @property {boolean} is_demo - is_demo
 * @property {string} role - role
 * @property {GUID} biToken - msid
 * @property {string} fail_reason - if the import failed what was the reason
 * @property {number} num_posts_total - the number of posts to be imported
 * @property {number} num_posts_unsucc - number of posts that failed to import
 * @property {string} import_type - xml/url
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} original_instance_id - the instance_id from which the posts were imported
 * @property {GUID} original_msid - original_msid
 * @property {boolean} is_successful - was the import successful
 * @return {LogObject<wixPostImporterImportFinishedServerParams>} LogObject<wixPostImporterImportFinishedServerParams>
 */
export function wixPostImporterImportFinishedServer(params) {
    return { evid: 2422, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogProvisioned' event (evid: 2423)
 *
 * Event description: Blog provisioned event
 *
 * @param {blogProvisionedParams} params - The parameters for this event
 * @property {boolean} is_demo - is_demo
 * @property {GUID} originMetaSiteId - origin metaSite id
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {string} siteLanguage - site language
 * @property {GUID} biToken - msid
 * @property {string} install_origin - duplicate/fresh install/template (whichever possible)
 * @property {GUID} uuid - uuid
 * @property {GUID} siteOwnerMemberId - site owner member id
 * @property {string} languageToCopy - language of the copied content
 * @property {GUID} post_stable_id - post_stable_id
 * @property {boolean} postsCopied - Are posts coped at all
 * @return {LogObject<blogProvisionedParams>} LogObject<blogProvisionedParams>
 */
export function blogProvisioned(params) {
    return { evid: 2423, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postPageOpenedServer' event (evid: 3)
 *
 * Event description: triggered when post page opened
 *
 * @param {postPageOpenedServerParams} params - The parameters for this event
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name (if discovery)
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {number} paid_plan_has_access - 1 - has access, 0 - don't have access, null - not paid post
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - the language of the post
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} translation_id - the stable id of the original post
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {string} paid_plan_id - list (array) of paid plan ids
 * @property {string} referral_post_id - the post_id that took the user here
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<postPageOpenedServerParams>} LogObject<postPageOpenedServerParams>
 */
export function postPageOpenedServer(params) {
    return { evid: 3, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogManagerOpenClickBo' event (evid: 300)
 *
 * Event description: triggered when click on Manage posts CTA
 *
 * @param {blogManagerOpenClickBoParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} app_id - app_id (forum, blog, members)
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @return {LogObject<blogManagerOpenClickBoParams>} LogObject<blogManagerOpenClickBoParams>
 */
export function blogManagerOpenClickBo(params) {
    return { evid: 300, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogImporterPageOpen' event (evid: 3000)
 *
 * Event description: BlogImporter.PageOpen.
 *
 * @param {blogImporterPageOpenParams} params - The parameters for this event
 * @property {string} import_type - import_type: xml/url
 * @property {string} origin - Editor / BM_Editor / Landing Page
 * @property {string} pageName - Page Name
 * @return {LogObject<blogImporterPageOpenParams>} LogObject<blogImporterPageOpenParams>
 */
export function blogImporterPageOpen(params) {
    return { evid: 3000, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogManagerOpenedBo' event (evid: 301)
 *
 * Event description: triggered when blog manager actually open!
 *
 * @param {blogManagerOpenedBoParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {string} version - the biz manager version (null values mean the v1)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - the language if ML
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} referrer - the place from which it was open
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @property {string} destination - blog manager destination name
 * @property {string} tab_name - tab_name
 * @return {LogObject<blogManagerOpenedBoParams>} LogObject<blogManagerOpenedBoParams>
 */
export function blogManagerOpenedBo(params) {
    return { evid: 301, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogImporterAddNewSiteClick' event (evid: 3024)
 *
 * Event description: Add new site to import click
 *
 * @param {blogImporterAddNewSiteClickParams} params - The parameters for this event
 * @property {string} origin - Editor / BM_Editor / Landing Page
 * @return {LogObject<blogImporterAddNewSiteClickParams>} LogObject<blogImporterAddNewSiteClickParams>
 */
export function blogImporterAddNewSiteClick(params) {
    return { evid: 3024, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogImporterExistingSiteClick' event (evid: 3025)
 *
 * Event description: Import blog to an existing site click
 *
 * @param {blogImporterExistingSiteClickParams} params - The parameters for this event
 * @property {string} origin - Editor / BM_Editor / Landing Page
 * @return {LogObject<blogImporterExistingSiteClickParams>} LogObject<blogImporterExistingSiteClickParams>
 */
export function blogImporterExistingSiteClick(params) {
    return { evid: 3025, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogImporterButtonClick' event (evid: 3026)
 *
 * Event description: Button Next / Back /Ok/ Contact etc click
 *
 * @param {blogImporterButtonClickParams} params - The parameters for this event
 * @property {string} import_type - import_type: xml/url
 * @property {string} origin - Editor / BM_Editor / Landing Page
 * @property {string} choice - key:value
 * @property {string} buttonName - Next / Back / Ok/ Contact etc
 * @property {string} pageName - Page Name
 * @return {LogObject<blogImporterButtonClickParams>} LogObject<blogImporterButtonClickParams>
 */
export function blogImporterButtonClick(params) {
    return { evid: 3026, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogImporterImportUrlCheck' event (evid: 3027)
 *
 * Event description: url check
 *
 * @param {blogImporterImportUrlCheckParams} params - The parameters for this event
 * @property {string} url - url
 * @property {boolean} isSuccess - true / false
 * @property {string} errorType - error *if failed
 * @property {string} import_type - import_type: xml/url
 * @property {string} origin - Editor / BM_Editor / Landing Page
 * @return {LogObject<blogImporterImportUrlCheckParams>} LogObject<blogImporterImportUrlCheckParams>
 */
export function blogImporterImportUrlCheck(params) {
    return { evid: 3027, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogImporterImportPreCheck' event (evid: 3028)
 *
 * Event description: go to url to check is wordpress?
 *
 * @param {blogImporterImportPreCheckParams} params - The parameters for this event
 * @property {number} itemsCount - PostsRecognized count
 * @property {string} url - url
 * @property {boolean} isSuccess - true / false
 * @property {string} errorType - error *if failed
 * @property {string} origin - Editor / BM_Editor / Landing Page
 * @return {LogObject<blogImporterImportPreCheckParams>} LogObject<blogImporterImportPreCheckParams>
 */
export function blogImporterImportPreCheck(params) {
    return { evid: 3028, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogImporterImportStarted' event (evid: 3029)
 *
 * Event description: Import started
 *
 * @param {blogImporterImportStartedParams} params - The parameters for this event
 * @property {string} url - url
 * @property {GUID} migrationTaskId - migrationTaskId
 * @property {string} import_type - import_type: xml/url
 * @property {string} origin - Editor / BM_Editor / Landing Page
 * @property {string} additionalInfo - json: { field_name: “url/theme/about/templateid etc” field_value: “value”}
 * @property {GUID} template_id - template ID
 * @return {LogObject<blogImporterImportStartedParams>} LogObject<blogImporterImportStartedParams>
 */
export function blogImporterImportStarted(params) {
    return { evid: 3029, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postPublishedSrc69Evid303' event (evid: 303)
 *
 * Event description: triggered when post: Created(Published), Updated, Unpublished, Moved to trash, Deleted,
 *
 * @param {postPublishedSrc69Evid303Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} image_count - image_count in the post
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} is_edited - 0 - new post / 1 - edit (to know if its posted for first time)
 * @property {string} post_title - post title
 * @property {string} role - member role (owner, writer, member)
 * @property {string} url - the post url
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {boolean} has_gallery - NOT IN USE: 0 - no gallery / 1 - published with gallery
 * @property {string} referral_info - NOT IN USE: external links - facebook, social networks. if from wix then null
 * @property {number} giphy_count - count of used  giphy gifs
 * @property {string} tag_ids - array of tags
 * @property {number} categories_count - NOT IN USE: categories_count that post was assigned to
 * @property {boolean} used_html - 0 - didnt used html component / 1 - used html component
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - for multilingual
 * @property {number} character_count - The number of characters on the post
 * @property {string} original_post_id - the original post id
 * @property {string} community_id - NOT IN USE: community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - Currently being used for wix reads posts.in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} translation_id - the post_stable_id of the post that was translated
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} author_id - author id
 * @property {string} paid_plan_id - Array of paid plan ids
 * @property {string} member_id - member_id
 * @property {number} video_count - video_count in the post
 * @property {GUID} msid - msid
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @property {string} galleries - will sent as array - [{ layout: 'masonry', count: 5}, { layout: 'whatever', count: 10 }]
 * @property {string} related_post_ids - array with related post Ids
 * @return {LogObject<postPublishedSrc69Evid303Params>} LogObject<postPublishedSrc69Evid303Params>
 */
export function postPublishedSrc69Evid303(params) {
    return { evid: 303, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogImporterImportSnapshotReady' event (evid: 3031)
 *
 * Event description: snapshot ready check
 *
 * @param {blogImporterImportSnapshotReadyParams} params - The parameters for this event
 * @property {string} url - url on a wordpress site
 * @property {string} snapshotUrl - link to snapshot img
 * @property {boolean} isSuccess - true / false
 * @property {string} errorType - error *if failed
 * @property {string} origin - Editor / BM_Editor / Landing Page
 * @return {LogObject<blogImporterImportSnapshotReadyParams>} LogObject<blogImporterImportSnapshotReadyParams>
 */
export function blogImporterImportSnapshotReady(params) {
    return { evid: 3031, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogImporterXmlUpload' event (evid: 3032)
 *
 * Event description: When the user uploads/drag and drops XML file
 *
 * @param {blogImporterXmlUploadParams} params - The parameters for this event
 * @property {string} origin - origin
 * @property {string} uploadType - press_upload / drag_and_drop
 * @return {LogObject<blogImporterXmlUploadParams>} LogObject<blogImporterXmlUploadParams>
 */
export function blogImporterXmlUpload(params) {
    return { evid: 3032, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postDraftCreated' event (evid: 305)
 *
 * Event description: triggered when a post draft is created (first save)
 *
 * @param {postDraftCreatedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {string} referral_info - NOT IN USE: external links - facebook, social networks. if from wix then null
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - for multilingual
 * @property {string} community_id - NOT IN USE: community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - NOT IN USE: in the members app events. holds the child app (forum/blog) instance_id
 * @property {boolean} is_offline - if the event happened offline
 * @property {string} translation_id - the post_stable_id of the translated post
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @property {string} template_id - post template id
 * @return {LogObject<postDraftCreatedParams>} LogObject<postDraftCreatedParams>
 */
export function postDraftCreated(params) {
    return { evid: 305, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postDeleted' event (evid: 306)
 *
 * Event description: triggered when post deleted
 *
 * @param {postDeletedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - for multilingual
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} translation_id - translation id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<postDeletedParams>} LogObject<postDeletedParams>
 */
export function postDeleted(params) {
    return { evid: 306, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postEditorOpenedSrc69Evid307' event (evid: 307)
 *
 * Event description: triggered when post editor opened
 *
 * @param {postEditorOpenedSrc69Evid307Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} translatation_id - the post_stable_id of the translated post
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} post_title - post title
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {string} referral_info - NOT IN USE: external links - facebook, social networks. if from wix then null
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - to be used in multilingual context.
 * @property {number} character_count - character count in post (sends only on Web)
 * @property {string} community_id - NOT IN USE: community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - NOT IN USE: in the members app events. holds the child app (forum/blog) instance_id
 * @property {boolean} is_offline - if the event happened offline
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} referrer - the place from which it was opened
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<postEditorOpenedSrc69Evid307Params>} LogObject<postEditorOpenedSrc69Evid307Params>
 */
export function postEditorOpenedSrc69Evid307(params) {
    return { evid: 307, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'writeNewPostClick' event (evid: 308)
 *
 * Event description: triggered when click on write new post CTA
 *
 * @param {writeNewPostClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {boolean} is_offline - if the event happened offline
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @return {LogObject<writeNewPostClickParams>} LogObject<writeNewPostClickParams>
 */
export function writeNewPostClick(params) {
    return { evid: 308, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postPageWidthOfPostChanged' event (evid: 309)
 *
 * Event description: Width of post changed in post page
 * width field itself is not very trustful, as it's calculated the other way around if "full width" is enabled and we can't know if it's enabled
 *
 * @param {postPageWidthOfPostChangedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} buildertype - In which editor changed was made: mobile, desktop
 * @property {string} role - role
 * @property {string} referral_info - not working: referral_info
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} eventmeta - eventmeta
 * @property {string} origin - editor
 * @property {GUID} msid - msid
 * @property {number} width - width of post after change (not very trustful, as there are some mismatches with enabled full width)
 * @return {LogObject<postPageWidthOfPostChangedParams>} LogObject<postPageWidthOfPostChangedParams>
 */
export function postPageWidthOfPostChanged(params) {
    return { evid: 309, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newCategoryAddedToBlogSrc69Evid311' event (evid: 311)
 *
 * Event description: triggered when a new category added in the app settings
 *
 * @param {newCategoryAddedToBlogSrc69Evid311Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} seo_description - category description in seo settings was added (OneApp only)
 * @property {string} role - member role (owner, writer, member)
 * @property {boolean} image - image for category was added (OneApp only)
 * @property {string} label - the category name
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {number} category_count - current amount of categories i the blog
 * @property {boolean} seo_name - category name was under seo settings (OneApp only)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - The category language
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor, avdanced_post_settings
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} category_id - category_id
 * @property {string} translation_id - the Id of category that was translated
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @return {LogObject<newCategoryAddedToBlogSrc69Evid311Params>} LogObject<newCategoryAddedToBlogSrc69Evid311Params>
 */
export function newCategoryAddedToBlogSrc69Evid311(params) {
    return { evid: 311, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogCategoryInfoChanged' event (evid: 312)
 *
 * Event description: triggered when an exiting category edited in the app settings - title or description
 *
 * @param {blogCategoryInfoChangedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} seo_description - seo_description was edited (OneApp only)
 * @property {string} role - member role (owner, writer, member)
 * @property {boolean} image - image was edited (OneApp only)
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {number} category_count - current amount of categories i the blog
 * @property {boolean} seo_name - seo_name was changed
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} category_id - category_id
 * @property {string} translation_id - the id of the the translated category
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {boolean} category_label - category label was changed
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @return {LogObject<blogCategoryInfoChangedParams>} LogObject<blogCategoryInfoChangedParams>
 */
export function blogCategoryInfoChanged(params) {
    return { evid: 312, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'draftSaved' event (evid: 313)
 *
 * Event description: triggered when a post draft is saved each time (Web Only)
 *
 * @param {draftSavedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} post_title - post title
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - for multilingual
 * @property {number} character_count - Character count in post
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {boolean} is_offline - if the event happened offline
 * @property {string} translation_id - the post_stable_id of the post that was translated
 * @property {GUID} msid - msid
 * @return {LogObject<draftSavedParams>} LogObject<draftSavedParams>
 */
export function draftSaved(params) {
    return { evid: 313, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tagCreated' event (evid: 314)
 *
 * Event description: triggered whenever the user removes a tag from the post.
 *
 * @param {tagCreatedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} tag_guid - tag stable id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} tagid - tag_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} origin - origin
 * @property {string} translation_id - translation_id
 * @property {GUID} msid - msid
 * @property {string} tag_name - tag label
 * @return {LogObject<tagCreatedParams>} LogObject<tagCreatedParams>
 */
export function tagCreated(params) {
    return { evid: 314, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'shareAfterPublishModalShown' event (evid: 315)
 *
 * Event description: Share after publish modal shown for user
 *
 * @param {shareAfterPublishModalShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of the user - writer or admin
 * @property {string} post_id - post_id
 * @property {string} possible_modal_actions - possible_modal_actions
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<shareAfterPublishModalShownParams>} LogObject<shareAfterPublishModalShownParams>
 */
export function shareAfterPublishModalShown(params) {
    return { evid: 315, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'shareAfterPublishModalAction' event (evid: 316)
 *
 * Event description: User chose action in Share after publish modal
 *
 * @param {shareAfterPublishModalActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of the user - writer or admin
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {boolean} dont_show_again - user marked don't show again
 * @property {GUID} msid - msid
 * @property {string} action - action user chose in modal (Not right now, close X, Facebook, Preview, Twitter, copy url, etc)
 * @return {LogObject<shareAfterPublishModalActionParams>} LogObject<shareAfterPublishModalActionParams>
 */
export function shareAfterPublishModalAction(params) {
    return { evid: 316, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileUploaded' event (evid: 317)
 *
 * Event description: Event triggered when a person tries to upload a file to a Blog post
 *
 * @param {fileUploadedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - metasite id
 * @property {boolean} is_demo - is_demo
 * @property {string} file_ext - File extension
 * @property {boolean} success - 0 - upload failed / 1 - upload successful
 * @property {string} screen_name - screen_name
 * @property {string} file_id - The file identifier (null if not successful)
 * @property {string} role - role
 * @property {number} file_size - The size of the file being uploaded (in bytes)
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} mime_type - File type
 * @property {string} origin - post (for now just post)
 * @property {GUID} msid - metasite id
 * @return {LogObject<fileUploadedParams>} LogObject<fileUploadedParams>
 */
export function fileUploaded(params) {
    return { evid: 317, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postFeedFilterSettingsCategoryAndTags' event (evid: 318)
 *
 * Event description: Whenever a user selects a filter for the post list from the settings button.
 *
 * @param {postFeedFilterSettingsCategoryAndTagsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} tag_guid - tag stable id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} tagid - tag_id, null if user selected all posts
 * @property {string} category_name - category name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} category_id - category Id
 * @property {GUID} category_stable_id - category stable id
 * @property {GUID} msid - msid
 * @property {string} tag_name - tag label
 * @return {LogObject<postFeedFilterSettingsCategoryAndTagsParams>} LogObject<postFeedFilterSettingsCategoryAndTagsParams>
 */
export function postFeedFilterSettingsCategoryAndTags(params) {
    return { evid: 318, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blog6thButtonBlogElementAdded' event (evid: 322)
 *
 * Event description: triggered when adding blog element from the blog 6th button
 *
 * @param {blog6thButtonBlogElementAddedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} widget_id - widget_id
 * @property {number} ts - dummy
 * @property {string} viewmode - dummy
 * @property {GUID} id - unique id of a widget to connect to other events
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - 6th button or Add panel
 * @property {string} editor_working_mode - dummy
 * @property {string} pageType - the page the widget was added on. Home, Post, other
 * @property {string} element_type - recent post, custom feed
 * @property {string} layout - layout of the element that was added
 * @property {GUID} esi - dummy
 * @property {boolean} is_first_time_view - dummy
 * @property {GUID} msid - msid
 * @return {LogObject<blog6thButtonBlogElementAddedParams>} LogObject<blog6thButtonBlogElementAddedParams>
 */
export function blog6thButtonBlogElementAdded(params) {
    return { evid: 322, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'advancedPostSettingsDoneClick' event (evid: 323)
 *
 * Event description: Clicking Done in advance post settings
 *
 * @param {advancedPostSettingsDoneClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} is_demo - is_demo
 * @property {boolean} is_changed_search_engine_title - Changed search engine title
 * @property {string} screen_name - screen_name
 * @property {string} language_id - language
 * @property {boolean} is_excerpt_written - 1 - added text, 0 - didn't
 * @property {string} role - Role of user - writer or admin
 * @property {string} post_id - post_id
 * @property {boolean} is_on_feature_post_toggle - 1 - on, 0 - off
 * @property {string} button_name - Save, Save and Publish
 * @property {boolean} is_publish_date_edited - Post publish date edited
 * @property {boolean} is_author_changed - User changed author
 * @property {number} categories_chosen - How many categories was chosen
 * @property {boolean} is_written_description - Written a description
 * @property {GUID} post_stable_id - post_stable_id
 * @property {boolean} is_feature_post_toggle_changed - If toggle was changed
 * @property {boolean} is_main_category_changed - if user changed the main category
 * @property {string} translation_id - translation
 * @property {boolean} is_changed_excerpt - If excerpt was changed
 * @property {string} platform - Was opened in back office/live site
 * @property {boolean} is_changed_url - Changed URL
 * @property {GUID} msid - msid
 * @property {boolean} is_cover_image_changed - Changed cover image
 * @property {boolean} is_category_changed - if the user added or removed categories from the post
 * @property {boolean} is_display_cover_toggle_changed - If toggle was changed
 * @property {boolean} is_published - Is post published (1-published)
 * @property {boolean} is_on_display_cover_toggle - 1 - on, 0 - off
 * @return {LogObject<advancedPostSettingsDoneClickParams>} LogObject<advancedPostSettingsDoneClickParams>
 */
export function advancedPostSettingsDoneClick(params) {
    return { evid: 323, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'advancedPostSettingsTabOpenSrc69Evid324' event (evid: 324)
 *
 * Event description: Left sidebar tab opened in post editor
 *
 * @param {advancedPostSettingsTabOpenSrc69Evid324Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of the user - writer or admin
 * @property {string} post_id - post id
 * @property {string} tab_name - Which tab was opened in post settings
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} platform - Where event took place - live site or business manager
 * @property {GUID} msid - msid
 * @property {string} origin - used with AI tools - what is the origin the tab was opened from
 * @return {LogObject<advancedPostSettingsTabOpenSrc69Evid324Params>} LogObject<advancedPostSettingsTabOpenSrc69Evid324Params>
 */
export function advancedPostSettingsTabOpenSrc69Evid324(params) {
    return { evid: 324, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogTabInBmOpened' event (evid: 325)
 *
 * Event description: Tab in Blog Manager opened
 *
 * @param {blogTabInBmOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {string} name - Opened Tab name in Blog Back Office
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of user - writer or admin
 * @property {string} tab_name - Opened Tab in Blog Back Office
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - the language that was rendered
 * @property {string} place - Place where tab was opened (sidebar / blog posts list)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} referrer - from which place it was opened
 * @property {GUID} msid - msid
 * @property {string} sub_tab - sub_tab
 * @return {LogObject<blogTabInBmOpenedParams>} LogObject<blogTabInBmOpenedParams>
 */
export function blogTabInBmOpened(params) {
    return { evid: 325, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adiBlogSettingsOpened' event (evid: 326)
 *
 * Event description: User opened blog settings in ADI
 *
 * @param {adiBlogSettingsOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} adi_blog_settings_opened - 1 - ADI Blog settings opened
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of user - writer or admin
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<adiBlogSettingsOpenedParams>} LogObject<adiBlogSettingsOpenedParams>
 */
export function adiBlogSettingsOpened(params) {
    return { evid: 326, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adiBlogSettingsToggleClick' event (evid: 327)
 *
 * Event description: Which settings user chose on Settings panel in ADI
 *
 * @param {adiBlogSettingsToggleClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of user - writer or admin
 * @property {GUID} post_stable_id - post_stable_id
 * @property {boolean} is_enabled - 1 - enabled, 0 - disabled
 * @property {string} toggle_name - Name of the toggle in blog settings
 * @property {GUID} msid - msid
 * @return {LogObject<adiBlogSettingsToggleClickParams>} LogObject<adiBlogSettingsToggleClickParams>
 */
export function adiBlogSettingsToggleClick(params) {
    return { evid: 327, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'advancedPostSettingsOpen' event (evid: 328)
 *
 * Event description: Advanced post settings opened
 *
 * @param {advancedPostSettingsOpenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - MSID
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of the user - writer or admin
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post stable id
 * @property {string} platform - Was opened in back office/live site
 * @property {GUID} msid - MSID
 * @property {boolean} is_published - Is post published (1-published)
 * @return {LogObject<advancedPostSettingsOpenParams>} LogObject<advancedPostSettingsOpenParams>
 */
export function advancedPostSettingsOpen(params) {
    return { evid: 328, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addBlogAppDisplayTypeOfBlogModal' event (evid: 329)
 *
 * Event description: Whenever the user adds the blog app to a site. This event records if the type of blog modal was displayed.
 *
 * @param {addBlogAppDisplayTypeOfBlogModalParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<addBlogAppDisplayTypeOfBlogModalParams>} LogObject<addBlogAppDisplayTypeOfBlogModalParams>
 */
export function addBlogAppDisplayTypeOfBlogModal(params) {
    return { evid: 329, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addBlogAppTypeOfBlogModalSelection' event (evid: 330)
 *
 * Event description: Whenever the user adds the blog app to a site, the type of modal is displayed. This event records the user selection on the type of blog modal.
 *
 * @param {addBlogAppTypeOfBlogModalSelectionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} option - values: wix blog or members area
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {string} action - close or next
 * @return {LogObject<addBlogAppTypeOfBlogModalSelectionParams>} LogObject<addBlogAppTypeOfBlogModalSelectionParams>
 */
export function addBlogAppTypeOfBlogModalSelection(params) {
    return { evid: 330, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postsBm3Dots' event (evid: 331)
 *
 * Event description: Whenever a user clicks one of the options from the 3 dots menu, in the Business Manager
 *
 * @param {postsBm3DotsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} language_id - the post_ stable id of the original post
 * @property {string} role - role
 * @property {string} post_id - post id
 * @property {string} tabName - Posts or Drafts
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - the language ML
 * @property {GUID} msid - msid
 * @property {string} action - view post, duplicate post, revert to draft, turn off commenting, move to trash, preview draft, duplicate draft
 * @return {LogObject<postsBm3DotsParams>} LogObject<postsBm3DotsParams>
 */
export function postsBm3Dots(params) {
    return { evid: 331, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'unpublishPost' event (evid: 332)
 *
 * Event description: When a post is unpublished.
 *
 * @param {unpublishPostParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - for multilingual
 * @property {string} origin - post page, post editor
 * @property {string} translation_id - posts stable id of the original translated post
 * @property {GUID} msid - msid
 * @property {string} action - revert to draft, move trash
 * @return {LogObject<unpublishPostParams>} LogObject<unpublishPostParams>
 */
export function unpublishPost(params) {
    return { evid: 332, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postSoftDelete' event (evid: 333)
 *
 * Event description: When a post is moved to trash
 *
 * @param {postSoftDeleteParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} language_id - the post stable if of the translated post
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - for multilingual
 * @property {string} origin - post page, post editor, drafts
 * @property {GUID} msid - msid
 * @return {LogObject<postSoftDeleteParams>} LogObject<postSoftDeleteParams>
 */
export function postSoftDelete(params) {
    return { evid: 333, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bm3DotsClick' event (evid: 334)
 *
 * Event description: Triggered when the user clicks on the 3 dots menu, on the post list within the Business Manager (BM)
 *
 * @param {bm3DotsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} source - post BO section name: published, overview
 * @property {string} role - role
 * @property {string} tabName - tab name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} translation_id - translation id
 * @property {GUID} msid - msid
 * @return {LogObject<bm3DotsClickParams>} LogObject<bm3DotsClickParams>
 */
export function bm3DotsClick(params) {
    return { evid: 334, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'emailMarketingSelectPost' event (evid: 335)
 *
 * Event description: Whenever the user selects a post from the Email marketing post selection modal.
 *
 * @param {emailMarketingSelectPostParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<emailMarketingSelectPostParams>} LogObject<emailMarketingSelectPostParams>
 */
export function emailMarketingSelectPost(params) {
    return { evid: 335, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postScheduled' event (evid: 336)
 *
 * Event description: triggered when a post is scheduled.
 *
 * @param {postScheduledParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} image_count - image_count in the post
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} is_edited - 0 - new post / 1 - edit (to know if its posted for first time)
 * @property {string} role - member role (owner, writer, member)
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {number} giphy_count - count of used  giphy gifs
 * @property {boolean} used_html - 0 - didnt used html component / 1 - used html component
 * @property {number} offset - the user timezone offset relative to UTC (in minutes)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {number} character_count - The number of characters on the post
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {DateTime} scheduled_date - The date when the post must be published (UTC)
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {string} member_id - NOT USED: member_id
 * @property {boolean} is_rescheduled - TRUE if rescheduled
 * @property {number} video_count - video_count in the post
 * @property {GUID} msid - msid
 * @property {string} galleries - will sent as array - [{ layout: 'masonry', count: 5}, { layout: 'whatever', count: 10 }]
 * @return {LogObject<postScheduledParams>} LogObject<postScheduledParams>
 */
export function postScheduled(params) {
    return { evid: 336, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postUnscheduled' event (evid: 337)
 *
 * Event description: When the user unschedules a post
 *
 * @param {postUnscheduledParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<postUnscheduledParams>} LogObject<postUnscheduledParams>
 */
export function postUnscheduled(params) {
    return { evid: 337, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'errorEvent' event (evid: 338)
 *
 * Event description: whenever the user sees an error message in post editor. Not sent if internet is gone for user, but user sees modal
 *
 * @param {errorEventParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} request_id - request_id (optional)
 * @property {string} applicationCode - applicationCode
 * @property {GUID} msid - msid
 * @property {string} action - which action triggered the error ( e.g. scheduling a post, publishing a post etc)
 * @return {LogObject<errorEventParams>} LogObject<errorEventParams>
 */
export function errorEvent(params) {
    return { evid: 338, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dotsClickPostEditor' event (evid: 339)
 *
 * Event description: Triggered when the user clicks on the 3 dots menu that sits next to the publish button, within the Post Editor
 *
 * @param {dotsClickPostEditorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @property {boolean} is_published - Is post published
 * @return {LogObject<dotsClickPostEditorParams>} LogObject<dotsClickPostEditorParams>
 */
export function dotsClickPostEditor(params) {
    return { evid: 339, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dotsPostEditorOptionClicked' event (evid: 340)
 *
 * Event description: Whenever a user clicks one of the options from the 3 dots menu, in the Post Editor
 *
 * @param {dotsPostEditorOptionClickedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} is_edited - is_edited
 * @property {string} role - role
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post. stable id
 * @property {string} language - Language
 * @property {boolean} title_ok - is title set
 * @property {string} origin - origin
 * @property {string} translation_id - translation_id
 * @property {GUID} msid - msid
 * @property {string} action - Preview Post, Post Settings, Choose Category, Save as Draft, Schedule Post
 * @property {boolean} is_published - Is post published
 * @return {LogObject<dotsPostEditorOptionClickedParams>} LogObject<dotsPostEditorOptionClickedParams>
 */
export function dotsPostEditorOptionClicked(params) {
    return { evid: 340, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bm3DotsClickSrc69Evid341' event (evid: 341)
 *
 * Event description: Triggered when the user clicks on the 3 dots menu
 *
 * @param {bm3DotsClickSrc69Evid341Params} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} source - post BO section name: published, overview
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<bm3DotsClickSrc69Evid341Params>} LogObject<bm3DotsClickSrc69Evid341Params>
 */
export function bm3DotsClickSrc69Evid341(params) {
    return { evid: 341, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postEditorHoverOnUpgrade' event (evid: 342)
 *
 * Event description: User hover on a button in post editor
 *
 * @param {postEditorHoverOnUpgradeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} is_edited - is_edited
 * @property {string} role - role
 * @property {string} post_id - post id
 * @property {string} button_name - button name which was hovered on
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - Multilingual language
 * @property {boolean} title_ok - is title set
 * @property {string} origin - origin
 * @property {string} translation_id - translation_id
 * @property {GUID} msid - msid
 * @property {boolean} is_published - Is post published
 * @return {LogObject<postEditorHoverOnUpgradeParams>} LogObject<postEditorHoverOnUpgradeParams>
 */
export function postEditorHoverOnUpgrade(params) {
    return { evid: 342, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchInBlogBo' event (evid: 343)
 *
 * Event description: Search in Blog BO
 *
 * @param {searchInBlogBoParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} text - Text entered in a search
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Search origin
 * @property {number} num_tags_found - number of tags found in search (if used in tag manager)
 * @property {number} num_posts_found - Number of posts found in search
 * @property {GUID} msid - msid
 * @return {LogObject<searchInBlogBoParams>} LogObject<searchInBlogBoParams>
 */
export function searchInBlogBo(params) {
    return { evid: 343, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'actionChoseInBmMoreActionsMenu' event (evid: 344)
 *
 * Event description: Triggered when the user clicks action under more actions menu in blog BO. For click on More actions itself, see event 69:341
 *
 * @param {actionChoseInBmMoreActionsMenuParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} source - post BO section name: published, overview
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {string} actionName - Action name chose inside menu
 * @property {GUID} msid - msid
 * @return {LogObject<actionChoseInBmMoreActionsMenuParams>} LogObject<actionChoseInBmMoreActionsMenuParams>
 */
export function actionChoseInBmMoreActionsMenu(params) {
    return { evid: 344, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postSettingsChangesSidebar' event (evid: 345)
 *
 * Event description: This event tracks all post settings changes made by the user. For each property changed one event is emitted.
 *
 * @param {postSettingsChangesSidebarParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of user - writer or admin
 * @property {string} post_id - post_id
 * @property {string} tab_name - SEO, Settings, Categories
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - the post language
 * @property {string} property_value - The value of the changed property
 * @property {string} translation_id - translation id
 * @property {string} property - The changed property (excerpt, author etc..)
 * @property {GUID} msid - msid
 * @property {boolean} is_published - Is post published (1-published)
 * @return {LogObject<postSettingsChangesSidebarParams>} LogObject<postSettingsChangesSidebarParams>
 */
export function postSettingsChangesSidebar(params) {
    return { evid: 345, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bulkActionsOptionChosen' event (evid: 346)
 *
 * Event description: User did bulk action in Blog BO
 *
 * @param {bulkActionsOptionChosenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} tabName - Posts or Drafts
 * @property {number} postsCount - Number of posts selected
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {string} action - Restore, Delete, Add Category
 * @return {LogObject<bulkActionsOptionChosenParams>} LogObject<bulkActionsOptionChosenParams>
 */
export function bulkActionsOptionChosen(params) {
    return { evid: 346, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'modalShown' event (evid: 347)
 *
 * Event description: Modal shown - generic event for many different modals.
 *
 * --Draft refresh:
 * Modal to refresh draft shown (there exists another version of the draft in another tab or Wix app)
 *
 * @param {modalShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} additional_info - json with additional info
 * @property {string} modal_name - modal name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<modalShownParams>} LogObject<modalShownParams>
 */
export function modalShown(params) {
    return { evid: 347, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'modalAction' event (evid: 348)
 *
 * Event description: Action on Modal - generic event for many different modals.
 *
 * --Draft refresh:
 * Action on modal to refresh draft (there exists another version of the draft in another tab or Wix app)
 *
 * @param {modalActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} default_language - default language
 * @property {string} role - role
 * @property {string} language_selected - In multilingual context stores the language that the user chose
 * @property {string} additional_info - json with additional_info
 * @property {string} modal_name - modal name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} dataJson - if the modal has selections for the user those selections will be stored here
 * @property {string} origin - origin
 * @property {string} available_languages - an array with the available languages
 * @property {GUID} msid - msid
 * @property {string} action - Action on modal (for Draft refresh - close/save this version/discard this version)
 * @return {LogObject<modalActionParams>} LogObject<modalActionParams>
 */
export function modalAction(params) {
    return { evid: 348, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorSettingsPostPageBlogFeedShortcuts' event (evid: 349)
 *
 * Event description: user clicks on Post Page tab inside the blog feed settings
 *
 * @param {editorSettingsPostPageBlogFeedShortcutsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} tab_name - tab name inside post settings
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - blog feed settings / post feed settings
 * @property {string} app_id - app_id
 * @property {GUID} msid - msid
 * @return {LogObject<editorSettingsPostPageBlogFeedShortcutsParams>} LogObject<editorSettingsPostPageBlogFeedShortcutsParams>
 */
export function editorSettingsPostPageBlogFeedShortcuts(params) {
    return { evid: 349, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postPagePostPageOpened' event (evid: 350)
 *
 * Event description: Post page opened in editor
 *
 * @param {postPagePostPageOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - blog_feed, page_preview
 * @property {string} app_id - app_id
 * @property {string} referrer - The place from which this was opened
 * @property {GUID} msid - msid
 * @return {LogObject<postPagePostPageOpenedParams>} LogObject<postPagePostPageOpenedParams>
 */
export function postPagePostPageOpened(params) {
    return { evid: 350, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogImporterImportFinished' event (evid: 3501)
 *
 * Event description: Import finished
 *
 * @param {blogImporterImportFinishedParams} params - The parameters for this event
 * @property {string} url - url
 * @property {GUID} migrationTaskId - migrationTaskId
 * @property {boolean} isSuccess - true / false
 * @property {string} errorType - error if exists
 * @property {string} import_type - import_type: xml/url
 * @property {GUID} templateId - Template Id
 * @property {string} origin - Editor / BM_Editor / Landing Page
 * @property {string} additionalInfo - json: { field_name: “url/theme/about/templateid etc” field_value: “value”}
 * @return {LogObject<blogImporterImportFinishedParams>} LogObject<blogImporterImportFinishedParams>
 */
export function blogImporterImportFinished(params) {
    return { evid: 3501, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogImporterImportRollbackStarted' event (evid: 3502)
 *
 * Event description: Rollback Started
 *
 * @param {blogImporterImportRollbackStartedParams} params - The parameters for this event
 * @property {string} url - url
 * @property {GUID} migrationTaskId - migrationTaskId
 * @property {string} origin - Editor / BM_Editor / Landing Page
 * @property {string} additionalInfo - json: { field_name: “url/theme/about/templateid etc” field_value: “value”}
 * @return {LogObject<blogImporterImportRollbackStartedParams>} LogObject<blogImporterImportRollbackStartedParams>
 */
export function blogImporterImportRollbackStarted(params) {
    return { evid: 3502, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogImporterImportRollbackFinished' event (evid: 3503)
 *
 * Event description: Rollback Finished
 *
 * @param {blogImporterImportRollbackFinishedParams} params - The parameters for this event
 * @property {string} url - url
 * @property {GUID} migrationTaskId - migrationTaskId
 * @property {boolean} isSuccess - true / false
 * @property {string} errorType - error if exists
 * @property {string} origin - Editor / BM_Editor / Landing Page
 * @property {string} additionalInfo - json: { field_name: “url/theme/about/templateid etc” field_value: “value”}
 * @return {LogObject<blogImporterImportRollbackFinishedParams>} LogObject<blogImporterImportRollbackFinishedParams>
 */
export function blogImporterImportRollbackFinished(params) {
    return { evid: 3503, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorSettingsOpened' event (evid: 351)
 *
 * Event description: Settings opened
 *
 * @param {editorSettingsOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} view_mode - Desktop , Mobile. NOTE: Any Null values are desktop
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - post_page, blog_feed
 * @property {string} app_id - app_id
 * @property {string} referrer - from which place it was opened
 * @property {GUID} msid - msid
 * @return {LogObject<editorSettingsOpenedParams>} LogObject<editorSettingsOpenedParams>
 */
export function editorSettingsOpened(params) {
    return { evid: 351, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorSettingsTabOpened' event (evid: 352)
 *
 * Event description: Tab inside settings opened
 *
 * @param {editorSettingsTabOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} view_mode - desktop, mobile. NOTE: any Null values belong to desktop
 * @property {string} role - role
 * @property {string} tab_name - tab name inside post settings
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Place settings was changed in: blog_feed, post_page
 * @property {string} app_id - app_id
 * @property {string} referrer - from which place it was opened
 * @property {GUID} msid - msid
 * @return {LogObject<editorSettingsTabOpenedParams>} LogObject<editorSettingsTabOpenedParams>
 */
export function editorSettingsTabOpened(params) {
    return { evid: 352, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postPagePostPageSettingsDisplayTab' event (evid: 353)
 *
 * Event description: Tab inside post page opened
 *
 * @param {postPagePostPageSettingsDisplayTabParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} view_mode - desktop, mobile. NOTE: any Null values belong to desktop
 * @property {string} role - role
 * @property {boolean} toggle - toggle, 1 if checked, 0 if unchecked
 * @property {string} section - setting name, i.e. author name and picture, date and reading time, login from blog menu,  etc.
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Post Page Settings, app settings (feed)
 * @property {string} property_value - the value of the property
 * @property {string} app_id - app_id
 * @property {string} property - the property that was changed
 * @property {GUID} msid - msid
 * @return {LogObject<postPagePostPageSettingsDisplayTabParams>} LogObject<postPagePostPageSettingsDisplayTabParams>
 */
export function postPagePostPageSettingsDisplayTab(params) {
    return { evid: 353, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorSettingsDesignTab' event (evid: 356)
 *
 * Event description: Actions on tab inside settings
 *
 * @param {editorSettingsDesignTabParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} view_mode - desktop, mobile. NOTE: any Null values belong to desktop
 * @property {string} role - role
 * @property {boolean} toggle - Deprecate
 * @property {string} section - The section where the changes occurred, i.e. Blog Menu, Posts, Buttons
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Post Page Settings, app settings (feed)
 * @property {string} property_value - the setting value. eg. True,
 * @property {string} app_id - app_id
 * @property {string} property - The property changed e.g. playback speed,
 * @property {GUID} msid - msid
 * @return {LogObject<editorSettingsDesignTabParams>} LogObject<editorSettingsDesignTabParams>
 */
export function editorSettingsDesignTab(params) {
    return { evid: 356, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorSettingsLayoutTab' event (evid: 357)
 *
 * Event description: Layout settings changed in editor. For custom feed all settings are returned in value field, for blog app it's spread to value, value_pagination_type, value_pagination_size. Use "settings" field to distinguish what was changed, origin - to identify blog app (main feed) and custom feed
 *
 * @param {editorSettingsLayoutTabParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} view_mode - desktop, mobile. NOTE: any Null values belong to desktop
 * @property {string} role - role
 * @property {string} tab_name - All poss feed/Category Page
 * @property {string} widget_name - Feed, Custom Feed
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} editor_layout - Computer/Mobile
 * @property {string} origin - Post Page Settings, app settings (feed)
 * @property {string} app_id - app_id
 * @property {number} value_pagination_size - number of posts per page/per load
 * @property {string} value_pagination_type - With page numbers, on scroll....
 * @property {GUID} msid - msid
 * @property {string} value - setting chosen, i.e. Tiled (for layout), On scroll down (for post load), 7 (for posts per page)
 * @property {string} settings - setting name, i.e. layout, post load, posts per page
 * @return {LogObject<editorSettingsLayoutTabParams>} LogObject<editorSettingsLayoutTabParams>
 */
export function editorSettingsLayoutTab(params) {
    return { evid: 357, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogWidgetElementRemoved' event (evid: 358)
 *
 * Event description: Triggered when the user clicks on a CTA that requires selecting multiple posts.
 *
 * @param {blogWidgetElementRemovedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post_id if applicable
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin - examples: related_posts, paid_plans etc..
 * @property {GUID} msid - msid
 * @return {LogObject<blogWidgetElementRemovedParams>} LogObject<blogWidgetElementRemovedParams>
 */
export function blogWidgetElementRemoved(params) {
    return { evid: 358, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postSelectorAction' event (evid: 359)
 *
 * Event description: triggered when the user closes the post selector. Stores the
 *
 * @param {postSelectorActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post_id if applicable
 * @property {string} post_ids - array of post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @property {string} action - The button that the user clicked, Cancel, Done, 'X'
 * @return {LogObject<postSelectorActionParams>} LogObject<postSelectorActionParams>
 */
export function postSelectorAction(params) {
    return { evid: 359, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogSettingsOpenedInBm' event (evid: 360)
 *
 * Event description: Blog settings opened (in BM)
 *
 * @param {blogSettingsOpenedInBmParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - BM_posts
 * @property {string} app_id - app_id
 * @property {GUID} msid - msid
 * @return {LogObject<blogSettingsOpenedInBmParams>} LogObject<blogSettingsOpenedInBmParams>
 */
export function blogSettingsOpenedInBm(params) {
    return { evid: 360, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogSettingsSavedInBm' event (evid: 361)
 *
 * Event description: Blog settings saved (in BM)
 *
 * @param {blogSettingsSavedInBmParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} schema_enabled - 1 - enabled, 0 - didn't
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {number} amp_changed - 1 - changed, 0 - didn't
 * @property {number} emailmembers_changed - 1 - changed, 0 - didn't
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {number} emailsubscribers_changed - 1 - changed, 0 - didn't
 * @property {number} emailmembers_enabled - 1 - enabled, 0 - didn't
 * @property {string} origin - BM_posts
 * @property {number} logo_changed - 1 - added/changed, 0 - didn't
 * @property {number} amp_enabled - 1 - enabled, 0 - didn't
 * @property {string} app_id - app_id
 * @property {number} schema_changed - 1 - changed, 0 - didn't
 * @property {number} emailsubscribers_enabled - 1 - enabled, 0 - didn't
 * @property {GUID} msid - msid
 * @property {string} settings - json string with values 0 - disabled, 1 - enabled, e.g. {AMP: 1, Schema: 0, logo : 0 }
 * @return {LogObject<blogSettingsSavedInBmParams>} LogObject<blogSettingsSavedInBmParams>
 */
export function blogSettingsSavedInBm(params) {
    return { evid: 361, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'imageSettingsPanelInPostEditorOpened' event (evid: 362)
 *
 * Event description: image settings panel in post editor opened
 *
 * @param {imageSettingsPanelInPostEditorOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<imageSettingsPanelInPostEditorOpenedParams>} LogObject<imageSettingsPanelInPostEditorOpenedParams>
 */
export function imageSettingsPanelInPostEditorOpened(params) {
    return { evid: 362, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helperShowed' event (evid: 363)
 *
 * Event description: Helper was showed (for custom feed confusion currently, can be reused later for others if needed)
 *
 * @param {helperShowedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} name - name of helper
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<helperShowedParams>} LogObject<helperShowedParams>
 */
export function helperShowed(params) {
    return { evid: 363, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helperAction' event (evid: 364)
 *
 * Event description: Action on helper_showed (for custom feed confusion currently, can be reused later for others if needed) - close or learn more
 *
 * @param {helperActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} name - name of helper
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {string} action - action in helper (close, learn more)
 * @return {LogObject<helperActionParams>} LogObject<helperActionParams>
 */
export function helperAction(params) {
    return { evid: 364, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'authorOfflineCreated' event (evid: 365)
 *
 * Event description: Created an offline author
 *
 * @param {authorOfflineCreatedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} has_picture - TRUE if a picture is assigned for created author
 * @property {string} author_name - Author name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} author_title - author title
 * @property {string} author_role - Currently "Offline", might be reused later
 * @property {GUID} author_id - Author id which was created
 * @property {GUID} msid - msid
 * @return {LogObject<authorOfflineCreatedParams>} LogObject<authorOfflineCreatedParams>
 */
export function authorOfflineCreated(params) {
    return { evid: 365, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'authorEdited' event (evid: 366)
 *
 * Event description: Author edited.
 *
 * @param {authorEditedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} new_author_name - new name after edit
 * @property {boolean} has_picture - TRUE if author already has a picture (nice to have)
 * @property {boolean} has_cover - does have a cover image
 * @property {boolean} was_picture_changed - if picture was changed on editing author
 * @property {boolean} cover_changed - cover has changed
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} new_author_title - new title after edit
 * @property {string} origin - origin
 * @property {string} author_role - Currently just "Offline/Owner" - might be reused later
 * @property {GUID} author_id - Author id = site member id
 * @property {boolean} was_name_changed - was_name_changed
 * @property {GUID} msid - msid
 * @return {LogObject<authorEditedParams>} LogObject<authorEditedParams>
 */
export function authorEdited(params) {
    return { evid: 366, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'authorOfflineDeleted' event (evid: 367)
 *
 * Event description: Deleted an offline author
 *
 * @param {authorOfflineDeletedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} has_picture - TRUE if a picture is assigned for created author (nice to have)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} author_role - Currently "Offline", might be reused later
 * @property {GUID} author_id - Author id which was created
 * @property {GUID} msid - msid
 * @return {LogObject<authorOfflineDeletedParams>} LogObject<authorOfflineDeletedParams>
 */
export function authorOfflineDeleted(params) {
    return { evid: 367, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogSettingsEditSeoBlogPostsClick' event (evid: 368)
 *
 * Event description: triggered when the user clicks on the edit button on the Blog settings screen, under the SEO settings section.
 *
 * @param {blogSettingsEditSeoBlogPostsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {string} click_name - which cta the user clicked: Posts, Categories or Tags
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {string} referrer - referrer
 * @property {GUID} msid - msid
 * @return {LogObject<blogSettingsEditSeoBlogPostsClickParams>} LogObject<blogSettingsEditSeoBlogPostsClickParams>
 */
export function blogSettingsEditSeoBlogPostsClick(params) {
    return { evid: 368, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogSettingsEditSeoBlogCategoriesClick' event (evid: 369)
 *
 * Event description: triggered when the user clicks on the edit button on the Blog settings screen, under the SEO settings section.
 *
 * @param {blogSettingsEditSeoBlogCategoriesClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {string} referrer - referrer
 * @property {GUID} msid - msid
 * @return {LogObject<blogSettingsEditSeoBlogCategoriesClickParams>} LogObject<blogSettingsEditSeoBlogCategoriesClickParams>
 */
export function blogSettingsEditSeoBlogCategoriesClick(params) {
    return { evid: 369, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'errorMessageShow' event (evid: 372)
 *
 * Event description: whenever an error message is shown (tooltip, modal)
 *
 * @param {errorMessageShowParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} error_type - Error type
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {string} error_message - error message
 * @property {string} type - The way it was displayed: Tooltip, Modal, toast etc..
 * @property {GUID} msid - msid
 * @property {number} error_code - http code
 * @return {LogObject<errorMessageShowParams>} LogObject<errorMessageShowParams>
 */
export function errorMessageShow(params) {
    return { evid: 372, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'errorMessageShowCtaClick' event (evid: 373)
 *
 * Event description: whenever an error msg cta is clicked (customer care, cancel etc..)
 *
 * @param {errorMessageShowCtaClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} error_type - error type
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {string} error_message - error message
 * @property {string} type - The way it was displayed: Tooltip, Modal, toast etc..
 * @property {GUID} msid - msid
 * @property {number} error_code - http error code
 * @property {string} action - the cta clicked - customer care, cancel ... others
 * @return {LogObject<errorMessageShowCtaClickParams>} LogObject<errorMessageShowCtaClickParams>
 */
export function errorMessageShowCtaClick(params) {
    return { evid: 373, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogFeedRenamed' event (evid: 374)
 *
 * Event description: When the user renames the Main blog feed from the BM
 *
 * @param {blogFeedRenamedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} name - The new feed name
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} old_name - The updated value
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} msid - msid
 * @return {LogObject<blogFeedRenamedParams>} LogObject<blogFeedRenamedParams>
 */
export function blogFeedRenamed(params) {
    return { evid: 374, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newCategoryClickSrc69Evid375' event (evid: 375)
 *
 * Event description: triggered when click on "new category" CTA
 *
 * @param {newCategoryClickSrc69Evid375Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<newCategoryClickSrc69Evid375Params>} LogObject<newCategoryClickSrc69Evid375Params>
 */
export function newCategoryClickSrc69Evid375(params) {
    return { evid: 375, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'categoryDeleted' event (evid: 376)
 *
 * Event description: When a category is deleted
 *
 * @param {categoryDeletedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - category language
 * @property {string} origin - post page, post editor, drafts
 * @property {string} category_id - category id
 * @property {string} translation_id - the id of the translated category
 * @property {GUID} msid - msid
 * @return {LogObject<categoryDeletedParams>} LogObject<categoryDeletedParams>
 */
export function categoryDeleted(params) {
    return { evid: 376, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paidPostInsidePostEditorSidebar' event (evid: 377)
 *
 * Event description: Option chosen inside Paid Post in post editor sidebar
 *
 * @param {paidPostInsidePostEditorSidebarParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} option - Get Started/Learn More
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<paidPostInsidePostEditorSidebarParams>} LogObject<paidPostInsidePostEditorSidebarParams>
 */
export function paidPostInsidePostEditorSidebar(params) {
    return { evid: 377, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postEditorAddMediaElementClick' event (evid: 378)
 *
 * Event description: When the user clicks the "+" in the post editor (sidebar or text area)
 *
 * @param {postEditorAddMediaElementClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of the user - writer or admin
 * @property {string} tab_name - Which tab was opened in post settings
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - sidebar or text area
 * @property {GUID} msid - msid
 * @return {LogObject<postEditorAddMediaElementClickParams>} LogObject<postEditorAddMediaElementClickParams>
 */
export function postEditorAddMediaElementClick(params) {
    return { evid: 378, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postEditorAddRemoveMediaElement' event (evid: 379)
 *
 * Event description: When the user clicks the "+" in the post editor (sidebar or text area)
 *
 * @param {postEditorAddRemoveMediaElementParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of the user - writer or admin
 * @property {string} tab_name - image, video, gallery, gif, html code (maybe not necessary)
 * @property {string} adding_method - Click or drag n drop
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - sidebar or composer
 * @property {string} mediaOrigin - upload, embed, giphy  etc..
 * @property {string} media_content - the added media content if applicable (links, file name, html code)
 * @property {string} media_type - image, video etc..
 * @property {GUID} msid - msid
 * @property {string} action_type - Add or Remove
 * @return {LogObject<postEditorAddRemoveMediaElementParams>} LogObject<postEditorAddRemoveMediaElementParams>
 */
export function postEditorAddRemoveMediaElement(params) {
    return { evid: 379, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationHomePageOpened' event (evid: 380)
 *
 * Event description: triggered when Migration home page opened actually open
 *
 * @param {migrationHomePageOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {string} migration_status - First time, In progress, Done (after finishing migration)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @property {boolean} is_full_width - is_full_width (with left nav or not)
 * @return {LogObject<migrationHomePageOpenedParams>} LogObject<migrationHomePageOpenedParams>
 */
export function migrationHomePageOpened(params) {
    return { evid: 380, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationGetStartedClick' event (evid: 381)
 *
 * Event description: triggered when users click on get started
 *
 * @param {migrationGetStartedClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationGetStartedClickParams>} LogObject<migrationGetStartedClickParams>
 */
export function migrationGetStartedClick(params) {
    return { evid: 381, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationMaybeLaterClick' event (evid: 382)
 *
 * Event description: triggered when users click on Maybe later click
 *
 * @param {migrationMaybeLaterClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationMaybeLaterClickParams>} LogObject<migrationMaybeLaterClickParams>
 */
export function migrationMaybeLaterClick(params) {
    return { evid: 382, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationLearnMoreClick' event (evid: 383)
 *
 * Event description: triggered when users click on Maybe Learn more click
 *
 * @param {migrationLearnMoreClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationLearnMoreClickParams>} LogObject<migrationLearnMoreClickParams>
 */
export function migrationLearnMoreClick(params) {
    return { evid: 383, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationImportPageFirstStepOpened' event (evid: 384)
 *
 * Event description: triggered when Migration Import page first step actually open
 *
 * @param {migrationImportPageFirstStepOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {string} migration_status - First time, In progress, Done (after finishing migration)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationImportPageFirstStepOpenedParams>} LogObject<migrationImportPageFirstStepOpenedParams>
 */
export function migrationImportPageFirstStepOpened(params) {
    return { evid: 384, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationCopyPostsClick' event (evid: 385)
 *
 * Event description: triggered when users click on Copy posts
 *
 * @param {migrationCopyPostsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationCopyPostsClickParams>} LogObject<migrationCopyPostsClickParams>
 */
export function migrationCopyPostsClick(params) {
    return { evid: 385, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationCopiedSuccessModalOpened' event (evid: 386)
 *
 * Event description: triggered when Migration Copied success modal opened actually open
 *
 * @param {migrationCopiedSuccessModalOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {string} migration_status - First time, In progress, Done (after finishing migration)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationCopiedSuccessModalOpenedParams>} LogObject<migrationCopiedSuccessModalOpenedParams>
 */
export function migrationCopiedSuccessModalOpened(params) {
    return { evid: 386, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationKeepGoingClick' event (evid: 387)
 *
 * Event description: triggered when users click on Keep going click
 *
 * @param {migrationKeepGoingClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationKeepGoingClickParams>} LogObject<migrationKeepGoingClickParams>
 */
export function migrationKeepGoingClick(params) {
    return { evid: 387, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationCloseModalClick' event (evid: 388)
 *
 * Event description: triggered when users click on Keep going click
 *
 * @param {migrationCloseModalClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {string} modal_name - post transferred, success
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationCloseModalClickParams>} LogObject<migrationCloseModalClickParams>
 */
export function migrationCloseModalClick(params) {
    return { evid: 388, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationImportPageSecondStepOpened' event (evid: 389)
 *
 * Event description: triggered when Migration Import page second step actually open
 *
 * @param {migrationImportPageSecondStepOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {string} migration_status - First time, In progress, Done (after finishing migration)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationImportPageSecondStepOpenedParams>} LogObject<migrationImportPageSecondStepOpenedParams>
 */
export function migrationImportPageSecondStepOpened(params) {
    return { evid: 389, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationUpdateAndPublishClick' event (evid: 390)
 *
 * Event description: triggered when users click on Update and publish click
 *
 * @param {migrationUpdateAndPublishClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationUpdateAndPublishClickParams>} LogObject<migrationUpdateAndPublishClickParams>
 */
export function migrationUpdateAndPublishClick(params) {
    return { evid: 390, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationUpdateUrlsModalOpened' event (evid: 391)
 *
 * Event description: triggered when Migration Update URLs modal actually open
 *
 * @param {migrationUpdateUrlsModalOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {string} migration_status - First time, In progress, Done (after finishing migration)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationUpdateUrlsModalOpenedParams>} LogObject<migrationUpdateUrlsModalOpenedParams>
 */
export function migrationUpdateUrlsModalOpened(params) {
    return { evid: 391, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationUpdateAndPublishConfirmationClick' event (evid: 392)
 *
 * Event description: triggered when users click on Update and publish confirmation click
 *
 * @param {migrationUpdateAndPublishConfirmationClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationUpdateAndPublishConfirmationClickParams>} LogObject<migrationUpdateAndPublishConfirmationClickParams>
 */
export function migrationUpdateAndPublishConfirmationClick(params) {
    return { evid: 392, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationUpdateSuccessModalOpened' event (evid: 393)
 *
 * Event description: triggered when Migration Update URLs modal actually open
 *
 * @param {migrationUpdateSuccessModalOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {string} migration_status - First time, In progress, Done (after finishing migration)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationUpdateSuccessModalOpenedParams>} LogObject<migrationUpdateSuccessModalOpenedParams>
 */
export function migrationUpdateSuccessModalOpened(params) {
    return { evid: 393, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationDoneClick' event (evid: 394)
 *
 * Event description: triggered when users click on done click
 *
 * @param {migrationDoneClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationDoneClickParams>} LogObject<migrationDoneClickParams>
 */
export function migrationDoneClick(params) {
    return { evid: 394, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationGiveFeedbackClick' event (evid: 395)
 *
 * Event description: triggered when users click on Give feedback
 *
 * @param {migrationGiveFeedbackClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationGiveFeedbackClickParams>} LogObject<migrationGiveFeedbackClickParams>
 */
export function migrationGiveFeedbackClick(params) {
    return { evid: 395, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationMigrationFailed' event (evid: 396)
 *
 * Event description: triggered when Migration fails
 *
 * @param {migrationMigrationFailedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {string} migration_status - First time, In progress, Done, Failed (after finishing migration)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationMigrationFailedParams>} LogObject<migrationMigrationFailedParams>
 */
export function migrationMigrationFailed(params) {
    return { evid: 396, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationQuickMigrationAd' event (evid: 397)
 *
 * Event description: Whenever the user clicks one option from the switch to new blog ad. The ad appears within the editor, on the new and old blog 6th button and on the old blog manager.
 *
 * @param {migrationQuickMigrationAdParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} post_id - post id
 * @property {boolean} do_not_show_again - do not show again flag
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - new blog 6th button, old blog 6th button, old blog manager, add panel
 * @property {GUID} msid - msid
 * @property {string} action - switch, find out more, later, close
 * @return {LogObject<migrationQuickMigrationAdParams>} LogObject<migrationQuickMigrationAdParams>
 */
export function migrationQuickMigrationAd(params) {
    return { evid: 397, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationLearnHowToSwitchDeleteOldBlog' event (evid: 398)
 *
 * Event description: Whenever the user clicks on the learn how link from the old blog 6th button - learn how to delete, learn how to switch
 *
 * @param {migrationLearnHowToSwitchDeleteOldBlogParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - old blog 6th button
 * @property {GUID} msid - msid
 * @property {string} action - switch, delete
 * @return {LogObject<migrationLearnHowToSwitchDeleteOldBlogParams>} LogObject<migrationLearnHowToSwitchDeleteOldBlogParams>
 */
export function migrationLearnHowToSwitchDeleteOldBlog(params) {
    return { evid: 398, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogLoadedInEditor' event (evid: 399)
 *
 * Event description: Once blog app loaded in Editor, used for AB test exposure. NOTE: When the Page post is selected and whenever the user switches the view, the event gets triggered 2 times one with Blog feed and another with Post view.
 *
 * @param {blogLoadedInEditorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} editor_view_mode - Computer/Mobile
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {string} blog_view - Blog Feed or Post Page
 * @property {boolean} isPreview - Is it in Preview mode (if not, it's Editor)
 * @return {LogObject<blogLoadedInEditorParams>} LogObject<blogLoadedInEditorParams>
 */
export function blogLoadedInEditor(params) {
    return { evid: 399, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'commentPublishedServer' event (evid: 4)
 *
 * Event description: triggered when UoU published a comment
 *
 * @param {commentPublishedServerParams} params - The parameters for this event
 * @property {number} image_count - image_count in the post
 * @property {boolean} is_demo - is_demo
 * @property {boolean} is_edited - 0 - new comment / 1 - edit (to know if its posted for first time)
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor_id
 * @property {number} giphy_count - count of used  giphy gifs
 * @property {string} comment_id - the id of the comment
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {number} video_count - video_count in the post
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<commentPublishedServerParams>} LogObject<commentPublishedServerParams>
 */
export function commentPublishedServer(params) {
    return { evid: 4, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationPostCopyingStatus' event (evid: 401)
 *
 * Event description: Triggered when the migration completes both successfully or failed.
 *
 * @param {migrationPostCopyingStatusParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} migration_succeed - 1 - yes / 0 - no
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} visitor_id - visitor_id
 * @property {number} num_posts_total - the number of total posts to copy
 * @property {number} num_posts_unsucc - the number of posts that weren't copied
 * @property {GUID} post_stable_id - post_stable_id
 * @property {boolean} was_post_too_big - was_post_too_big
 * @property {string} error_message - error message if unsuscessfull
 * @property {string} posts_with_too_large_content
 * @property {GUID} msid - msid
 * @property {number} too_large_post_count - too_large_post_count
 * @return {LogObject<migrationPostCopyingStatusParams>} LogObject<migrationPostCopyingStatusParams>
 */
export function migrationPostCopyingStatus(params) {
    return { evid: 401, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appInstallAutopilot' event (evid: 402)
 *
 * Event description: sends if app was installed, used for autopilot for post page migration
 *
 * @param {appInstallAutopilotParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} uuid - uuid
 * @property {string} __cookies_prefix__uuid - __cookies_prefix__uuid
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} app_id - installed app id
 * @property {GUID} msid - msid
 * @return {LogObject<appInstallAutopilotParams>} LogObject<appInstallAutopilotParams>
 */
export function appInstallAutopilot(params) {
    return { evid: 402, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateBlogModalShown' event (evid: 405)
 *
 * Event description: Whenver the user sees the migration option - Migration message shown
 *
 * @param {updateBlogModalShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {boolean} new_blog_valid - TRUE if new Blog is installed (nice to have)
 * @property {string} screen_name - screen_name
 * @property {string} modal_name - "Upgrade to the new blog".; "Magic Migration Blog Out of date"; "Magic Migration Blog Out of date - update options"
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin - 6th button or right after opening Editor or some other place
 * @property {GUID} msid - msid
 * @return {LogObject<updateBlogModalShownParams>} LogObject<updateBlogModalShownParams>
 */
export function updateBlogModalShown(params) {
    return { evid: 405, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateBlogModalAction' event (evid: 406)
 *
 * Event description: Action on migration message (shown - evid 405)
 *
 * @param {updateBlogModalActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {boolean} new_blog_valid - if the site has new blog installed
 * @property {string} screen_name - screen_name
 * @property {string} modal_name - "Upgrade to the new blog".; "Magic Migration Blog Out of date"; "Magic Migration Blog Out of date - update options"
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin (nice to have if we get any)
 * @property {string} choice - Content update/Content and design update
 * @property {string} choise - Content update/Content and design update - if user has both blogs (NOT USED)
 * @property {GUID} msid - msid
 * @property {string} action - action - close, learn more, update now
 * @return {LogObject<updateBlogModalActionParams>} LogObject<updateBlogModalActionParams>
 */
export function updateBlogModalAction(params) {
    return { evid: 406, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'magicMigrationStart' event (evid: 409)
 *
 * Event description: Magic Migration Failed after copied posts, error message
 *
 * @param {magicMigrationStartParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} error_message - error_message
 * @property {string} migration_step - migration step error occuried
 * @property {GUID} msid - msid
 * @return {LogObject<magicMigrationStartParams>} LogObject<magicMigrationStartParams>
 */
export function magicMigrationStart(params) {
    return { evid: 409, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'magicMigrationFinish' event (evid: 410)
 *
 * Event description: Tracks steps on the ultimate migration (old blog)
 *
 * @param {magicMigrationFinishParams} params - The parameters for this event
 * @property {boolean} is_demo - is_demo
 * @property {DateTime} startTime - when the step started
 * @property {GUID} biToken - msid
 * @property {GUID} old_instance_id - the old blog instance_id
 * @property {DateTime} endTime - when did the step end
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} error_message - error msg
 * @property {string} migration_step - Migration step
 * @return {LogObject<magicMigrationFinishParams>} LogObject<magicMigrationFinishParams>
 */
export function magicMigrationFinish(params) {
    return { evid: 410, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfMagicMigrationStart' event (evid: 411)
 *
 * Event description: Triggered when the migration completes both successfully or failed.
 *
 * @param {copyOfMagicMigrationStartParams} params - The parameters for this event
 * @property {GUID} instanceid - instance_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<copyOfMagicMigrationStartParams>} LogObject<copyOfMagicMigrationStartParams>
 */
export function copyOfMagicMigrationStart(params) {
    return { evid: 411, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'magicMigrationFinishSrc69Evid412' event (evid: 412)
 *
 * Event description: Triggered when the migration completes both successfully or failed.
 *
 * @param {magicMigrationFinishSrc69Evid412Params} params - The parameters for this event
 * @property {GUID} instanceid - instance_id
 * @property {string} error_reason - Error reason if not successful
 * @property {boolean} is_successful - was successful
 * @property {GUID} bi_token - msid
 * @return {LogObject<magicMigrationFinishSrc69Evid412Params>} LogObject<magicMigrationFinishSrc69Evid412Params>
 */
export function magicMigrationFinishSrc69Evid412(params) {
    return { evid: 412, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hoverOnTooltip' event (evid: 413)
 *
 * Event description: Fired when the user hovers a tooltip
 *
 * @param {hoverOnTooltipParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {string} tooltip_name - tooltip name
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} text - the tooltip text
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<hoverOnTooltipParams>} LogObject<hoverOnTooltipParams>
 */
export function hoverOnTooltip(params) {
    return { evid: 413, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'multilingualLanguagePickerOpen' event (evid: 415)
 *
 * Event description: Triggered when the user clicks and opens on the language picker
 *
 * @param {multilingualLanguagePickerOpenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance id
 * @property {GUID} biToken - instance id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} tabName - tab name
 * @property {boolean} isFilter - is the language picker a filter?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} msid - instance id
 * @return {LogObject<multilingualLanguagePickerOpenParams>} LogObject<multilingualLanguagePickerOpenParams>
 */
export function multilingualLanguagePickerOpen(params) {
    return { evid: 415, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'multilingualLanguagePickerLanguageClick' event (evid: 416)
 *
 * Event description: Triggered when the user chooses a language from the language picker
 *
 * @param {multilingualLanguagePickerLanguageClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance id
 * @property {GUID} biToken - instance id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} language_selected - language selected
 * @property {string} tabName - tab name
 * @property {boolean} isFilter - is the language picker a filter?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} msid - instance id
 * @return {LogObject<multilingualLanguagePickerLanguageClickParams>} LogObject<multilingualLanguagePickerLanguageClickParams>
 */
export function multilingualLanguagePickerLanguageClick(params) {
    return { evid: 416, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'multilingualCategoryTranslateClick' event (evid: 417)
 *
 * Event description: triggered when click on translate CTA
 *
 * @param {multilingualCategoryTranslateClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {string} category_id - category id
 * @property {string} translation_id - the category id of the translated post
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<multilingualCategoryTranslateClickParams>} LogObject<multilingualCategoryTranslateClickParams>
 */
export function multilingualCategoryTranslateClick(params) {
    return { evid: 417, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'multilingualHoverTranslateGlobe' event (evid: 418)
 *
 * Event description: triggered when user hovers on the translate globe.
 *
 * @param {multilingualHoverTranslateGlobeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} tabName - tab name: published, drafts, trash,  categories
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<multilingualHoverTranslateGlobeParams>} LogObject<multilingualHoverTranslateGlobeParams>
 */
export function multilingualHoverTranslateGlobe(params) {
    return { evid: 418, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorCustomizeLayoutButtonClick' event (evid: 420)
 *
 * Event description: User clicked customize layout from the while editing the blog or post feed
 *
 * @param {editorCustomizeLayoutButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - post list, blog feed
 * @property {string} layout - the selected layout
 * @property {GUID} msid - msid
 * @return {LogObject<editorCustomizeLayoutButtonClickParams>} LogObject<editorCustomizeLayoutButtonClickParams>
 */
export function editorCustomizeLayoutButtonClick(params) {
    return { evid: 420, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixPostImporterImportStarted' event (evid: 421)
 *
 * Event description: Wix post importer: Import Started.
 *
 * @param {wixPostImporterImportStartedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {number} num_posts_total - the number of posts to be imported
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - the instance_id from which the posts were imported
 * @property {GUID} original_msid - the msid from which the posts were imported
 * @property {GUID} msid - msid
 * @return {LogObject<wixPostImporterImportStartedParams>} LogObject<wixPostImporterImportStartedParams>
 */
export function wixPostImporterImportStarted(params) {
    return { evid: 421, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixPostImporterImportFinished' event (evid: 422)
 *
 * Event description: Triggered when the import wix posts process starts
 *
 * @param {wixPostImporterImportFinishedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} fail_reason - if the import failed what was the reason
 * @property {number} num_posts_total - the number of posts to be imported
 * @property {number} num_posts_unsucc - number of posts that failed to import
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} original_instance_id - the instance_id from which the posts were imported
 * @property {GUID} original_msid - the msid from which the posts were imported
 * @property {boolean} is_successful - was the import successful
 * @property {GUID} msid - msid
 * @return {LogObject<wixPostImporterImportFinishedParams>} LogObject<wixPostImporterImportFinishedParams>
 */
export function wixPostImporterImportFinished(params) {
    return { evid: 422, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postTemplatesWriteNewPostFromTemplateClick' event (evid: 423)
 *
 * Event description: triggered when click on write new post from template
 *
 * @param {postTemplatesWriteNewPostFromTemplateClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {boolean} is_offline - if the event happened offline
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<postTemplatesWriteNewPostFromTemplateClickParams>} LogObject<postTemplatesWriteNewPostFromTemplateClickParams>
 */
export function postTemplatesWriteNewPostFromTemplateClick(params) {
    return { evid: 423, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postTemplatesSelectTemplateFromListClick' event (evid: 424)
 *
 * Event description: triggered when click on a template from the list
 *
 * @param {postTemplatesSelectTemplateFromListClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} template_name - template name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} templateCategory - template category
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {boolean} is_offline - if the event happened offline
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @property {string} template_id - the template id clicked
 * @return {LogObject<postTemplatesSelectTemplateFromListClickParams>} LogObject<postTemplatesSelectTemplateFromListClickParams>
 */
export function postTemplatesSelectTemplateFromListClick(params) {
    return { evid: 424, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postTemplatesFilterTemplateByCategory' event (evid: 425)
 *
 * Event description: triggered when click on a template category from the drop down list
 *
 * @param {postTemplatesFilterTemplateByCategoryParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} templateCategory - template category
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {boolean} is_offline - if the event happened offline
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<postTemplatesFilterTemplateByCategoryParams>} LogObject<postTemplatesFilterTemplateByCategoryParams>
 */
export function postTemplatesFilterTemplateByCategory(params) {
    return { evid: 425, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postTemplatesUseThisTemplateClick' event (evid: 426)
 *
 * Event description: triggered when click on use this template CTA
 *
 * @param {postTemplatesUseThisTemplateClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} template_name - template name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} templateCategory - template category
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {boolean} is_offline - if the event happened offline
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @property {string} template_id - template id
 * @return {LogObject<postTemplatesUseThisTemplateClickParams>} LogObject<postTemplatesUseThisTemplateClickParams>
 */
export function postTemplatesUseThisTemplateClick(params) {
    return { evid: 426, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postEditorHelpPanelClick' event (evid: 432)
 *
 * Event description: Whenever a user clicks on any link on the help panel.
 *
 * @param {postEditorHelpPanelClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} click_name - click name
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post. stable id
 * @property {string} language - Language
 * @property {string} origin - origin
 * @property {string} translation_id - translation_id
 * @property {GUID} msid - msid
 * @return {LogObject<postEditorHelpPanelClickParams>} LogObject<postEditorHelpPanelClickParams>
 */
export function postEditorHelpPanelClick(params) {
    return { evid: 432, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postHistoryViewPostHistoryClick' event (evid: 433)
 *
 * Event description: triggered when click on view post history CTA
 *
 * @param {postHistoryViewPostHistoryClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - for multilingual
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {boolean} is_offline - if the event happened offline
 * @property {string} translation_id - translation id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<postHistoryViewPostHistoryClickParams>} LogObject<postHistoryViewPostHistoryClickParams>
 */
export function postHistoryViewPostHistoryClick(params) {
    return { evid: 433, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postHistoryPostHistoryScreenShown' event (evid: 434)
 *
 * Event description: When the user sees the post history screen
 *
 * @param {postHistoryPostHistoryScreenShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post_id if applicable
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - language
 * @property {string} origin - origin - examples: related_posts, paid_plans etc..
 * @property {string} translation_id - translation id
 * @property {number} revision_count - the number of revisions displayed
 * @property {GUID} msid - msid
 * @return {LogObject<postHistoryPostHistoryScreenShownParams>} LogObject<postHistoryPostHistoryScreenShownParams>
 */
export function postHistoryPostHistoryScreenShown(params) {
    return { evid: 434, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postHistoryPostHistoryScreenClicks' event (evid: 435)
 *
 * Event description: Post history - post history screen clicks.
 *
 * @param {postHistoryPostHistoryScreenClicksParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {string} click_name - click_name
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post_id if applicable
 * @property {string} revisionId - revision id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} origin - origin - examples: related_posts, paid_plans etc..
 * @property {string} translation_id - translation id
 * @property {number} revision_count - the number of revisions displayed
 * @property {GUID} msid - msid
 * @return {LogObject<postHistoryPostHistoryScreenClicksParams>} LogObject<postHistoryPostHistoryScreenClicksParams>
 */
export function postHistoryPostHistoryScreenClicks(params) {
    return { evid: 435, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postHistoryRevisionRestoredSuccessfully' event (evid: 436)
 *
 * Event description: When the revision was successfully restored
 *
 * @param {postHistoryRevisionRestoredSuccessfullyParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post_id if applicable
 * @property {string} revisionId - post revision id
 * @property {string} original_revision_id - post original revision id
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - language
 * @property {string} origin - origin - examples: related_posts, paid_plans etc..
 * @property {string} translation_id - translation id
 * @property {GUID} msid - msid
 * @return {LogObject<postHistoryRevisionRestoredSuccessfullyParams>} LogObject<postHistoryRevisionRestoredSuccessfullyParams>
 */
export function postHistoryRevisionRestoredSuccessfully(params) {
    return { evid: 436, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'buisinessManagerClickThatDirectsOutOfBm' event (evid: 437)
 *
 * Event description: When the user clicks on a CTA within the BM, that leads to another page outside blog scope. eg. Editor, App market etc..
 *
 * @param {buisinessManagerClickThatDirectsOutOfBmParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {string} click_name - click name
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - Language
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @property {string} destination - where is the user being routed to, Editor, app market
 * @return {LogObject<buisinessManagerClickThatDirectsOutOfBmParams>} LogObject<buisinessManagerClickThatDirectsOutOfBmParams>
 */
export function buisinessManagerClickThatDirectsOutOfBm(params) {
    return { evid: 437, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postTemplatesSeeMoreTemplatesClick' event (evid: 438)
 *
 * Event description: triggered when click on write new post from template
 *
 * @param {postTemplatesSeeMoreTemplatesClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} origin - origin
 * @property {boolean} is_offline - if the event happened offline
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<postTemplatesSeeMoreTemplatesClickParams>} LogObject<postTemplatesSeeMoreTemplatesClickParams>
 */
export function postTemplatesSeeMoreTemplatesClick(params) {
    return { evid: 438, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'noteClick' event (evid: 439)
 *
 * Event description: BI event firing when clicking on Note in Post Editor
 *
 * @param {noteClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - can be : owner , writer, editor
 * @property {GUID} visitor_id - visitor ID
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} parent_resource_id - notes' parent entity GUID ( e.g. post, group, event, post etc)
 * @property {string} app_id - app_id
 * @property {GUID} site_member_id - member ID after logging to Wix site
 * @property {GUID} msid - msid
 * @return {LogObject<noteClickParams>} LogObject<noteClickParams>
 */
export function noteClick(params) {
    return { evid: 439, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickingOnPost' event (evid: 440)
 *
 * Event description: Sending an event when clicking on Post from Owner App, Comments section
 *
 * @param {clickingOnPostParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role
 * @property {string} post_id - The post that was clicked
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where the post was clicked from ( in this case Comments)
 * @property {GUID} msid - msid
 * @return {LogObject<clickingOnPostParams>} LogObject<clickingOnPostParams>
 */
export function clickingOnPost(params) {
    return { evid: 440, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnLink' event (evid: 441)
 *
 * Event description: Click on Link.
 *
 * @param {clickOnLinkParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} tab_name - tab_name
 * @property {GUID} uuid - uuid
 * @property {string} origin_name - origin_name
 * @property {string} button_name - How the button is named
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - For example: ‘Blog’ , ‘RSS Widget’ , ‘Post Page’ , ‘Post List’ and so on
 * @property {GUID} msid - msid
 * @property {Url} button_link - the link of the button( particular support page)
 * @return {LogObject<clickOnLinkParams>} LogObject<clickOnLinkParams>
 */
export function clickOnLink(params) {
    return { evid: 441, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppSharePostButtonTypeClick' event (evid: 442)
 *
 * Event description: user clicked on share button type (sends sms, share social, copy link etc..) in oneapp
 *
 * @param {oneAppSharePostButtonTypeClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance id
 * @property {GUID} biToken - biToken
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {string} button_name - sends via sms, share via social, copy invite link etc..
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - post page, view post etc.
 * @property {GUID} msid - biToken
 * @return {LogObject<oneAppSharePostButtonTypeClickParams>} LogObject<oneAppSharePostButtonTypeClickParams>
 */
export function oneAppSharePostButtonTypeClick(params) {
    return { evid: 442, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppScrollPositionInPostForReadingTime' event (evid: 444)
 *
 * Event description: triggered when view post type clicked: space by wix or mobile web
 *
 * @param {oneAppScrollPositionInPostForReadingTimeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {string} button_name - button name clicked under view post: space by wix or mobile web
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - language
 * @property {string} origin - which page the action took place in - view post, more actions..
 * @property {boolean} is_offline - if the action happened while offline
 * @property {string} translation_id - the original post stable_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<oneAppScrollPositionInPostForReadingTimeParams>} LogObject<oneAppScrollPositionInPostForReadingTimeParams>
 */
export function oneAppScrollPositionInPostForReadingTime(params) {
    return { evid: 444, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postModerationButtonClick' event (evid: 446)
 *
 * Event description: When owner/guest_writer clicks one of the main buttons: review/edit/view_post in pending review tab.
 *
 * @param {postModerationButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post_id
 * @property {string} button_name - the button name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - post page
 * @property {GUID} msid - msid
 * @return {LogObject<postModerationButtonClickParams>} LogObject<postModerationButtonClickParams>
 */
export function postModerationButtonClick(params) {
    return { evid: 446, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postModerationStatus' event (evid: 447)
 *
 * Event description: Tracks post's status: sent_for_approval/approved/rejected_and_reverted/reverted/updated/deleted/translated/
 *
 * @param {postModerationStatusParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} image_count - image_count in the post
 * @property {boolean} is_demo - is_demo
 * @property {string} previous_post_status - previous_post_status
 * @property {string} screen_name - screen_name
 * @property {boolean} is_edited - 0 - new post / 1 - edit (to know if its posted for first time)
 * @property {string} post_title - post_title
 * @property {string} role - DONT USE! member role (owner, writer, member) (use 'roles')
 * @property {string} url - url
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {boolean} has_gallery - NOT IN USE: 0 - no gallery / 1 - published with gallery
 * @property {string} referral_info - NOT IN USE: external links - facebook, social networks. if from wix then null
 * @property {number} giphy_count - giphy_count
 * @property {string} tag_ids - tag_ids
 * @property {number} categories_count - categories_count
 * @property {boolean} used_html - 0 - didnt used html component / 1 - used html component
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - for multilingual
 * @property {number} character_count - character_count
 * @property {string} original_post_id - the original post id
 * @property {string} community_id - NOT IN USE: community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - Currently being used for wix reads posts.in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} new_post_status - current post status: sent_for_approval/approved/rejected_and_reverted/reverted/updated/deleted/translated/
 * @property {string} translation_id - the post_stable_id of the post that was translated
 * @property {GUID} app_id - app_id
 * @property {GUID} author_id - author id
 * @property {string} paid_plan_id - paid_plan_id
 * @property {number} video_count - video_count
 * @property {GUID} msid - msid
 * @property {boolean} is_published - is_published
 * @property {string} galleries - will sent as array - [{ layout: 'masonry', count: 5}, { layout: 'whatever', count: 10 }]
 * @property {string} related_post_ids - related_post_ids
 * @return {LogObject<postModerationStatusParams>} LogObject<postModerationStatusParams>
 */
export function postModerationStatus(params) {
    return { evid: 447, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixBlogPostPageReadingStartSrc69Evid448' event (evid: 448)
 *
 * Event description: When a blog post page is opened in screen
 *
 * @param {wixBlogPostPageReadingStartSrc69Evid448Params} params - The parameters for this event
 * @property {GUID} post_stable_id - post_stable_id
 * @return {LogObject<wixBlogPostPageReadingStartSrc69Evid448Params>} LogObject<wixBlogPostPageReadingStartSrc69Evid448Params>
 */
export function wixBlogPostPageReadingStartSrc69Evid448(params) {
    return { evid: 448, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixBlogPostPageReadingEndSrc69Evid449' event (evid: 449)
 *
 * Event description: When a blog post page is closed/not in focus
 *
 * @param {wixBlogPostPageReadingEndSrc69Evid449Params} params - The parameters for this event
 * @property {GUID} post_stable_id - post stable id
 * @return {LogObject<wixBlogPostPageReadingEndSrc69Evid449Params>} LogObject<wixBlogPostPageReadingEndSrc69Evid449Params>
 */
export function wixBlogPostPageReadingEndSrc69Evid449(params) {
    return { evid: 449, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppPostFreeDotsClick' event (evid: 450)
 *
 * Event description: triggered when three dots are clicked in OneApp Post View
 *
 * @param {oneAppPostFreeDotsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - language
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {string} translation_id - translation id
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<oneAppPostFreeDotsClickParams>} LogObject<oneAppPostFreeDotsClickParams>
 */
export function oneAppPostFreeDotsClick(params) {
    return { evid: 450, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppPostFreeDotsButtonClick' event (evid: 451)
 *
 * Event description: triggered when button, after opened three dots (evid 450), are clicked in OneApp
 *
 * @param {oneAppPostFreeDotsButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} button_name - button name clicked inside three dots: (Un)Follow post, Disable(Enable) Comments, Edit, Share, Delete. On Edit, Share and Delete, flag is not used
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - language
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {boolean} is_offline - if the action happened while offline
 * @property {boolean} flag - 0 - disabled / 1 - enabled
 * @property {string} translation_id - the original post stable_id
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<oneAppPostFreeDotsButtonClickParams>} LogObject<oneAppPostFreeDotsButtonClickParams>
 */
export function oneAppPostFreeDotsButtonClick(params) {
    return { evid: 451, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppCategoriesPanelOpened' event (evid: 452)
 *
 * Event description: triggered when categories drop down is opened in OneApp
 *
 * @param {oneAppCategoriesPanelOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @return {LogObject<oneAppCategoriesPanelOpenedParams>} LogObject<oneAppCategoriesPanelOpenedParams>
 */
export function oneAppCategoriesPanelOpened(params) {
    return { evid: 452, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppChoseCategory' event (evid: 453)
 *
 * Event description: triggered when category filter is chosen in oneapp
 *
 * @param {oneAppChoseCategoryParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in
 * @property {string} category_id - category_id
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @return {LogObject<oneAppChoseCategoryParams>} LogObject<oneAppChoseCategoryParams>
 */
export function oneAppChoseCategory(params) {
    return { evid: 453, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppSeeAllClickInPostsFeed' event (evid: 454)
 *
 * Event description: triggered when see all is clicked in posts feed in OneApp
 *
 * @param {oneAppSeeAllClickInPostsFeedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @return {LogObject<oneAppSeeAllClickInPostsFeedParams>} LogObject<oneAppSeeAllClickInPostsFeedParams>
 */
export function oneAppSeeAllClickInPostsFeed(params) {
    return { evid: 454, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppMigrationModalOpen' event (evid: 455)
 *
 * Event description: triggered when user gets Blog migration modal in OneApp
 *
 * @param {oneAppMigrationModalOpenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} site_member_id - site_member_id
 * @return {LogObject<oneAppMigrationModalOpenParams>} LogObject<oneAppMigrationModalOpenParams>
 */
export function oneAppMigrationModalOpen(params) {
    return { evid: 455, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppMigrationGetInviteClick' event (evid: 456)
 *
 * Event description: triggered when user clicks 'get invited' to new Wix blog
 *
 * @param {oneAppMigrationGetInviteClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} site_member_id - site_member_id
 * @return {LogObject<oneAppMigrationGetInviteClickParams>} LogObject<oneAppMigrationGetInviteClickParams>
 */
export function oneAppMigrationGetInviteClick(params) {
    return { evid: 456, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppPostPageBottomBarClick' event (evid: 457)
 *
 * Event description: When the user clicks on the Bottom bar from within the post page (Like,
 *
 * @param {oneAppPostPageBottomBarClickParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {string} click_name - Like/Unkike, Comment, Share
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids array
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post stable Id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - the member Id on the site
 * @return {LogObject<oneAppPostPageBottomBarClickParams>} LogObject<oneAppPostPageBottomBarClickParams>
 */
export function oneAppPostPageBottomBarClick(params) {
    return { evid: 457, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppBookmarkClick' event (evid: 458)
 *
 * Event description: triggered when uou clicking or unclicking bookmark
 *
 * @param {oneAppBookmarkClickParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} post_id - post_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} click_origin - weather it was on the bottom bar or toast
 * @property {GUID} post_stable_id - new immutable post_id
 * @property {string} origin - which page the action took place in - post_page, blog_feed, my_saved_posts_page
 * @property {boolean} flag - 0 - unliked / 1 - like
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @return {LogObject<oneAppBookmarkClickParams>} LogObject<oneAppBookmarkClickParams>
 */
export function oneAppBookmarkClick(params) {
    return { evid: 458, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppMySavedPostsPageOpened' event (evid: 459)
 *
 * Event description: triggered when blog My saved posts page opened (uou)
 *
 * @param {oneAppMySavedPostsPageOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - post_feed, post_page
 * @return {LogObject<oneAppMySavedPostsPageOpenedParams>} LogObject<oneAppMySavedPostsPageOpenedParams>
 */
export function oneAppMySavedPostsPageOpened(params) {
    return { evid: 459, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'commentDeletedServer' event (evid: 5)
 *
 * Event description: triggered when UoU deletes a comment
 *
 * @param {commentDeletedServerParams} params - The parameters for this event
 * @property {number} image_count - image_count in the post
 * @property {boolean} is_demo - is_demo
 * @property {boolean} is_edited - 0 - new comment / 1 - edit (to know if its posted for first time)
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor_id
 * @property {number} giphy_count - count of used  giphy gifs
 * @property {string} comment_id - the id of the comment
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {number} video_count - video_count in the post
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<commentDeletedServerParams>} LogObject<commentDeletedServerParams>
 */
export function commentDeletedServer(params) {
    return { evid: 5, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tagCreatedServer' event (evid: 6)
 *
 * Event description: Whenever a tag is created
 *
 * @param {tagCreatedServerParams} params - The parameters for this event
 * @property {GUID} tag_guid - the stable id for tags
 * @property {boolean} is_demo - is_demo
 * @property {string} role - role
 * @property {GUID} biToken - msid
 * @property {string} tagid - tag id
 * @property {GUID} uuid - uuid
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} origin - origin
 * @property {string} translation_id - translation id
 * @property {string} tag_name - tag name
 * @return {LogObject<tagCreatedServerParams>} LogObject<tagCreatedServerParams>
 */
export function tagCreatedServer(params) {
    return { evid: 6, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'widgetAddClickAppBuilder' event (evid: 701)
 *
 * Event description: user clicks to add widget
 *
 * @param {widgetAddClickAppBuilderParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} widget_id - widget_id
 * @property {GUID} id - unique widget id to connect to other events
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Add Panel/6th button
 * @property {string} element_type - recent post, custom feed, wix code
 * @property {GUID} msid - msid
 * @return {LogObject<widgetAddClickAppBuilderParams>} LogObject<widgetAddClickAppBuilderParams>
 */
export function widgetAddClickAppBuilder(params) {
    return { evid: 701, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogAiAssistantStartDemoDataInjectionAttempt' event (evid: 798)
 *
 * Event description: Attempt for injecting demo data with app
 *
 * @param {blogAiAssistantStartDemoDataInjectionAttemptParams} params - The parameters for this event
 * @property {string} app_id - app_id
 * @property {GUID} msid - msid
 * @property {string} request_id - request_id
 * @return {LogObject<blogAiAssistantStartDemoDataInjectionAttemptParams>} LogObject<blogAiAssistantStartDemoDataInjectionAttemptParams>
 */
export function blogAiAssistantStartDemoDataInjectionAttempt(params) {
    return { evid: 798, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogAiAssistantCompletedDemoDataInjectionAttempt' event (evid: 799)
 *
 * Event description: AI Assistant - Completed Demo Data Injection Attempt
 *
 * @param {blogAiAssistantCompletedDemoDataInjectionAttemptParams} params - The parameters for this event
 * @property {string} app_id - app_id
 * @property {number} work_time - time from request start to completion in ms
 * @return {LogObject<blogAiAssistantCompletedDemoDataInjectionAttemptParams>} LogObject<blogAiAssistantCompletedDemoDataInjectionAttemptParams>
 */
export function blogAiAssistantCompletedDemoDataInjectionAttempt(params) {
    return { evid: 799, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tagDeletedServer' event (evid: 8)
 *
 * Event description: tag was deleted from the blog
 *
 * @param {tagDeletedServerParams} params - The parameters for this event
 * @property {GUID} tag_guid - tag stable id
 * @property {boolean} is_demo - is_demo
 * @property {string} role - role
 * @property {string} tagid - tag id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {string} translation_id - translation_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<tagDeletedServerParams>} LogObject<tagDeletedServerParams>
 */
export function tagDeletedServer(params) {
    return { evid: 8, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogAiAssistantOpenAiCall' event (evid: 800)
 *
 * Event description: AI Assistant - OpenAI Call
 *
 * @param {blogAiAssistantOpenAiCallParams} params - The parameters for this event
 * @property {number} duration - milliseconds between start and finish of generation request to ai gateway
 * @property {string} inputText - input to prompt
 * @property {boolean} is_error - is_error
 * @property {GUID} msid - msid
 * @property {boolean} isFallback - is_fallback
 * @property {number} orderIndex - message order index in chat that was the last one in the chat in this prompt
 * @property {string} outputText - output from prompt
 * @property {string} promptId - promptid
 * @property {string} vendorid - vendorID of the call
 * @return {LogObject<blogAiAssistantOpenAiCallParams>} LogObject<blogAiAssistantOpenAiCallParams>
 */
export function blogAiAssistantOpenAiCall(params) {
    return { evid: 800, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postTranslationCreatedServer' event (evid: 83)
 *
 * Event description: Whenever a post translation is created. will be used to create a map between original posts and their respective translations
 *
 * @param {postTranslationCreatedServerParams} params - The parameters for this event
 * @property {boolean} is_demo - is_demo
 * @property {string} original_language - original language
 * @property {string} role - role
 * @property {GUID} biToken - msid
 * @property {string} post_id - the translation post_id
 * @property {GUID} uuid - uuid
 * @property {GUID} original_post_stable_id - post_stable_id that was translated
 * @property {string} translation_type - auto_translate/manual
 * @property {GUID} post_stable_id - the translation stable post
 * @property {string} language - the translation language
 * @property {string} original_post_id - post_id that was translated
 * @property {string} origin - origin
 * @property {string} translation_id - translation_id
 * @return {LogObject<postTranslationCreatedServerParams>} LogObject<postTranslationCreatedServerParams>
 */
export function postTranslationCreatedServer(params) {
    return { evid: 83, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfPostTranslationCreatedServer' event (evid: 84)
 *
 * Event description: Whenever a post translation is created. will be used to create a map between original posts and their respective translations
 *
 * @param {copyOfPostTranslationCreatedServerParams} params - The parameters for this event
 * @property {boolean} is_demo - is_demo
 * @property {string} original_language - original language
 * @property {string} role - role
 * @property {GUID} biToken - msid
 * @property {string} original_category_id - category_id that was translated
 * @property {GUID} original_category_stable_id - category_stable_id that was translated
 * @property {GUID} uuid - uuid
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - the translation language
 * @property {string} origin - origin
 * @property {string} category_id - the translation category Id
 * @property {string} translation_id - the translation id created
 * @property {GUID} category_stable_id - the translation stable category id
 * @return {LogObject<copyOfPostTranslationCreatedServerParams>} LogObject<copyOfPostTranslationCreatedServerParams>
 */
export function copyOfPostTranslationCreatedServer(params) {
    return { evid: 84, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'importStatusChange' event (evid: 8701)
 *
 * Event description: Blog import status change
 *
 * @param {importStatusChangeParams} params - The parameters for this event
 * @property {string} status - READY, IN_PROGRESS, FAILED, SUCCESSFUL
 * @property {string} errorMessage - error_message
 * @return {LogObject<importStatusChangeParams>} LogObject<importStatusChangeParams>
 */
export function importStatusChange(params) {
    return { evid: 8701, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dataImportStatusChange' event (evid: 8703)
 *
 * Event description: Blog import status change
 *
 * @param {dataImportStatusChangeParams} params - The parameters for this event
 * @property {string} errorMessage - errorMessage
 * @property {string} wordpressId - entity wordpress id
 * @property {string} id - id
 * @property {string} importStatus - NOT_STARTED, FINISHED, FAILED
 * @return {LogObject<dataImportStatusChangeParams>} LogObject<dataImportStatusChangeParams>
 */
export function dataImportStatusChange(params) {
    return { evid: 8703, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'xmlPostImporterImportStartedServer' event (evid: 8704)
 *
 * Event description: Server event for when the user starts the post import
 *
 * @param {xmlPostImporterImportStartedServerParams} params - The parameters for this event
 * @property {string} role - role
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {number} num_posts_total - the number of posts to be imported
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @return {LogObject<xmlPostImporterImportStartedServerParams>} LogObject<xmlPostImporterImportStartedServerParams>
 */
export function xmlPostImporterImportStartedServer(params) {
    return { evid: 8704, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'xmlPostImporterImportFinishedServer' event (evid: 8705)
 *
 * Event description: Server event for when the user starts the post import
 *
 * @param {xmlPostImporterImportFinishedServerParams} params - The parameters for this event
 * @property {string} role - role
 * @property {GUID} biToken - msid
 * @property {string} fail_reason - if the import failed what was the reason
 * @property {GUID} uuid - uuid
 * @property {number} num_posts_total - the number of posts to be imported
 * @property {number} num_posts_unsucc - number of posts that failed to import
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {boolean} is_successful - was the import successful
 * @return {LogObject<xmlPostImporterImportFinishedServerParams>} LogObject<xmlPostImporterImportFinishedServerParams>
 */
export function xmlPostImporterImportFinishedServer(params) {
    return { evid: 8705, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'likeClickServer' event (evid: 9)
 *
 * Event description: triggered when uou clicking like or unlike
 *
 * @param {likeClickServerParams} params - The parameters for this event
 * @property {boolean} is_demo - is_demo
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} biToken - msid
 * @property {string} post_id - post_id
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comment_id - comment_id of like clicked (can be used to separate like clicks between comments and posts). Currently OneApp only
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {boolean} flag - 0 - unliked / 1 - like
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {number} likes_count - the current counter on the site
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<likeClickServerParams>} LogObject<likeClickServerParams>
 */
export function likeClickServer(params) {
    return { evid: 9, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postCreatedWithAi' event (evid: 9301)
 *
 * Event description: Post created with AI (chat funnel, etc.)
 *
 * @param {postCreatedWithAiParams} params - The parameters for this event
 * @property {string} post_title - post_title
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} prompt_id - prompt_id
 * @property {string} project_id - project_id
 * @property {GUID} msid - msid
 * @return {LogObject<postCreatedWithAiParams>} LogObject<postCreatedWithAiParams>
 */
export function postCreatedWithAi(params) {
    return { evid: 9301, src: 69, endpoint: '', params };
}
//# sourceMappingURL=index.js.map